/**
 * Dutch (default) — the source of all message keys. Tone: "je", short sentences, verbs first on buttons
 * (UI spec §10.2). Key copy follows the §10.3 table. To be reviewed by a native speaker before beta.
 */
export const nl = {
  /* common */
  'common.active': 'Actief',
  'common.allEntities': 'Alle bedrijven',
  'common.back': 'Terug',
  'common.cancel': 'Annuleren',
  'common.clearFilters': 'Filters wissen',
  'common.close': 'Sluiten',
  'common.copied': 'Gekopieerd',
  'common.copy': 'Kopiëren',
  'common.done': 'Klaar',
  'common.edit': 'Bewerken',
  'common.exclVat': 'excl. btw',
  'common.filterEntity': 'Bedrijf',
  'common.inactive': 'Uit',
  'common.loadMore': 'Meer laden',
  'common.loading': 'Bezig met laden…',
  'common.manage': 'Beheren',
  'common.more': 'Meer',
  'common.next': 'Volgende',
  'common.nextPage': 'Volgende pagina',
  'common.no': 'Nee',
  'common.off': 'Uit',
  'common.on': 'Aan',
  'common.open': 'Openen',
  'common.opensNewTab': '(opent in een nieuw tabblad)',
  'common.optional': 'optioneel',
  'common.or': 'of',
  'common.pageOf': 'Pagina {n} van {total}',
  'common.prevPage': 'Vorige pagina',
  'common.remove': 'Verwijderen',
  'common.retry': 'Opnieuw proberen',
  'common.save': 'Opslaan',
  'common.saved': 'Opgeslagen',
  'common.view': 'Bekijken',
  'common.viewAll': 'Bekijk alles',
  'common.yes': 'Ja',
  'time.yesterday': 'Gisteren',
  'a11y.euroSpoken': '{n} euro',
  'lang.label': 'Taal',

  /* navigation & shell */
  'nav.aria': 'Hoofdmenu',
  'nav.audit': 'Logboek',
  'nav.collapse': 'Menu inklappen',
  'nav.documents': 'Documenten',
  'nav.entities': 'Bedrijven',
  'nav.expand': 'Menu uitklappen',
  'nav.help': 'Hulp',
  'nav.home': 'BTW Kwartier — naar overzicht',
  'nav.mobile': 'Snelmenu',
  'nav.more': 'Meer',
  'nav.openMenu': 'Menu openen',
  'nav.openQuestionsBadge': '{n} open vragen',
  'nav.ops': 'Back office',
  'nav.overview': 'Overzicht',
  'nav.plan': 'Je abonnement',
  'nav.planManage': 'Abonnement beheren',
  'nav.questions': 'Vragen',
  'nav.returns': 'Aangiftes',
  'nav.settings': 'Instellingen',
  'nav.skip': 'Naar de inhoud',
  'nav.transactions': 'Transacties',
  'nav.upload': 'Uploaden',
  'account.logout': 'Uitloggen',
  'account.menu': 'Accountmenu',
  'account.menuFor': 'Accountmenu van {name}',
  'account.profile': 'Profiel',
  'account.switch': 'Wissel van account',
  'account.twofa': 'Tweestapsverificatie',
  'search.hint': 'Zoek op bedrijf, aangifte, factuur, leverancier of bedrag (bijv. 142,50).',
  'search.none': 'Niets gevonden voor “{q}”.',
  'search.open': 'Zoeken',
  'search.placeholder': 'Zoek bedrijven, aangiftes, documenten of vragen…',
  'search.results': 'Zoekresultaten',
  'search.title': 'Zoeken',
  'search.type.entity': 'Bedrijven',
  'search.type.period': 'Aangiftes',
  'search.type.document': 'Documenten',
  'search.type.question': 'Vragen',
  'search.type.transaction': 'Transacties',
  'notif.action': 'Vereist actie',
  'notif.actionEmpty': 'Niets te doen. Goed bezig!',
  'notif.ariaCount': 'Meldingen, {n} vereisen actie',
  'notif.info': 'Ter info',
  'notif.infoEmpty': 'Geen nieuwe berichten.',
  'notif.markAll': 'Alles gelezen',
  'notif.title': 'Meldingen',
  'notif.unread': 'Ongelezen',
  'notif.kind.quarter_started': '{quarter} is afgelopen: tijd om je gegevens aan te vullen',
  'notif.kind.missing_documents': 'Er ontbreken nog {n} documenten',
  'notif.kind.deadline_countdown': 'Nog {days} dagen tot de deadline van {quarter}',
  'notif.kind.overdue': 'De deadline van {quarter} is voorbij',
  'notif.kind.questions_waiting': '{n} vragen wachten op je antwoord',
  'notif.kind.review_done': 'De controle is klaar',
  'notif.kind.kor_threshold': '{count, plural, =100 {Je omzet is over de KOR-grens} other {Je omzet zit op #% van de KOR-grens}}',
  'notif.kind.receipt_missing': 'Upload nog de ontvangstbevestiging',
  'notif.kind.channel_check': 'Regel je inlogmiddel voor het portaal',
  'notif.kind.payment_failed': 'De betaling van je abonnement is mislukt',
  'notif.kind.plan_suspended': 'Je abonnement is gepauzeerd: betaling nodig',
  'notif.kind.advisor_review_done': 'De adviseur heeft je aangifte bekeken',
  'notif.kind.invite': 'Je bent uitgenodigd voor een account',
  'notif.kind.company_check': 'Controleer de bedrijfsgegevens van {entity}',
  'env.staging.text': 'Gebruik alleen voorbeeldgegevens: AI en betalingen zijn gesimuleerd. Upload geen echte klantgegevens.',
  'env.staging.title': 'Testomgeving.',
  'banner.pastDue.action': 'Betaling regelen',
  'banner.pastDue.text': 'Aangiftes die al lopen kun je afronden. Je gegevens blijven bewaard en zijn te exporteren.',
  'banner.pastDue.title': 'De betaling van je abonnement is mislukt',
  'banner.readOnly.text': 'Aangiftes die al lopen kun je nog afronden. Al je gegevens zijn alleen-lezen en blijven exporteerbaar.',
  'banner.readOnly.title': 'Je abonnement is gestopt',
  'banner.twofa.action': 'Nu instellen',
  'banner.twofa.text': 'Zonder tweestapsverificatie kun je een aangifte niet bevestigen. Het instellen duurt ongeveer 2 minuten.',
  'banner.twofa.title': 'Zet tweestapsverificatie aan',
  'notFound.action': 'Naar overzicht',
  'notFound.text': 'Deze pagina bestaat niet (meer). Misschien is de link oud.',
  'notFound.title': 'Pagina niet gevonden',

  /* status, steps, sources (§8.2, §8.4) */
  'status.collecting': 'Verzamelen',
  'status.questions_open': 'Vragen open',
  'status.draft_ready': 'Concept gereed',
  'status.in_review': 'In controle',
  'status.review_differences': 'Verschillen',
  'status.ready_to_file': 'Klaar voor indienen',
  'status.filed': 'Ingediend',
  'status.closed': 'Afgerond',
  'status.out_of_scope': 'Buiten scope',
  'status.not_required': 'Geen aangifte (KOR)',
  'status.late': 'Te laat',
  'next.upload_documents': 'Documenten uploaden',
  'next.answer_questions': 'Vragen beantwoorden',
  'next.view_concept': 'Concept bekijken',
  'next.busy': 'Bezig…',
  'next.view_differences': 'Verschillen bekijken',
  'next.compare_portal': 'Vergelijk met portaal',
  'next.upload_receipt': 'Bevestiging uploaden',
  'next.view_return': 'Bekijk aangifte',
  'next.refer': 'Doorverwijzen',
  'next.refer_long': 'Doorverwijzen naar een boekhouder',
  'next.view_kor': 'Omzet bekijken',
  'step.aria': 'Voortgang van de aangifte',
  'step.gegevens': 'Gegevens',
  'step.vragen': 'Vragen',
  'step.concept': 'Concept',
  'step.controle': 'Controle',
  'step.indienen': 'Indienen',
  'step.bevestiging': 'Bevestiging',
  'step.done.gegevens': 'Compleet',
  'step.done.vragen': 'Beantwoord',
  'step.done.concept': 'Gereed',
  'step.done.controle': 'Geen verschillen',
  'step.done.indienen': 'Ingediend',
  'step.done.bevestiging': 'Afgerond',
  'step.current.gegevens': 'Aanvullen',
  'step.current.vragen': 'Open',
  'step.current.concept': 'Bekijken',
  'step.current.controle': 'In behandeling',
  'step.current.indienen': 'Klaar om te vergelijken',
  'step.current.bevestiging': 'Wacht op bevestiging',
  'step.upcoming': 'Nog te doen',
  'step.upcomingReason': 'Deze stap komt later',
  'step.state.done': 'klaar',
  'step.state.current': 'huidige stap',
  'step.state.upcoming': 'nog niet beschikbaar',
  'step.compact': 'Stap {n} van {total} · {name}',
  'step.reason.vragen': 'Eerst je gegevens aanvullen',
  'step.reason.concept': 'Het concept wordt gemaakt zodra je gegevens compleet zijn',
  'step.reason.controle': 'Bekijk eerst het concept',
  'step.reason.indienen': 'Eerst moet de controle klaar zijn',
  'step.reason.bevestiging': 'Eerst indienen in het portaal',
  'source.ai': 'AI',
  'source.rule': 'Regel',
  'source.user': 'Jij',
  'source.advisor': 'Adviseur',
  'source.system': 'Systeem',
  'source.import': 'Import',
  'source.aiTip': 'Voorgesteld door AI — controleer het zelf',
  'actor.ai': 'BTW Kwartier AI',
  'actor.advisor': 'Adviseur van BTW Kwartier',
  'actor.system': 'Systeem',
  'legalForm.bv': 'B.V.',
  'legalForm.eenmanszaak': 'Eenmanszaak',
  'legalForm.vof': 'V.O.F.',
  'legalForm.other': 'Andere rechtsvorm',
  'role.owner': 'Eigenaar',
  'role.member': 'Lid',
  'role.filer': 'Aangifteverantwoordelijke',
  'role.accountant': 'Boekhouder (alleen lezen)',
  'subscription.trial_check': 'Gratis btw-check',
  'subscription.beta_free': 'Bèta · eerste aangiftekwartaal gratis',
  'subscription.active': 'Actief',
  'subscription.past_due': 'Betaling mislukt',
  'subscription.cancelled': 'Opgezegd',
  'subscription.read_only': 'Alleen-lezen',
  'subscription.pending': 'Eerste betaling open',
  'subscription.suspended': 'Gepauzeerd: betaling nodig',
  'match.unmatched': 'Niet gekoppeld',
  'match.suggested': 'Voorstel',
  'match.matched': 'Gekoppeld',
  'match.not_needed': 'Niet nodig',

  /* amounts & deadlines (§8.3, §5.4) */
  'amount.toPay': 'Te betalen',
  'amount.toReceive': 'Te ontvangen',
  'amount.provisional': 'voorlopig',
  'amount.provisionalHint': 'Voorlopig: er staan nog vragen open, het bedrag kan nog veranderen',
  'amount.final': 'definitief',
  'amount.notComputed': 'Nog niet berekend',
  'deadline.title': 'Volgende deadline',
  'deadline.return': 'Btw-aangifte {quarter}',
  'deadline.lastDay': 'Uiterlijk indienen en betalen',
  'deadline.left': '{n, plural, one {Nog # dag} other {Nog # dagen}}',
  'deadline.today': 'Vandaag',
  'deadline.late': '{n, plural, one {# dag te laat} other {# dagen te laat}}',
  'deadline.weekend': '{nominal} valt op een {weekday}. De deadline schuift niet op: het bedrag moet vóór die dag op de rekening van de Belastingdienst staan, dus uiterlijk {lastWorkingDay}. Je bank heeft enkele werkdagen nodig.',
  'deadline.openEntities': '{n, plural, one {# bedrijf nog niet ingediend} other {# bedrijven nog niet ingediend}}',
  'deadline.noneOpen': 'Alle bedrijven zijn ingediend.',
  'quarter.label': 'Kwartaal',
  'quarter.toFile': 'nu aan de beurt',

  /* overview (§5) */
  'overview.greeting.morning': 'Goedemorgen, {name}',
  'overview.greeting.afternoon': 'Goedemiddag, {name}',
  'overview.greeting.evening': 'Goedenavond, {name}',
  'overview.sub.both': 'Nog {q, plural, one {# vraag} other {# vragen}} en {d, plural, one {# document} other {# documenten}} voor dit kwartaal.',
  'overview.sub.questions': 'Nog {q, plural, one {# vraag} other {# vragen}} voor dit kwartaal.',
  'overview.sub.documents': 'Nog {d, plural, one {# document} other {# documenten}} voor dit kwartaal.',
  'overview.sub.onTrack': 'Alles loopt voor {quarter}. We laten het weten als we iets nodig hebben.',
  'overview.sub.allFiled': 'Alles ingediend voor {quarter}. Goed bezig!',
  'overview.empty.title': 'Voeg je eerste bedrijf toe',
  'overview.empty.text': 'Met je KvK-nummer staat je bedrijf er zo in. Reken op ongeveer 15 minuten voor alle stappen.',
  'overview.empty.action': 'Bedrijf toevoegen',
  'overview.overdue.title': '{entity}: de deadline is {n, plural, one {# dag} other {# dagen}} voorbij',
  'overview.overdue.text': 'De deadline is voorbij. Dien zo snel mogelijk in om een boete te beperken.',
  'overview.overdue.action': 'Naar de aangifte',
  'overview.aiDegraded.title': 'De AI-hulp is tijdelijk beperkt',
  'overview.aiDegraded.text': 'Wat onze regels kunnen berekenen, staat gewoon in je concept. De rest zetten we als vraag voor je klaar.',
  'overview.running.title': '{quarter} loopt nog',
  'overview.running.text': 'Upload tussendoor je facturen en bankafschriften: we koppelen ze per maand, dan blijft er aan het eind van het kwartaal weinig over.',
  'overview.done.title': 'Alles ingediend voor {quarter}',
  'overview.done.time': 'Je was gemiddeld {n} minuten per bedrijf bezig.',
  'overview.done.next': 'De volgende deadline is {date}.',
  'overview.moreInsight': 'Meer inzicht',
  'overview.table.title': 'Alle bedrijven – dit kwartaal',
  'overview.table.entity': 'Bedrijf',
  'overview.table.btwId': 'Btw-id',
  'overview.table.status': 'Status',
  'overview.table.amount': 'Bedrag',
  'overview.table.next': 'Volgende stap',
  'overview.table.rowAria': 'Open de aangifte van {name}',
  'overview.table.filedOn': 'ingediend op {date}',
  'overview.table.closedMore': '+ {n} afgerond',
  'overview.table.hideClosed': 'Afgeronde verbergen',
  'kpi.progress': 'Voortgang',
  'kpi.progressValue': 'van {total} ingediend',
  'kpi.openQuestions': 'Open vragen',
  'kpi.openQuestionsTime': '{n, plural, one {ca. # minuut} other {ca. # minuten}}',
  'kpi.openQuestionsNone': 'Alles beantwoord',
  'kpi.conceptsReady': 'Concept gereed',
  'kpi.conceptsReadyFoot': 'Klaar om te bekijken',
  'kpi.balances': 'Btw dit kwartaal',
  'kpi.balancesFoot': 'Per bedrijf apart te betalen of te ontvangen',
  'kpi.yourTime': 'Jouw tijd',
  'kpi.yourTimeValue': 'min per bedrijf',
  'kpi.yourTimeFoot': 'Alleen je eigen werk',
  'missing.title': 'Ontbrekende documenten',
  'missing.none': 'Er ontbreekt niets. Mooi!',
  'missing.kind.purchase_invoices': 'Inkoopfacturen',
  'missing.kind.sales_invoices': 'Verkoopfacturen',
  'missing.kind.sales_invoices_eu': 'Verkoopfacturen (EU)',
  'missing.kind.bank_statements': 'Bankafschriften',
  'missing.countAria': '{n} ontbrekend',
  'missing.upload': 'Uploaden',
  'missing.noInvoice': 'Geen factuur',
  'missing.noInvoiceHint': 'Geen factuur? Dan trekken we geen btw af (voorzichtige keuze).',
  'chart.title': 'Btw te betalen / te ontvangen',
  'chart.filter': 'Toon bedrijf',
  'chart.allEntities': 'Alle bedrijven',
  'progress.title': 'Voortgang',
  'progress.open': 'Bekijk aangifte',
  'progress.switch': 'Kies bedrijf',
  'progress.note.collecting': 'We wachten op je bankafschriften en facturen.',
  'progress.note.questions_open': 'Er staan nog vragen voor je klaar. Meestal ben je in een paar minuten klaar.',
  'progress.note.draft_ready': 'Het concept staat klaar. Bekijk het en start de controle.',
  'progress.note.in_review': 'Onafhankelijke controle loopt · meestal binnen enkele minuten',
  'progress.note.review_differences': 'De controle zag een paar dingen anders. Kies per punt wat klopt.',
  'progress.note.ready_to_file': 'Klaar! Vergelijk de bedragen met het portaal en dien zelf in.',
  'progress.note.filed': 'Ingediend. Upload nog de ontvangstbevestiging van de Belastingdienst.',
  'progress.note.closed': 'Afgerond en gearchiveerd.',
  'progress.note.out_of_scope': 'Deze aangifte bevat iets wat we nog niet ondersteunen. Een boekhouder kan helpen.',
  'activity.title': 'Recente activiteit',
  'activity.none': 'Nog geen activiteit.',
  'activity.generic': 'Activiteit',
  'activity.question.created': 'Nieuwe vraag',
  'activity.question.answered': 'Vraag beantwoord',
  'activity.question.undone': 'Antwoord ongedaan gemaakt',
  'activity.question.unsure': 'Vraag gemarkeerd als “niet zeker”',
  'activity.document.uploaded': 'Document geüpload',
  'activity.document.extracted': 'Factuur gelezen',
  'activity.document.moved': 'Document verplaatst',
  'activity.document.deleted': 'Document verwijderd',
  'activity.document.updated': 'Document aangepast',
  'activity.import.confirmed': 'Bankafschrift geïmporteerd',
  'activity.match.created': 'Factuur gekoppeld aan betaling',
  'activity.draft.computed': 'Concept berekend',
  'activity.review.started': 'Controle gestart',
  'activity.review.completed': 'Controle afgerond',
  'activity.finding.resolved': 'Verschil opgelost',
  'activity.authorization.created': 'Concept bevestigd',
  'activity.period.filed': 'Aangifte ingediend',
  'activity.period.filing_undone': 'Indiening teruggedraaid',
  'activity.receipt.registered': 'Ontvangstbevestiging geregistreerd',
  'activity.entity.created': 'Bedrijf toegevoegd',
  'activity.entity.updated': 'Bedrijfsgegevens aangepast',
  'activity.rule.created': 'Regel aangemaakt',
  'activity.rule.revoked': 'Regel ingetrokken',
  'activity.member.invited': 'Lid uitgenodigd',
  'activity.member.removed': 'Lid verwijderd',
  'activity.correction.created': 'Correctie vastgelegd',
  'activity.billing.checkout': 'Abonnement gestart',
  'activity.access.granted': 'Adviseur van BTW Kwartier kreeg tijdelijk toegang',
  'activity.account.created': 'Account aangemaakt',
  'activity.advisor_review.completed': 'Adviseurscontrole afgerond',
  'activity.advisor_review.escalated': 'Adviseurscontrole met voorrang opgepakt',
  'activity.advisor_review.ordered': 'Adviseurscontrole besteld',
  'activity.authorization.revoked': 'Bevestiging vervallen: concept gewijzigd',
  'activity.bank_account.added': 'Bankrekening toegevoegd',
  'activity.bank_account.created': 'Bankrekening toegevoegd',
  'activity.bank_account.removed': 'Bankrekening verwijderd',
  'activity.billing.cancelled': 'Abonnement opgezegd',
  'activity.billing.free_check': 'Gratis btw-check gedaan',
  'activity.billing.invoice_created': 'Factuur van BTW Kwartier aangemaakt',
  'activity.billing.invoice_paid': 'Factuur betaald',
  'activity.billing.payment_failed': 'Betaling mislukt',
  'activity.billing.plan_changed': 'Abonnement gewijzigd',
  'activity.billing.read_only': 'Account staat op alleen-lezen',
  'activity.billing.subscribed': 'Abonnement gestart',
  'activity.correction.filed': 'Suppletie ingediend',
  'activity.document.attributed': 'Document aan bedrijf gekoppeld',
  'activity.document.extraction_failed': 'Document kon niet worden gelezen',
  'activity.document.reassigned': 'Document verplaatst',
  'activity.entity.intake_completed': 'Toelatingsvragen ingevuld',
  'activity.entity.previous_return_saved': 'Vorige aangifte vastgelegd',
  'activity.import.created': 'Bankafschrift geüpload',
  'activity.import.mapped': 'Kolommen van bankafschrift ingesteld',
  'activity.match.accepted': 'Factuur gekoppeld aan betaling',
  'activity.match.suggested': 'Mogelijke factuur gevonden',
  'activity.member.joined': 'Lid toegevoegd',
  'activity.member.updated': 'Rol van lid gewijzigd',
  'activity.period.archive_exported': 'Archief gedownload',
  'activity.period.closed': 'Aangifte afgerond',
  'activity.portal.mismatch_reported': 'Verschil met portaal gemeld',
  'activity.question.dismissed': 'Vraag vervallen',
  'activity.question.reopened': 'Vraag opnieuw geopend',
  'activity.referral.created': 'Doorverwezen naar boekhouder',
  'activity.review.failed': 'Controle mislukt',
  'activity.review.finding_resolved': 'Verschil opgelost',
  'activity.ticket.created': 'Vraag aan support gestuurd',
  'activity.transaction.classified': 'Betaling ingedeeld',
  'activity.user.totp_enabled': 'Tweestapsverificatie aangezet',
  'activity.vies.rechecked': 'Btw-nummer opnieuw gecontroleerd',

  /* errors (§9.2) */
  'error.featureDisabled.what': 'Deze functie is nu niet beschikbaar.',
  'error.featureDisabled.todo': 'Twijfel je? Laat een partner-accountant meekijken via het menu Meer.',
  'error.savedNote': 'Wat je al had ingevuld, is bewaard.',
  'error.session.what': 'Je bent uitgelogd.',
  'error.session.todo': 'Log opnieuw in om verder te gaan.',
  'error.session.login': 'Opnieuw inloggen',
  'error.network.what': 'Geen verbinding met BTW Kwartier.',
  'error.network.todo': 'Controleer je internet en probeer het opnieuw.',
  'error.forbidden.what': 'Je hebt hier geen toegang toe.',
  'error.forbidden.todo': 'Vraag de eigenaar van het account om toegang.',
  'error.notFound.what': 'We kunnen dit niet (meer) vinden.',
  'error.notFound.todo': 'Misschien is het verwijderd of verplaatst. Ga terug naar het overzicht.',
  'error.validation.what': 'Er klopt iets niet in wat je invulde.',
  'error.validation.todo': 'Kijk de velden na en probeer het opnieuw.',
  'error.gate.what': 'Dit kan nog niet.',
  'error.gate.todo': 'Rond eerst de open vragen of verschillen af.',
  'error.intake.incomplete': 'Beantwoord eerst alle toelatingsvragen van dit bedrijf (Instellingen → Bedrijven).',
  'error.intake.notEligible': 'Dit bedrijf past niet bij zelf aangifte doen; een partner-accountant kan je helpen.',
  'error.readOnly.what': 'Je account is alleen-lezen.',
  'error.readOnly.todo': 'Je kunt alles nog bekijken en exporteren.',
  'error.payment.what': 'Hiervoor is een actief abonnement nodig.',
  'error.payment.todo': 'Kies een abonnement onder Instellingen.',
  'error.conflict.what': 'Iemand anders heeft dit net aangepast.',
  'error.conflict.todo': 'Vernieuw de pagina en probeer het opnieuw.',
  'error.reauth.what': 'Bevestig eerst dat jij het bent.',
  'error.reauth.todo': 'Vul de code uit je authenticator-app in.',
  'error.generic.what': 'Er ging iets mis aan onze kant.',
  'error.generic.todo': 'Probeer het over een minuut opnieuw. Blijft het misgaan? Neem contact op met support.',

  /* re-authentication */
  'reauth.title': 'Bevestig dat jij het bent',
  'reauth.text': 'Voor deze stap vragen we je code uit je authenticator-app. Daarna kun je 5 minuten verder zonder opnieuw te bevestigen.',
  'reauth.code': 'Code uit je authenticator-app',
  'reauth.codeHint': 'Open je authenticator-app (bijv. Google Authenticator, Microsoft Authenticator of 1Password) en vul de 6 cijfers in die bij BTW Kwartier staan. De code verandert elke 30 seconden.',
  'reauth.confirm': 'Bevestigen',
  'reauth.wrong': 'Deze code klopt niet. Probeer de nieuwste code.',
  'reauth.validUntil': 'Bevestigd tot {time}',
  'reauth.useRecovery': 'Authenticator kwijt? Gebruik een herstelcode',
  'reauth.useAuthenticator': 'Toch de code uit de app gebruiken',
  'reauth.recoveryLabel': 'Herstelcode',
  'reauth.recoveryHint': 'Een van je bewaarde herstelcodes (xxxxx-xxxxx). Elke code werkt één keer.',

  /* questions (§6.2) */
  'q.pageSub': 'Eén vraag tegelijk. Je antwoorden worden direct bewaard.',
  'q.count': 'Vraag {n} van {total}',
  'q.locked': '{name} beantwoordt deze vraag',
  'q.maskedTitle': 'Deze betaling is privé. Alleen de eigenaar ziet de details.',
  'q.thisAmount': 'dit bedrag',
  'q.thisParty': 'deze partij',
  'q.invoice': 'Factuur',
  'q.openInvoice': 'Factuur van {name} vergroten',
  'q.suggestion': 'Voorstel',
  'q.suggestionReason': 'Waarom dit voorstel',
  'q.unsure': 'Ik weet het niet zeker',
  'q.alwaysRule': 'Vanaf nu altijd zo',
  'q.alwaysRuleHint': 'Je kunt deze regel intrekken onder Instellingen → Mijn regels.',
  'q.partial.label': 'Welk deel is zakelijk?',
  'q.partial.save': 'Opslaan: {n}% zakelijk',
  'q.saved': 'Opgeslagen',
  'q.savedRule': 'Opgeslagen · regel aangemaakt',
  'q.undo': 'Ongedaan maken',
  'q.undone': 'Antwoord ongedaan gemaakt',
  'q.prev': 'Vorige',
  'q.skip': 'Later',
  'q.shortcuts': 'Sneltoetsen',
  'q.key.options': 'Kies antwoord 1, 2 of 3',
  'q.key.nav': 'Vorige / volgende vraag',
  'q.allDone': 'Alle vragen beantwoord',
  'q.allDoneText': 'Dank je! We werken je concept bij met je antwoorden.',
  'q.viewConcept': 'Bekijk concept',
  'q.business_or_private.title': 'Is deze betaling van {amount} aan {counterparty} zakelijk?',
  'q.business_or_private.opt.yes': 'Ja, zakelijk',
  'q.business_or_private.opt.no': 'Nee, privé',
  'q.business_or_private.opt.partial': 'Deels zakelijk',
  'q.business_or_private.hint.partial': 'Bijvoorbeeld een telefoon die je ook privé gebruikt',
  'q.which_entity.title': 'Bij welk bedrijf hoort deze factuur van {counterparty}?',
  'q.which_entity.opt.unknown': 'Onbekend bedrijf',
  'q.incoming_payment.title': 'Wat is deze ontvangst van {amount} van {counterparty}?',
  'q.incoming_payment.opt.sale': 'Een verkoop (omzet)',
  'q.incoming_payment.opt.capital_or_loan': 'Eigen geld of een lening',
  'q.incoming_payment.opt.refund': 'Een terugbetaling',
  'q.foreign_service.title': 'Wat heb je gekocht bij {counterparty} in het buitenland?',
  'q.foreign_service.opt.eu_service': 'Een dienst uit een ander EU-land, zonder btw op de factuur',
  'q.foreign_service.opt.noneu_service': 'Een dienst van buiten de EU, zonder btw op de factuur',
  'q.foreign_service.opt.not_business': 'Nee, niet zakelijk',
  'q.noneu_sale_confirm.title': 'Je factuur aan {counterparty} buiten de EU heeft geen btw. Wat heb je geleverd?',
  'q.noneu_sale_confirm.opt.confirm': 'Een dienst aan een bedrijf (hoort niet in je Nederlandse aangifte)',
  'q.noneu_sale_confirm.opt.other': 'Nee, het is iets anders',
  'q.which_invoice.title': 'Welke factuur hoort bij deze betaling van {amount} aan {counterparty}?',
  'q.which_invoice.opt.doc': '{supplier} · {amount} · {date}',
  'q.which_invoice.opt.none': 'Er is geen factuur',
  'q.which_invoice.hint.none': 'Dan trekken we geen btw af voor deze betaling',
  'q.invalid_vat_number.title': 'Het btw-nummer van {counterparty} is niet geldig volgens de EU-controle. Wat wil je doen?',
  'q.invalid_vat_number.opt.recheck': 'Ik vraag het juiste nummer op',
  'q.invalid_vat_number.opt.treat_domestic': 'Reken Nederlandse btw',
  'q.confirm_amounts.title': 'We konden de factuur van {counterparty} niet goed lezen. Klopt {amount}?',
  'q.confirm_amounts.opt.confirm': 'Ja, dat klopt',
  'q.confirm_amounts.opt.edit': 'Nee, ik pas het aan',
  'q.foreign_currency.title': 'De factuur van {counterparty} is in {currency} ({foreignAmount}). Wat is het totaal in euro?',
  'q.foreign_currency.opt.eur_total': 'Totaal in euro invullen',
  'q.foreign_currency.hint.eur_total': 'Zonder eurobedrag telt deze factuur nog niet mee in je aangifte.',
  'q.foreign_currency.label': 'Totaal van de factuur in euro (incl. btw)',
  'q.foreign_currency.help': 'Staat er een eurobedrag op de factuur, gebruik dat. Anders reken je om met de koers op de factuurdatum (ECB), of neem je het bedrag dat op je bankrekening is af- of bijgeschreven.',
  'q.foreign_currency.fromBank': 'Je bank boekte {amount} voor deze factuur.',
  'q.foreign_currency.save': 'Opslaan: {amount}',
  'q.foreign_currency.saveEmpty': 'Opslaan',
  'q.suspicious_document.title': 'Dit document bevat tekst die op instructies lijkt. Wil je het gebruiken?',
  'q.suspicious_document.opt.ignore': 'Nee, negeren',
  'q.suspicious_document.opt.use': 'Ja, het is een gewone factuur',
  'q.review_difference.title': 'De controle ziet het anders. Welke klopt?',
  'q.review_difference.opt.draft': 'Zoals in het concept',
  'q.review_difference.opt.review': 'Zoals de controle',
  'review.finding.unreadable': 'De controle kon dit document niet volledig lezen',
  'review.finding.review_suspicious': 'De controle vertrouwt dit document niet',
  'review.suspicious.text': 'De controle zag tekst die op instructies of een aangepast document lijkt. In het concept staat {amount}. Bekijk het origineel: klopt het?',
  'q.review_suspicious.title': 'De controle vertrouwt de factuur van {counterparty} niet. Klopt het concept?',
  'review.finding.net_differs': 'Bedrag zonder btw verschilt',
  'review.finding.vat_differs': 'Btw-bedrag verschilt',
  'review.finding.total_differs': 'Totaalbedrag verschilt',
  'review.finding.rate_differs': 'Btw-tarief verschilt',
  'review.finding.date_differs': 'Factuurdatum verschilt',
  'review.finding.reverse_charge_differs': 'Btw verlegd of niet',
  'review.finding.duplicate_invoice': 'Factuur lijkt dubbel te tellen',
  'review.finding.duplicate_payment': 'Betaling lijkt dubbel te tellen',
  'review.finding.rounding_differs': 'Afronding van een vak verschilt',
  'review.unreadable.text': 'In het concept staat {amount}. Bekijk het origineel: klopt dat bedrag?',
  'review.unreadable.keep': 'Ik heb het origineel bekeken: het concept klopt',
  'review.unreadable.retry': 'Opnieuw laten controleren',
  'q.review_unreadable.title': 'De controle kon de factuur van {counterparty} niet lezen. Klopt het concept?',
  'q.review_unreadable.opt.draft': 'Ik heb het origineel bekeken: het klopt',
  'q.review_unreadable.opt.review': 'Opnieuw laten controleren',
  'q.foreign_service.opt.goods': 'Goederen (spullen die zijn verstuurd of ingevoerd)',
  'q.foreign_service.opt.local_vat': 'De leverancier heeft al buitenlandse btw gerekend',
  'q.foreign_service.hint.goods': 'Uit een ander EU-land: je rekent de btw zelf aan en trekt die meteen weer af. Van buiten de EU: de invoer-btw staat op de papieren van de douane of de vervoerder; upload die ook.',
  'q.foreign_service.hint.local_vat': 'Bijvoorbeeld een hotel of taxi in het buitenland. Die btw hoort niet in je Nederlandse aangifte; terugvragen gaat via dat land.',
  'q.noneu_sale_confirm.opt.goods': 'Goederen die naar het buitenland gaan (uitvoer)',
  'q.noneu_sale_confirm.opt.private_customer': 'Een dienst aan een particulier',
  'q.noneu_sale_confirm.hint.goods': 'Uitvoer is 0% btw als je een uitvoerbewijs hebt. Daar vragen we hierna naar.',
  'q.noneu_sale_confirm.hint.private_customer': 'Voor particulieren geldt meestal Nederlandse btw. We rekenen voorzichtig 21%; een adviseur kan bepalen of dat lager mag.',
  'q.eu_sale_kind.title': 'Je factuur aan {counterparty} in de EU heeft geen btw en geen btw-nummer van de klant. Wat heb je geleverd?',
  'q.eu_sale_kind.opt.business_service': 'Een dienst aan een bedrijf',
  'q.eu_sale_kind.opt.goods': 'Goederen die naar een ander EU-land gaan',
  'q.eu_sale_kind.opt.private_customer': 'Iets voor een particulier',
  'q.eu_sale_kind.hint.business_service': 'Dan heb je het btw-nummer van de klant nodig; dat vragen we hierna.',
  'q.eu_sale_kind.hint.goods': 'Aan een bedrijf met een geldig btw-nummer is dat 0% en komt het op je ICP-opgaaf. We vragen hierna naar het btw-nummer en het bewijs van vervoer.',
  'q.eu_sale_kind.hint.private_customer': 'Verkoop aan particulieren in andere EU-landen kan onder de OSS-regeling vallen. Dat valt buiten BTW Kwartier.',
  'q.import_document.title': 'Gaat dit document van {counterparty} over de invoer van goederen van buiten de EU?',
  'q.import_document.opt.vat_paid': 'Ja, de invoer-btw is betaald (aan de douane of via de vervoerder)',
  'q.import_document.opt.deferred_21': 'Ja, met artikel 23 (btw verlegd naar de aangifte), tarief 21%',
  'q.import_document.opt.deferred_9': 'Ja, met artikel 23 (btw verlegd naar de aangifte), tarief 9%',
  'q.import_document.opt.not_import': 'Nee, het gaat niet over invoer',
  'q.import_document.hint.vat_paid': 'Vul hierna het bedrag aan invoer-btw van het document in. Dat trek je af als voorbelasting.',
  'q.import_document.hint.deferred_21': 'Met een artikel 23-vergunning betaal je niet aan de grens: je geeft de btw aan in rubriek 4a en trekt hem meteen weer af. Vul hierna de waarde van de goederen in.',
  'q.import_document.hint.deferred_9': 'Voor goederen met het verlaagde tarief, zoals voedingsmiddelen en boeken. Vul hierna de waarde van de goederen in.',
  'q.import_document.hint.not_import': 'Dan behandelen we het als een gewone inkoopfactuur.',
  'q.import_document.amountPaid': 'Bedrag aan invoer-btw',
  'q.import_document.amountBase': 'Waarde van de goederen (waarover de btw wordt berekend)',
  'q.import_document.helpPaid': 'Staat op het document als “btw”, “invoer-btw” of “import VAT”. Niet de inklaringskosten zelf.',
  'q.import_document.helpBase': 'De douanewaarde plus vracht en invoerrechten; staat op de aangifte ten invoer.',
  'q.import_document.fromLine': 'Gevonden op het document: {amount}',
  'q.goods_rate.title': 'Welk Nederlands btw-tarief hoort bij de goederen die je kocht bij {counterparty} in de EU?',
  'q.goods_rate.opt.rate_21': 'Het algemene tarief (21%)',
  'q.goods_rate.opt.rate_9': 'Het verlaagde tarief (9%)',
  'q.goods_rate.hint.rate_21': 'Voor de meeste goederen. Je rekent de btw zelf aan (rubriek 4b) en trekt die meteen weer af.',
  'q.goods_rate.hint.rate_9': 'Bijvoorbeeld voedingsmiddelen, boeken of geneesmiddelen.',
  'q.export_proof.title': 'Je verkocht goederen aan {counterparty} buiten de EU zonder btw. Heb je een uitvoerbewijs?',
  'q.export_proof.opt.yes': 'Ja, ik heb een uitvoerbewijs',
  'q.export_proof.opt.no': 'Nee, of ik weet het niet',
  'q.export_proof.hint.yes': 'Bijvoorbeeld de uitvoeraangifte of de exportpapieren van de vervoerder. Dan is het 0% (rubriek 3a); bewaar het bewijs.',
  'q.export_proof.hint.no': 'Zonder bewijs rekenen we voorzichtig 21% Nederlandse btw. Krijg je het bewijs later, pas dan je antwoord aan.',
  'q.eu_goods_proof.title': 'Je verkocht goederen zonder btw aan {counterparty} in een ander EU-land. Kun je aantonen dat ze naar dat land zijn vervoerd?',
  'q.eu_goods_proof.opt.yes': 'Ja, ik heb bewijs van het vervoer',
  'q.eu_goods_proof.opt.no': 'Nee, of ik weet het niet',
  'q.eu_goods_proof.hint.yes': 'Bijvoorbeeld een vrachtbrief (CMR) of een ontvangstbevestiging van de klant. Dan is het 0% (rubriek 3b) en komt het op je ICP-opgaaf.',
  'q.eu_goods_proof.hint.no': 'Zonder bewijs rekenen we voorzichtig 21% Nederlandse btw. Krijg je het bewijs later, pas dan je antwoord aan.',
  'q.kor_receipt.title': 'Is deze ontvangst van {amount} van {counterparty} omzet?',
  'q.kor_receipt.opt.turnover': 'Ja, het is omzet',
  'q.kor_receipt.opt.paid_invoice': 'Het is de betaling van een verkoopfactuur die al in BTW Kwartier staat',
  'q.kor_receipt.opt.not_turnover': 'Nee, telt niet mee (lening, eigen geld, terugbetaling, of een dienst aan een bedrijf in het buitenland)',
  'q.kor_receipt.hint.turnover': 'Telt mee voor de KOR-grens.',
  'q.kor_receipt.hint.paid_invoice': 'De factuur telt al mee; de betaling tellen we niet nog een keer.',
  'q.kor_receipt.hint.not_turnover': 'Telt niet mee voor de KOR-grens.',
  'q.zero_vat_sale.title': 'Je factuur van {amount} aan {counterparty} heeft geen btw. Waarom niet?',
  'q.zero_vat_sale.opt.reverse_charged': 'De btw is verlegd naar de klant (dat staat op de factuur)',
  'q.zero_vat_sale.opt.exempt': 'Het is vrijgestelde omzet (bijv. zorg, onderwijs)',
  'q.zero_vat_sale.opt.vat_missing': 'Er had btw op moeten staan',
  'q.zero_vat_sale.hint.reverse_charged': 'Alleen in bijzondere gevallen, zoals onderaanneming in de bouw. De factuur noemt “btw verlegd” en het btw-nummer van de klant.',
  'q.zero_vat_sale.hint.exempt': 'Met vrijgestelde omzet mag je btw maar gedeeltelijk aftrekken. Dat valt buiten BTW Kwartier.',
  'q.zero_vat_sale.hint.vat_missing': 'We rekenen 21% btw over het bedrag. Stuur de klant een gecorrigeerde factuur.',
  'q.horeca_purchase.title': 'Is de factuur van {counterparty} voor eten of drinken?',
  'q.horeca_purchase.opt.food_drink': 'Ja, eten of drinken in een restaurant, café of lunchroom',
  'q.horeca_purchase.opt.other': 'Nee, iets anders (bijv. zaalhuur, overnachting, catering op kantoor)',
  'q.horeca_purchase.hint.food_drink': 'Btw op eten en drinken in de horeca mag je niet aftrekken, ook niet bij een zakelijke lunch. De kosten zelf blijven zakelijk.',
  'q.horeca_purchase.hint.other': 'Dan trekken we de btw gewoon af.',
  'q.bua_purchase.title': 'Is de aankoop bij {counterparty} een geschenk of iets voor je personeel?',
  'q.bua_purchase.opt.within_limit': 'Ja, en per ontvanger dit jaar niet meer dan €227 (zonder btw)',
  'q.bua_purchase.opt.above_limit': 'Ja, en per ontvanger meer dan €227 dit jaar',
  'q.bua_purchase.opt.not_gift': 'Nee, het is voor het bedrijf zelf',
  'q.bua_purchase.hint.within_limit': 'Tot €227 per ontvanger per jaar mag je de btw aftrekken.',
  'q.bua_purchase.hint.above_limit': 'Boven €227 per ontvanger per jaar mag je de btw niet aftrekken.',
  'q.real_estate_check.title': 'Gaat de factuur van {counterparty} over de aankoop of bouw van een pand of grond?',
  'q.real_estate_check.opt.yes': 'Ja',
  'q.real_estate_check.opt.no': 'Nee',
  'q.real_estate_check.hint.yes': 'Btw bij vastgoed heeft eigen regels (zoals herziening over 10 jaar). Dat valt buiten BTW Kwartier; we verwijzen je naar een boekhouder.',
  'q.incoming_payment.hint.sale_with_vat': 'Het tarief bepalen wij: 21%, of 9% als al je facturen 9% zijn. Heb je een factuur? Upload die, dan gebruiken we die.',
  'q.incoming_payment.hint.sale_reverse_charged': 'Alleen als de factuur “btw verlegd” en het btw-nummer van de klant noemt.',
  'q.incoming_payment.hint.sale_exempt': 'Vrijgestelde omzet valt buiten BTW Kwartier; we verwijzen je naar een boekhouder.',
  'unsure.title': 'Niet zeker? Kies wat je wilt doen',
  'unsure.text': 'Elke keuze is goed. Je ziet hieronder wat het met je bedrag doet.',
  'unsure.accountant.title': 'Op de lijst voor je boekhouder',
  'unsure.accountant.effect': 'De vraag blijft openstaan en je concept blijft voorlopig tot je het antwoord hebt. Je kunt de lijst exporteren.',
  'unsure.accountant.action': 'Op de lijst zetten',
  'unsure.accountant.done': 'Op de lijst voor je boekhouder gezet',
  'unsure.accountant.export': 'Lijst exporteren (CSV)',
  'unsure.conservative.title': 'Voorzichtig verwerken',
  'unsure.conservative.effect': 'We trekken geen btw af voor deze post. Je betaalt misschien iets meer, maar het klopt altijd. In het concept staat het als “Voorzichtig behandeld”.',
  'unsure.conservative.action': 'Voorzichtig verwerken',
  'unsure.conservative.done': 'Voorzichtig verwerkt',
  'unsure.advisor.title': 'Laat een adviseur van BTW Kwartier meekijken',
  'unsure.advisor.effect': 'Een adviseur beantwoordt de vraag vóór je indient (€ 69 excl. btw per bedrijf). Je bedrag kan daarna nog veranderen.',
  'unsure.advisor.action': 'Adviseur vragen',
  'unsure.advisor.done': 'Gevraagd aan een adviseur',
  'unsure.partner.title': 'Laat een partner-accountant meekijken',
  'unsure.partner.effect': 'We vragen een accountant waarmee we samenwerken om contact met je op te nemen; je ziet eerst wat we delen. Het tarief spreek je met het kantoor af. Tot dan staat de vraag op je lijst en blijft je concept voorlopig.',
  'unsure.partner.action': 'Accountant vragen',
  'unsure.partner.done': 'Doorgestuurd naar een partner-accountant',

  /* period list & workplace (§6.1) */
  'periods.sub': 'Alle aangiftes voor {quarter}, de meest dringende bovenaan.',
  'periods.filterStatus': 'Status',
  'periods.allStatuses': 'Alle statussen',
  'periods.empty': 'Nog geen aangiftes',
  'periods.emptyText': 'Voeg een bedrijf toe; dan maken we per kwartaal een aangifte voor je klaar.',
  'periods.emptyFiltered': 'Geen aangiftes met deze status',
  'workplace.switchEntity': 'Wissel van bedrijf',
  'workplace.deadline': 'Deadline',
  'workplace.asideAria': 'Poorten en wat er nog ontbreekt',
  'workplace.menu.archive': 'Download archief (zip)',
  'workplace.menu.workpaper': 'Werkpapier voor je boekhouder (CSV)',
  'workplace.menu.recompute': 'Opnieuw berekenen',
  'workplace.menu.refer': 'Doorverwijzen naar een boekhouder',
  'workplace.menu.advisor': 'Controle door een adviseur',
  'workplace.menu.advisorPrice': '{price} excl. btw per bedrijf',
  'workplace.recomputed': 'Concept opnieuw berekend',
  'workplace.readOnly.title': 'Alleen-lezen',
  'workplace.readOnly.text': 'Je kunt deze aangifte bekijken en exporteren, maar niet meer wijzigen.',
  'workplace.readOnly.short': 'Je account is alleen-lezen',
  'gate.title': 'Poorten',
  'gate.passed': 'Gehaald',
  'gate.notPassed': 'Nog niet gehaald',
  'gate.1.ok': 'Poort 1: alle vragen beantwoord',
  'gate.1.blocked': 'Poort 1: nog {n, plural, one {# vraag} other {# vragen}} open',
  'gate.1.fix': 'Beantwoorden',
  'gate.1.short': 'Beantwoord eerst nog {n, plural, one {# vraag} other {# vragen}}',
  'gate.2.ok': 'Poort 2: controle zonder verschillen',
  'gate.2.blocked': 'Poort 2: nog {n, plural, one {# verschil} other {# verschillen}} te bekijken',
  'gate.2.fix': 'Bekijken',
  'gate.2.start': 'Controle starten',
  'gate.2.short': 'Bekijk eerst nog {n, plural, one {# verschil} other {# verschillen}}',
  'gate.2.running': 'Poort 2: controle loopt',
  'gate.2.none': 'Poort 2: controle nog niet gestart',
  'gate.2.stale': 'Poort 2: concept gewijzigd, controle opnieuw nodig',
  'gate.2.failed': 'Poort 2: controle mislukt, start opnieuw',
  'checklist.title': 'Wat ontbreekt nog',
  'checklist.complete': 'Alles compleet',
  'checklist.missing_invoice': '{n, plural, one {# factuur ontbreekt} other {# facturen ontbreken}}',
  'checklist.open_question': '{n, plural, one {# vraag open} other {# vragen open}}',
  'checklist.open_difference': '{n, plural, one {# verschil te bekijken} other {# verschillen te bekijken}}',
  'checklist.bank_coverage': '{n, plural, one {# rekening niet compleet} other {# rekeningen niet compleet}}',
  'checklist.receipt': 'Ontvangstbevestiging uploaden',
  'checklist.channel': 'Inlogmiddel voor het portaal regelen',
  'checklist.correction': '{n, plural, one {# correctie (suppletie)} other {# correcties (suppletie)}}',
  /* Q4 year-end check (TS-06) */
  'yearEnd.title': 'Laatste aangifte van het jaar: drie vragen',
  'yearEnd.text': 'In de laatste aangifte van het jaar horen een paar jaarcorrecties die BTW Kwartier nog niet berekent. Beantwoord eerst deze drie vragen; daarna kun je bevestigen.',
  'yearEnd.q.companyCarPrivate': 'Rijdt iemand privé in een auto van de zaak?',
  'yearEnd.h.companyCarPrivate': 'Ook woon-werkverkeer telt als privé. Hiervoor betaal je meestal 2,7% of 1,5% van de cataloguswaarde aan btw (rubriek 1d).',
  'yearEnd.q.giftsOverThreshold': 'Gaf je dit jaar personeelsvoorzieningen, giften of relatiegeschenken van meer dan € 227 per persoon?',
  'yearEnd.h.giftsOverThreshold': 'Bijvoorbeeld kerstpakketten, personeelsuitjes of cadeaus aan klanten. Boven het drempelbedrag moet je de afgetrokken btw corrigeren.',
  'yearEnd.q.privateUse': 'Gebruikte je goederen of diensten van de zaak privé, waarvan je de btw hebt afgetrokken?',
  'yearEnd.h.privateUse': 'Bijvoorbeeld een laptop of telefoon die je ook privé gebruikt, of spullen uit de zaak voor jezelf.',
  'yearEnd.item.companyCarPrivate': 'privégebruik auto van de zaak',
  'yearEnd.item.giftsOverThreshold': 'personeelsvoorzieningen en relatiegeschenken boven € 227',
  'yearEnd.item.privateUse': 'privégebruik van goederen of diensten',
  'yearEnd.save': 'Antwoorden opslaan',
  'yearEnd.saved': 'Antwoorden opgeslagen',
  'yearEnd.answerAll': 'Beantwoord alle drie de vragen.',
  'yearEnd.blocked.title': 'Deze jaarcorrectie kunnen we nog niet voor je maken',
  'yearEnd.blocked.text': 'Je hebt ja geantwoord bij: {items}. Een partner-accountant kan de correctie berekenen. Klopt je antwoord niet? Pas het hieronder aan.',
  'yearEnd.referral': 'Jaarcorrecties in de laatste aangifte van het jaar (auto van de zaak, relatiegeschenken of privégebruik).',
  'gate.yearEnd.ok': 'Jaarvragen beantwoord',
  'gate.yearEnd.blocked': 'Beantwoord eerst de drie jaarvragen hierboven',
  'scope.title': 'Deze aangifte kunnen we niet voor je afmaken',
  'lang.current': 'Taal: {lang}',
  'mode.label': 'App of back office',
  'mode.app': 'App',
  'mode.ops': 'Back office',
  'mode.toApp': 'Naar de app',
  'scope.intakeText': 'Op basis van je antwoorden over het bedrijf valt het buiten wat BTW Kwartier nu ondersteunt: {reasons}. Klopt een antwoord niet? Pas je antwoorden aan. Anders helpt een boekhouder je verder.',
  'scope.textGeneric': 'Er zit iets in wat de eerste versie van BTW Kwartier nog niet ondersteunt. Een boekhouder kan je hiermee helpen; je gegevens kun je meenemen.',
  'home.amount.outOfScopeIntake': 'Op basis van je antwoorden over het bedrijf valt het buiten wat BTW Kwartier nu ondersteunt. Klopt een antwoord niet? Pas het aan.',
  'scope.text': 'Er zit iets in wat de eerste versie van BTW Kwartier nog niet ondersteunt: {reasons}. Een boekhouder kan je hiermee helpen; je gegevens kun je meenemen.',
  'scope.short': 'Buiten wat we nu ondersteunen',
  'scope.authHidden': 'Bevestigen en vergelijken met het portaal is niet mogelijk zolang er iets buiten scope in zit. Verwijs door naar een boekhouder via het menu Meer.',
  'correction.next.title': 'Kleine correctie: gaat mee in de volgende aangifte',
  'correction.next.fromHere': 'Een verschil van {amount} wordt meegenomen in de aangifte van {target}.',
  'correction.next.intoHere': 'Deze aangifte bevat een correctie van {amount} uit {origin}.',
  'correction.nextQuarter': 'het volgende kwartaal',
  'correction.suppletie.title': 'Suppletie nodig voor {origin}',
  'correction.suppletie.text': 'Het verschil is {amount}, meer dan € 1.000. Dien vóór {deadline} een suppletie in via het portaal.',
  'correction.suppletie.markFiled': 'Ik heb de suppletie ingediend',
  'correction.suppletie.marked': 'Suppletie gemarkeerd als ingediend',
  'correction.suppletie.filed': 'De suppletie is ingediend.',
  'advisor.confirmTitle': 'Controle door een adviseur bestellen?',
  'advisor.confirmText': 'Een adviseur van BTW Kwartier bekijkt je concept en beantwoordt je open vragen, uiterlijk 3 dagen vóór de deadline. Je dient daarna zelf in.',
  'advisor.confirmAction': 'Bestellen voor {price}',
  'advisor.ordered': 'Besteld. Je hoort het zodra de adviseur klaar is.',
  'advisor.dueBy': 'Uiterlijk klaar op {date}.',
  'advisor.status.ordered': 'Adviseur ingepland',
  'advisor.status.in_progress': 'Adviseur kijkt mee',
  'advisor.status.done': 'Adviseur is klaar',
  'referral.title': 'Een partner-accountant vragen',
  'referral.text': 'We vragen een accountant waarmee we samenwerken om contact met je op te nemen. Het tarief spreek je rechtstreeks met het kantoor af; BTW Kwartier rekent hiervoor niets.',
  'referral.reason': 'Waar wil je hulp bij?',
  'referral.send': 'Delen en doorverwijzen',
  'referral.doneWith': 'Je bent doorverwezen naar {name}',
  'referral.doneWithText': 'Je kunt ze ook zelf bereiken. Je krijgt een bevestiging per e-mail.',
  'referral.doneNoMatch': 'Je verzoek is verstuurd',
  'referral.doneNoMatchText': 'We zoeken een passende accountant en nemen contact met je op. Je krijgt een bevestiging per e-mail.',

  /* step: gegevens */
  'gegevens.bank.title': 'Bankafschriften',
  'gegevens.bank.period': 'We hebben afschriften nodig van {start} tot en met {end}.',
  'gegevens.bank.none': 'Nog geen bankrekeningen. Voeg er een toe of importeer een afschrift.',
  'gegevens.bank.coverage': 'Geïmporteerd van {from} t/m {to}',
  'gegevens.bank.noImport': 'Nog niets geïmporteerd',
  'gegevens.bank.gap': 'Ontbreekt: {from} – {to}',
  'gegevens.bank.complete': 'Compleet',
  'gegevens.bank.incomplete': 'Niet compleet',
  'gegevens.bank.import': 'Bankafschrift importeren',
  'gegevens.bank.importMore': 'Nog een afschrift importeren',
  'gegevens.bank.importThis': 'Importeren',
  'gegevens.invoices.title': 'Facturen',
  'gegevens.invoices.missing': 'Bij {n, plural, one {# betaling} other {# betalingen}} vonden we nog geen factuur. Upload ze hier of stuur ze door naar je eigen adres.',
  'gegevens.invoices.complete': 'Bij alle betalingen hebben we een factuur gevonden.',
  'gegevens.invoices.view': 'Bekijk {n} betalingen',
  'gegevens.next': 'Verder naar vragen',

  /* step: concept (§6.3) */
  'concept.none.title': 'Nog geen concept',
  'concept.none.text': 'Zodra je bankafschriften compleet zijn, rekenen we het concept voor je uit.',
  'concept.provisionalBanner': 'Voorlopig — nog {n, plural, one {# vraag} other {# vragen}} open',
  'concept.provisionalText': 'Je ziet al een voorlopig concept. Na je antwoorden wordt het definitief en kun je de controle starten.',
  'concept.heroSub': 'Concept {quarter}',
  'concept.layer.label': 'Weergave',
  'concept.layer.simple': 'Eenvoudig',
  'concept.layer.boxes': 'Rubrieken',
  'concept.layer.portal': 'Portaal',
  'concept.simple.sales_21': 'Je verkocht voor {turnover} met 21% btw. Daarover betaal je {vat}.',
  'concept.simple.sales_9': 'Je verkocht voor {turnover} met 9% btw. Daarover betaal je {vat}.',
  'concept.simple.sales_0': 'Voor {turnover} aan verkopen rekende je geen btw (0% of btw verlegd).',
  'concept.simple.sales_export': 'Je voerde voor {turnover} aan goederen uit naar landen buiten de EU. Daarover reken je 0% btw; bewaar het uitvoerbewijs.',
  'concept.simple.sales_eu': 'Je leverde voor {turnover} aan diensten of goederen aan bedrijven in andere EU-landen. Daar betaal je hier geen btw over; het komt ook op je ICP-opgaaf.',
  'concept.simple.purchases': 'Op je zakelijke aankopen betaalde je {vat} btw. Die krijg je terug (voorbelasting).',
  'concept.simple.foreign_services': 'Je kocht voor {turnover} aan diensten of goederen in het buitenland (of je voerde goederen in met artikel 23). Je rekent daarover zelf {vat} btw en trekt die meteen weer af.',
  'concept.simple.private_use': 'Voor privégebruik tel je {vat} btw bij.',
  'concept.simple.corrections': 'Correcties uit een eerder kwartaal: {vat}.',
  'concept.simple.excluded': '{count, plural, one {# post telt} other {# posten tellen}} niet mee: privé, loon, bankkosten of overboekingen tussen je eigen rekeningen.',
  'concept.simple.zero': 'Geen omzet en geen kosten met btw dit kwartaal. Je dient dan een nulaangifte in.',
  'concept.items': '{n, plural, one {# post} other {# posten}}',
  'concept.col.box': 'Rubriek',
  'concept.col.name': 'Omschrijving',
  'concept.col.officialName': 'Officiële naam',
  'concept.col.turnover': 'Omzet',
  'concept.col.vat': 'Btw',
  'concept.col.turnoverEuro': 'Omzet (hele €)',
  'concept.col.vatEuro': 'Btw (hele €)',
  'concept.drillAria': 'Bekijk waar rubriek {box} uit bestaat',
  'concept.portalComputes': 'Berekent het portaal zelf',
  'concept.roundingNote': 'In het portaal vul je hele euro’s in: omzet en te betalen btw ronden we naar beneden af, voorbelasting naar boven — in jouw voordeel.',
  'concept.flag.conservative': 'Voorzichtig behandeld',
  'concept.flag.conservativeTitle': '{n, plural, one {# post voorzichtig behandeld} other {# posten voorzichtig behandeld}}',
  'concept.flag.conservativeText': 'Hiervoor trekken we geen btw af, bijvoorbeeld omdat er geen factuur is. Upload alsnog een factuur om dat te herstellen.',
  'concept.flag.blocked': 'Buiten scope',
  'concept.icp.title': 'ICP-opgaaf nodig',
  'concept.icp.text': 'Je leverde diensten of goederen aan bedrijven in andere EU-landen. We maken de ICP-opgaaf voor je klaar; die dien je ook in het portaal in.',
  'concept.footer': 'Regels {rules} · concept #{version} · {at}',
  'concept.startReview': 'Start controle',
  'concept.toReview': 'Naar de controle',
  'drill.empty': 'Hier zitten geen posten in.',
  'drill.summary': '{n, plural, one {# post} other {# posten}}',
  'drill.vatTotal': 'btw samen',
  'drill.vat': 'btw',
  'drill.share': '{n}% zakelijk',
  'drill.openDoc': 'Factuur',
  'drill.noDoc': 'Geen factuur',

  /* step: controle (§6.4) */
  'review.intro.title': 'Onafhankelijke controle',
  'review.intro.text': 'Een tweede, onafhankelijk AI-model rekent je aangifte opnieuw na vanaf de bron. Waar het iets anders ziet, beslis jij.',
  'review.retry': 'Controle opnieuw starten',
  'review.running.title': 'Onafhankelijke controle loopt',
  'review.running.text': 'Dit duurt meestal binnen enkele minuten.',
  'review.running.leave': 'Je kunt deze pagina verlaten; je krijgt een melding als het klaar is.',
  'review.running.started': 'Gestart om {time}',
  'review.passed.title': 'Geen verschillen gevonden',
  'review.passed.text': 'De controle komt op dezelfde bedragen uit als concept #{version}.',
  'review.toFile': 'Naar indienen',
  'review.diff.title': '{n, plural, one {# verschil om te bekijken} other {# verschillen om te bekijken}}',
  'review.diff.text': 'Kies per punt welke aanpak klopt. Je hoeft niets uit te leggen.',
  'review.auto': '{n, plural, one {# verschil automatisch opgelost} other {# verschillen automatisch opgelost}} — bekijk',
  'review.autoKept': 'opgelost met: {value}',
  'review.autoNoDetail': 'Opgelost met de regels en je documenten.',
  'review.memberOnly': 'Alleen de eigenaar kan verschillen oplossen. Je kunt ze wel bekijken.',
  'review.resolved': 'Keuze opgeslagen',
  'review.resolvedTitle': '{n, plural, one {# verschil opgelost} other {# verschillen opgelost}}',
  'review.impact': 'Effect',
  'review.choice.draft': 'Concept',
  'review.choice.review': 'Controle',
  'review.keepDraft': 'Concept klopt',
  'review.takeReview': 'Controle klopt',
  'review.evidence': 'Bekijk het document',
  'review.stale.title': 'Het concept is gewijzigd',
  'review.stale.text': 'Na een wijziging moet de controle opnieuw. Dat gaat meestal snel.',
  'review.failed.title': 'De controle is niet gelukt',
  'review.failed.text': 'Er ging iets mis bij het controleren. Je gegevens zijn veilig; start de controle opnieuw.',

  /* step: indienen (§6.5) */
  'auth.title': 'Bevestig je aangifte',
  'auth.stepA': 'Stap A van 2',
  'auth.stepB': 'Stap B van 2',
  'auth.line': 'Concept #{version} · bevestigd door {name} · {at}',
  'auth.invalid': 'Het concept is daarna gewijzigd. Bevestig opnieuw.',
  'auth.prereqs': 'Voorwaarden',
  'auth.twofaOn': 'Tweestapsverificatie staat aan',
  'auth.twofaOff': 'Tweestapsverificatie staat uit',
  'auth.twofaFix': 'Instellen',
  'auth.roleOk': 'Je mag deze aangifte bevestigen',
  'auth.roleNo': 'Alleen de eigenaar mag bevestigen',
  'auth.confirmLegend': 'Ik bevestig voor concept #{version}:',
  'auth.check.0': 'Mijn gegevens zijn volledig en kloppen.',
  'auth.check.1': 'Ik dien de aangifte zelf in via Mijn Belastingdienst Zakelijk.',
  'auth.check.2': 'Ik heb het concept bekeken.',
  'auth.submit': 'Bevestigen met tweestapsverificatie',
  'auth.reason.prereq': 'Nog niet alle voorwaarden zijn gehaald',
  'auth.reason.checks': 'Vink eerst de drie zinnen aan',
  'auth.reauthReason': 'Je bevestigt concept-bedragen voor je aangifte. Vul de code uit je authenticator-app in.',
  'auth.done': 'Bevestigd. Vergelijk nu met het portaal.',
  'portal.title': 'Vergelijk met portaal',
  'portal.lockedText': 'Zodra je het concept hebt bevestigd, zie je hier alle bedragen in de volgorde van het portaal.',
  'portal.progress': '{n} van {total} afgevinkt',
  'portal.turnover': 'Omzet',
  'portal.vat': 'Btw',
  'portal.computed': 'Berekent het portaal zelf — controleer: {amount}',
  'portal.checkAria': 'Rubriek {box} afgevinkt',
  'portal.copyAria': 'Kopieer {label} van rubriek {box}: {value}',
  'portal.mismatch': 'Het portaal toont iets anders',
  'portal.filed': 'Ik heb ingediend',
  'filed.confirm.title': 'Heb je de aangifte verzonden?',
  'filed.confirm.text': 'Heb je in Mijn Belastingdienst op ‘Verzenden’ gedrukt en een bevestiging gezien?',
  'filed.confirm.hint': 'Daarna stoppen we de herinneringen voor de deadline. Binnen 24 uur kun je dit nog terugdraaien.',
  'filed.confirm.yes': 'Ja, ingediend',
  'filed.confirm.no': 'Nog niet',
  'filed.title': 'Ingediend op {date}',
  'filed.text': 'We bewaren deze aangifte precies zoals je hem hebt ingediend.',
  'filed.undo': 'Toch nog niet ingediend',
  'filed.undoUntil': 'Terugdraaien kan tot {date}, {time}.',
  'filed.undone': 'Teruggezet naar ‘nog niet ingediend’. Vergelijk opnieuw met het portaal als je klaar bent.',
  'portal.reason': 'Vink eerst nog {n, plural, one {# rubriek} other {# rubrieken}} af',
  'portal.open': 'Open Mijn Belastingdienst Zakelijk',
  'portal.guide.title': 'Zo dien je in',
  'portal.guide.loginEh': 'Log in met eHerkenning (niveau EH3 of hoger).',
  'portal.guide.loginDigid': 'Log in met DigiD.',
  'portal.guide.step2': 'Open de btw-aangifte voor {quarter}.',
  'portal.guide.step3': 'Neem per rubriek de bedragen over met de kopieerknoppen en vink ze hier af.',
  'portal.guide.step4': 'Verstuur de aangifte in het portaal en kom terug om “Ik heb ingediend” te kiezen.',
  'portal.guide.video': 'Bekijk de video-uitleg',
  'portal.mobile.title': 'Werkt het best op een computer',
  'portal.mobile.text': 'Je wisselt steeds tussen het portaal en deze pagina. Op een computer gaat dat het makkelijkst.',
  'security.never': 'We vragen nooit om je wachtwoord of inlogcode.',
  'mismatch.title': 'Het portaal toont iets anders',
  'mismatch.text': 'Laat ons weten welke rubriek afwijkt. We zoeken het uit en zetten het afronden even op pauze.',
  'mismatch.box': 'Welke rubriek?',
  'mismatch.boxPlaceholder': 'Kies een rubriek',
  'mismatch.value': 'Wat toont het portaal?',
  'mismatch.valueHint': 'In hele euro’s, zonder punten.',
  'mismatch.note': 'Toelichting',
  'mismatch.pause': 'Tot we het hebben uitgezocht, kun je deze aangifte niet afronden.',
  'mismatch.send': 'Versturen',
  'mismatch.sent': 'Verstuurd. We nemen contact met je op.',

  /* step: bevestiging (§6.6) */
  'receipt.notYet.title': 'Nog niet ingediend',
  'receipt.notYet.text': 'Na het indienen in het portaal upload je hier de ontvangstbevestiging.',
  'receipt.waiting.title': 'Ingediend op {date}',
  'receipt.waiting.text': 'Upload de ontvangstbevestiging van de Belastingdienst om af te ronden. Zonder kunnen we de aangifte niet afsluiten.',
  'receipt.title': 'Ontvangstbevestiging',
  'receipt.text': 'Je vindt hem in het portaal onder Berichten, of als pdf na het versturen.',
  'receipt.file': 'Bestand (pdf of schermafbeelding)',
  'receipt.fileHint': 'Kies het bestand van de ontvangstbevestiging',
  'receipt.number': 'Kenmerk van de ontvangstbevestiging',
  'receipt.numberHint': 'Staat bovenaan de bevestiging',
  'receipt.date': 'Ontvangen op',
  'receipt.submit': 'Afronden',
  'receipt.reason.role': 'Alleen de eigenaar kan afronden',
  'receipt.reason.file': 'Kies eerst het bestand',
  'receipt.reason.number': 'Vul eerst het kenmerk in',
  'receipt.saved': 'Afgerond en gearchiveerd',
  'closed.title': 'Aangifte {quarter} afgerond',
  'closed.receipt': 'Kenmerk {number}',
  'closed.pay.title': 'Vergeet niet te betalen',
  'closed.pay.text': 'Het bedrag van {amount} betaal je zelf aan de Belastingdienst, uiterlijk {date}. BTW Kwartier betaalt niets voor je.',
  'closed.pay.weekend': 'Die dag is een {weekday}: zorg dat het bedrag uiterlijk {lastWorkingDay} op de rekening van de Belastingdienst staat. Je bank heeft enkele werkdagen nodig.',
  'closed.refund.title': 'Je krijgt geld terug',
  'closed.refund.text': 'De Belastingdienst betaalt het bedrag terug op je rekening. Dat duurt meestal een paar weken.',
  'closed.archive': 'Download archief',
  'closed.archiveHint': 'Csv, pdf en alle originele documenten. Bewaar het 7 jaar.',
  'closed.next': 'Volgende aangifte: {quarter}, uiterlijk {date}.',

  /* documents (§7) */
  'documents.sub': 'Facturen en bonnen. We lezen ze en koppelen ze aan je betalingen.',
  'documents.upload': 'Documenten toevoegen',
  'documents.uploadFor': 'Voor welk bedrijf?',
  'documents.autoEntity': 'Laat ons het bedrijf herkennen',
  'documents.uploaded': '{n, plural, one {# document geüpload} other {# documenten geüpload}}',
  'documents.forward.title': 'Doorstuuradres',
  'documents.forward.label': 'Of stuur facturen door naar',
  'documents.forward.hint': 'Stuur facturen per mail door naar dit adres. Binnen een minuut staan ze hier.',
  'documents.forward.copy': 'Kopieer doorstuuradres',
  'documents.forward.copyFor': 'Kopieer doorstuuradres van {name}',
  'documents.filterAria': 'Filter documenten',
  'documents.filter.all': 'Alle',
  'documents.filter.matched': 'Gekoppeld',
  'documents.filter.unmatched': 'Niet gekoppeld',
  'documents.filter.duplicate': 'Dubbel',
  'documents.filter.other_quarter': 'Niet in dit kwartaal',
  'documents.empty': 'Geen documenten',
  'documents.emptyText': 'Sleep facturen hierheen, maak een foto of stuur ze door naar je doorstuuradres.',
  'documents.listAria': 'Documenten',
  'documents.noDate': 'Geen datum',
  'documents.vat': 'btw',
  /* 2026-10 phase 2: 资料 page, 3-step onboarding, settings tabs (铁扇律官) */
  'documents.title': 'Documenten',
  'documents.eyebrow': '{company} · {quarter}',
  'documents.noCompany': 'Nog geen bedrijf',
  'documents.noCompanyText': 'Voeg eerst een bedrijf toe; daarna lever je hier afschriften en facturen aan.',
  'documents.tabsAria': 'Soort document',
  'documents.tab.invoices': 'Facturen {n}',
  'documents.tab.bank': 'Bankafschriften {n}',
  'documents.bank.none': 'Nog geen bankrekening. Sleep een afschrift (MT940, CAMT.053 of CSV) in het vak hierboven; de rekening herkennen we zelf.',
  'documents.bank.covered': 'Gedekt {from} – {to}',
  'documents.bank.gap': 'Ontbreekt {from} – {to}',
  'documents.bank.notYet': 'Nog geen afschrift',
  'documents.bank.allTx': 'Elke betaling zie je terug in de aangifte.',
  'documents.bank.allTxLink': 'Alle transacties bekijken',
  'documents.invoices.empty': 'Nog geen facturen voor dit kwartaal',
  'documents.invoices.emptyText': 'Sleep ze in het vak hierboven, maak een foto of stuur ze door naar je doorstuuradres.',
  'documents.invoices.emptyTextNoForward': 'Sleep ze in het vak hierboven of maak een foto.',
  'documents.invoices.yours': 'jouw verkoopfactuur',
  'documents.invoices.more': 'Nog {n}',
  'documents.invoices.showAll': 'alles tonen',
  'documents.pill.processing': 'Wordt gelezen',
  'documents.pill.check': 'Controleren',
  'documents.pill.duplicate': 'Dubbel',
  'documents.pill.sale': 'Verkoop',
  'documents.pill.matched': 'Gekoppeld aan betaling',
  'documents.pill.unmatched': 'Nog geen betaling',
  'documents.missing.title': '{n, plural, one {Nog # factuur nodig} other {Nog # facturen nodig}}',
  'documents.missing.gain': 'dan trek je tot ca. {amount} meer btw af (uitgaand van 21% btw)',
  'documents.missing.hint': 'Zonder factuur trekken we geen btw af. Het bedrag is een schatting bij 21% btw.',
  'documents.missing.unknownParty': 'Onbekende ontvanger',
  'documents.missing.status': 'Betaling gevonden, factuur nog niet',
  'documents.missing.upload': 'Uploaden',
  'documents.missing.uploadFor': 'Factuur van {name} uploaden',
  'documents.missing.noInvoice': 'Geen factuur',
  'documents.missing.noInvoiceFor': 'Geen factuur voor {name}',
  'documents.missing.noInvoiceDone': 'Genoteerd: geen factuur voor {name}. Hiervoor trekken we geen btw af.',
  'documents.drop.title': 'Sleep bankafschriften en facturen hierheen',
  'documents.drop.hint': 'PDF, foto, CSV, MT940 of CAMT.053: we zien zelf wat een afschrift is en wat een factuur.',
  'documents.drop.choose': 'Bestanden kiezen',
  'documents.drop.camera': 'Foto maken',
  'documents.drop.forward': 'Of stuur factuurmails door naar',
  'documents.drop.unsupported': 'Dit bestandstype kunnen we niet lezen. Gebruik PDF, een foto, CSV, MT940 of CAMT.053.',
  'documents.drop.okStatement': 'bankafschrift: controleer en bevestig de import',
  'documents.drop.statementImported': 'bankafschrift geïmporteerd',
  'documents.drop.okInvoice': 'factuur, wordt gelezen',
  'documents.drop.confirmImport': 'Import bevestigen',
  'onboarding.progressAria': 'Voortgang',
  'onboarding.step.account': 'Account',
  'onboarding.step.company': 'Je bedrijf',
  'onboarding.step.statement': 'Eerste afschrift',
  'onboarding.later': 'Later doen',
  'onboarding.company.title': 'Je bedrijf',
  'onboarding.company.lead': 'Vul je KvK-nummer in; naam en adres vullen we zelf aan. Beantwoord daarna een paar ja/nee-vragen: dan zie je meteen of je bedrijf geschikt is om zelf aangifte te doen.',
  'onboarding.company.kvk': 'KvK-nummer',
  'onboarding.company.kvkHint': '8 cijfers, staat op je KvK-uittreksel.',
  'onboarding.company.looking': 'Zoeken bij de KvK…',
  'onboarding.company.found': 'Gevonden',
  'onboarding.company.notFound': 'Dit nummer vinden we niet bij de KvK. Controleer het, of vul de naam zelf in.',
  'onboarding.company.lookupError': 'De KvK is nu niet bereikbaar. Vul de naam zelf in.',
  'onboarding.company.manualHint': 'Vul de naam in zoals die bij de KVK staat. Wij controleren de gegevens met het Handelsregister.',
  'onboarding.fit.title': 'Geschikt om zelf aangifte te doen?',
  'onboarding.fit.note': 'Zeg je bij een van de eerste 8 vragen nee, dan leggen we uit waarom en stellen we je voor aan een partner-accountant. Dat kost bij BTW Kwartier niets.',
  'onboarding.q.ownQuarterly': 'Dit bedrijf doet zelf elk kwartaal btw-aangifte (niet per maand of per jaar, en niet samen in een fiscale eenheid)',
  'onboarding.q.noKor': 'Je doet niet mee aan de KOR (kleineondernemersregeling)',
  'onboarding.q.noExempt': 'Je hebt geen omzet die vrijgesteld is van btw (zoals zorg, onderwijs, financiële diensten, verzekeringen, verhuur of verkoop van vastgoed)',
  'onboarding.q.noDistanceSales': 'Je verkoopt geen goederen op afstand aan consumenten in andere EU-landen (webwinkel, OSS)',
  'onboarding.q.noCash': 'Je bedrijf is geen winkel, restaurant of kraam die vooral contant of via de kassa ontvangt',
  'onboarding.q.canLogin': 'Je kunt inloggen op Mijn Belastingdienst Zakelijk (BV met eHerkenning, eenmanszaak met DigiD)',
  'onboarding.h.ownQuarterly': 'Het aangiftetijdvak staat in de brief met je btw-nummer. In een fiscale eenheid doet één bedrijf de aangifte voor alle bedrijven samen.',
  'onboarding.h.noKor': 'Doe je wel mee? Dan doe je geen btw-aangifte. Wij houden dan gratis je omzet bij tegen de grens van € 20.000.',
  'onboarding.h.noExempt': 'Met vrijgestelde omzet mag je btw maar gedeeltelijk aftrekken; dat vraagt een berekening naar verhouding.',
  'onboarding.h.noDistanceSales': 'Invoer, uitvoer en levering van goederen aan bedrijven in de EU zijn geen probleem. Het gaat alleen om verkoop aan particulieren in andere EU-landen.',
  'onboarding.h.noCash': 'Zulke bedrijven doen meestal aangifte volgens het kasstelsel, en niet alle omzet staat op de bankafschriften.',
  'onboarding.h.canLogin': 'Je dient de aangifte zelf in via het portaal. Kun je nog niet inloggen? Dat blokkeert niets; we vertellen je hoe je het regelt.',
  'onboarding.q.noMargin': 'Je gebruikt de margeregeling niet',
  'onboarding.h.noMargin': 'De margeregeling is voor handel in gebruikte goederen, kunst en antiek: btw alleen over de winstmarge.',
  'onboarding.q.notHoldingOnly': 'Je bedrijf brengt zelf iets in rekening (het is geen holding die alleen aandelen houdt)',
  'onboarding.h.notHoldingOnly': 'Een holding die alleen aandelen houdt en niets in rekening brengt, is voor de btw geen ondernemer. Rekent je holding een managementfee? Dan is het antwoord ja.',
  'onboarding.q.establishedNl': 'Je bedrijf is in Nederland gevestigd',
  'onboarding.h.establishedNl': 'Buitenlandse bedrijven doen aangifte bij de Belastingdienst in Heerlen en hebben andere regels.',
  'onboarding.result.okTitle': 'Geschikt.',
  'onboarding.result.okText': 'Je bedrijf kan met BTW Kwartier zelf aangifte doen.',
  'onboarding.result.korTitle': 'Geschikt voor KOR-bewaking.',
  'onboarding.result.korText': 'Met de KOR doe je geen btw-aangifte. Wij houden gratis je omzet bij en waarschuwen je bij 80%, 90% en 100% van de grens van € 20.000.',
  'onboarding.result.channel': 'Regel vóór het indienen je inlogmiddel: eHerkenning (niveau 3 of hoger) voor een BV, DigiD voor een eenmanszaak. Aanvragen duurt meestal enkele dagen tot twee weken.',
  'onboarding.result.noTitle': 'Dit bedrijf past nog niet bij zelf aangifte doen',
  'onboarding.why.not_quarterly': 'De eerste versie ondersteunt alleen de eigen kwartaalaangifte van een bedrijf. Maand- en jaaraangifte of een fiscale eenheid vragen een accountant.',
  'onboarding.why.kor': 'Met de KOR doe je meestal geen kwartaalaangifte. Koop je diensten in het buitenland in (bijvoorbeeld online advertenties) of is de btw om een andere reden naar jou verlegd, dan moet je soms toch een incidentele aangifte doen; die situaties doen we nog niet.',
  'onboarding.why.excluded_scheme': 'Met vrijgestelde omzet moet de aftrek van btw naar verhouding worden verdeeld, en de margeregeling rekent anders. Dat kan de eerste versie nog niet.',
  'onboarding.why.goods_or_distance': 'Je antwoorden zijn van vóór oktober 2026. Beantwoord de vragen opnieuw: in- en uitvoer van goederen en levering aan bedrijven in de EU doen we nu ook.',
  'onboarding.why.distance_sales': 'Webwinkelverkoop aan consumenten in andere EU-landen gaat via de OSS-regeling, met de btw van het land van de klant. Die aangifte doen we niet.',
  'onboarding.why.cash_business': 'Bij een bedrijf dat vooral contant ontvangt, geldt meestal het kasstelsel en staat veel omzet niet op de bank. Dan kunnen wij de aangifte niet controleren.',
  'onboarding.why.exempt_income': 'Met vrijgestelde omzet mag je de btw op je kosten maar voor een deel aftrekken, naar verhouding. Die verdeling kan de eerste versie nog niet maken.',
  'onboarding.why.margin_scheme': 'Bij de margeregeling betaal je btw over je winstmarge per verkoop, niet over de verkoopprijs. Die berekening doet de eerste versie nog niet.',
  'onboarding.why.holding_only': 'Een holding zonder eigen omzet heeft meestal geen recht op aftrek van btw, of zit in een fiscale eenheid. Dat vraagt een accountant.',
  'onboarding.why.non_resident': 'Een buitenlands bedrijf doet aangifte bij een ander kantoor van de Belastingdienst en vaak met andere regels. De eerste versie is gemaakt voor bedrijven in Nederland.',
  'onboarding.why.too_many_transactions': 'Op dit moment tot 300 bankbetalingen per kwartaal.',
  'onboarding.refer.text': 'Een partner-accountant kan de aangifte voor je doen. BTW Kwartier rekent hiervoor niets; het tarief spreek je rechtstreeks met de accountant af. Liever eerst overleggen? Mail ons op info@jrkdm.com, dan zoeken we samen een oplossing.',
  'onboarding.refer.action': 'Laat een partner-accountant contact opnemen',
  'onboarding.refer.sent': 'Doorverwezen. We stellen je voor aan een passende partner-accountant.',
  'onboarding.refer.sentWith': 'Doorverwezen naar {name} ({email}). Zij nemen contact met je op; je mag ook zelf mailen.',
  'onboarding.toHome': 'Naar het overzicht',
  'onboarding.continue': 'Verder',
  'onboarding.changeAnswers': 'Antwoorden aanpassen',
  'onboarding.reason.company': 'Vul eerst je KvK-nummer in',
  'onboarding.reason.answers': 'Beantwoord alle 9 vragen',
  'onboarding.statement.title': 'Eerste afschrift',
  'onboarding.statement.lead': 'Upload het bankafschrift van dit kwartaal. Daaruit halen we elke betaling en ontvangst, en daar koppelen we de facturen aan.',
  'onboarding.statement.channel.eherkenning': 'Voor het indienen heb je eHerkenning nodig (niveau 3 of hoger). Vraag het nu aan; dat duurt meestal enkele dagen tot twee weken.',
  'onboarding.statement.channel.digid': 'Voor het indienen heb je DigiD nodig. Heb je het nog niet? Vraag het nu aan.',
  'onboarding.statement.formats': 'ING, Rabobank, ABN AMRO, Knab, bunq en Revolut leveren MT940, CAMT.053 of CSV. Liefst het hele kwartaal.',
  'onboarding.statement.choose': 'Afschrift kiezen',
  'onboarding.statement.guide': 'Hoe exporteer ik dat? Stap voor stap per bank',
  'onboarding.statement.later': 'Je kunt het ook later uploaden op de pagina Documenten.',
  'settings.tab.companies': 'Bedrijven',
  'settings.tab.log': 'Logboek',
  'intake.reason.cash_business': 'Vooral contante of kassa-ontvangsten',
  'upload.title': 'Sleep bestanden hierheen',
  'upload.hint': 'Pdf, foto of e-factuur (UBL). Meerdere tegelijk mag.',
  'upload.choose': 'Bestanden kiezen',
  'upload.camera': 'Foto maken',
  'upload.ok': 'geüpload, we lezen hem nu',
  'doc.title': 'Document',
  'doc.status.processing': 'Wordt gelezen',
  'doc.status.extracted': 'Gelezen',
  'doc.status.needs_review': 'Controleer',
  'doc.status.failed': 'Niet leesbaar',
  'doc.status.duplicate': 'Dubbel',
  'doc.status.suspicious': 'Verdacht',
  'doc.reverseCharge': 'Btw verlegd',
  'doc.reverseChargeLabel': 'Btw verlegd (de btw draag jij af)',
  'doc.suspicious.title': 'Dit document bevat verdachte tekst',
  'doc.suspicious.text': 'Er staat tekst in die op instructies lijkt. We gebruiken het pas als jij zegt dat het een gewone factuur is.',
  'doc.duplicate.title': 'Dit lijkt een dubbel document',
  'doc.duplicate.text': 'We hebben dezelfde factuur al. We tellen hem maar één keer mee.',
  'doc.fields': 'Gelezen gegevens',
  'doc.edit': 'Aanpassen',
  'doc.processing': 'We lezen dit document nog. Dat duurt meestal minder dan een minuut.',
  'doc.noFields': 'We konden hier geen gegevens uit lezen. Vul ze zelf in.',
  'doc.confidence': '{pct}% zeker',
  'doc.showSource': 'Toon in document',
  'doc.sourceHighlighted': 'Waar we dit lazen',
  'doc.original': 'Origineel',
  'doc.showOriginal': 'Toon origineel bestand',
  'doc.openFile': 'Bestand openen',
  'doc.textPreview': 'Tekst van het document',
  'doc.zoom': 'Zoomen',
  'doc.zoomIn': 'Inzoomen',
  'doc.zoomOut': 'Uitzoomen',
  'doc.lines': 'Regels',
  'doc.line.description': 'Omschrijving',
  'doc.line.net': 'Bedrag excl. btw',
  'doc.line.rate': 'Tarief',
  'doc.line.vat': 'Btw',
  'doc.field.supplierName': 'Leverancier',
  'doc.field.invoiceNumber': 'Factuurnummer',
  'doc.field.invoiceDate': 'Factuurdatum',
  'doc.field.direction': 'Soort',
  'doc.field.supplierVatId': 'Btw-nummer leverancier',
  'doc.field.supplierCountry': 'Land leverancier',
  'doc.field.buyerName': 'Op naam van',
  'doc.field.totalCents': 'Totaal',
  'doc.field.vatCents': 'Btw-bedrag',
  'doc.field.netCents': 'Bedrag excl. btw',
  'doc.field.vatRate': 'Btw-tarief',
  'doc.field.currency': 'Valuta',
  'doc.field.reverseCharge': 'Btw verlegd',
  'doc.field.dueDate': 'Vervaldatum',
  'doc.countryHint': 'Twee letters, bijv. DE',
  'doc.direction.purchase': 'Inkoopfactuur',
  'doc.direction.sales': 'Verkoopfactuur',
  'doc.direction.unknown': 'Weet ik niet',
  'doc.saved': 'Document aangepast',
  'doc.move.label': 'Verkeerd bedrijf? Verplaatsen',
  'doc.move.placeholder': 'Kies het juiste bedrijf',
  'doc.move.hint': 'We rekenen alleen opnieuw wat erdoor verandert.',
  'doc.moved': 'Verplaatst naar {name}',
  'doc.delete': 'Document verwijderen',
  'doc.deleteTitle': 'Document verwijderen?',
  'doc.deleteText': '“{name}” verdwijnt uit je administratie en uit lopende aangiftes. Dit kun je niet ongedaan maken.',
  'doc.deleteReauth': 'We vragen je om je code uit je authenticator-app.',
  'doc.deleteAction': 'Document verwijderen',
  'doc.deleted': 'Document verwijderd',

  /* transactions & import (§7) */
  'tx.sub': 'Je bankbetalingen. Plus en min staan voor geld erbij en eraf.',
  'tx.updated': 'Laatst bijgewerkt {time}',
  'tx.import': 'Bankafschrift importeren',
  'tx.accounts': 'Bankrekeningen',
  'tx.privateAccount': 'Privérekening',
  'tx.filterAria': 'Filter transacties',
  'tx.filter.all': 'Alle',
  'tx.filter.matched': 'Gekoppeld',
  'tx.filter.missing_invoice': 'Mist factuur',
  'tx.filter.private': 'Privé',
  'tx.filter.internal': 'Intern',
  'tx.filter.unknown': 'Onbekend',
  'tx.search': 'Zoek op naam, omschrijving of bedrag',
  'tx.col.date': 'Datum',
  'tx.col.party': 'Tegenpartij',
  'tx.col.status': 'Status',
  'tx.col.docs': 'Factuur',
  'tx.col.amount': 'Bedrag',
  'tx.count': '{n, plural, one {# transactie} other {# transacties}}',
  'tx.empty': 'Nog geen transacties',
  'tx.emptyText': 'Importeer een bankafschrift van dit kwartaal om te beginnen.',
  'tx.emptyFiltered': 'Geen transacties met dit filter',
  'tx.private': 'Privé',
  'tx.maskedHint': 'Alleen de eigenaar ziet privédetails.',
  'tx.unknownParty': 'Onbekende tegenpartij',
  'tx.debit': 'Afschrijving',
  'tx.credit': 'Bijschrijving',
  'tx.missingInvoice': 'Mist factuur',
  'tx.docsAria': '{n, plural, one {# gekoppelde factuur} other {# gekoppelde facturen}}',
  'tx.noInvoice.title': 'Geen factuur voor een betaling?',
  'tx.noInvoice.text': 'Beantwoord de vraag bij die betaling met “Er is geen factuur”. Dan trekken we er geen btw voor af (voorzichtige keuze); in je concept staat het als “Voorzichtig behandeld”.',
  'tx.class.unknown': 'Onbekend',
  'tx.class.business': 'Zakelijk',
  'tx.class.private': 'Privé',
  'tx.class.partial': 'Deels zakelijk',
  'tx.class.internal_transfer': 'Intern',
  'tx.class.no_vat': 'Zonder btw',
  'import.step.bank': 'Welke bank?',
  'import.step.guide': 'Zo download je het afschrift bij {bank}',
  'import.step.upload': 'Upload het afschrift',
  'import.step.mapping': 'Kolommen koppelen',
  'import.step.preview': 'Controleer de import',
  'import.step.done': 'Geïmporteerd',
  'import.bankIntro': 'Kies je bank; dan laten we zien hoe je het afschrift downloadt.',
  'import.otherBank': 'Andere bank',
  'import.guide.ing': 'Log in op Mijn ING (website, niet de app). | Ga naar Betalen → Af- en bijschrijvingen downloaden. | Kies het formaat MT940 of CAMT.053. | Kies de periode: het hele kwartaal. | Klik op Downloaden.',
  'import.guide.rabobank': 'Log in op Rabo Internetbankieren. | Ga naar Rekeningen → Transacties downloaden. | Kies CAMT.053 (of MT940). | Kies het hele kwartaal als periode en download.',
  'import.guide.abnamro': 'Log in op Internet Bankieren. | Ga naar Zelf regelen → Transacties downloaden. | Kies MT940 of CAMT.053. | Kies het kwartaal en download.',
  'import.guide.knab': 'Log in via de website van Knab. | Open je rekening en kies Exporteren. | Kies MT940 of CSV en het hele kwartaal. | Download het bestand.',
  'import.guide.bunq': 'Open de bunq-app. | Tik op je rekening → Export → Afschrift. | Kies CAMT.053 of CSV en het kwartaal. | Deel het bestand naar je computer of upload het hier vanaf je telefoon.',
  'import.guide.revolut': 'Log in op Revolut Business (website). | Open de rekening → Afschrift. | Kies CSV (of CAMT.053) en het kwartaal. | Klik op Exporteren.',
  'import.guide.other': 'Log in bij je bank. | Zoek naar “transacties downloaden” of “exporteren”. | Kies MT940, CAMT.053 of CSV en het hele kwartaal. | Kan het niet? Upload dan een CSV; je koppelt zelf de kolommen.',
  'import.guide.formats': 'We lezen MT940, CAMT.053 en CSV. Een pdf-afschrift kunnen we (nog) niet lezen.',
  'import.haveFile': 'Ik heb het bestand',
  'import.entity': 'Bedrijf',
  'import.account': 'Rekening',
  'import.accountHint': 'Weet je het niet? Dan herkennen we het IBAN uit het bestand.',
  'import.accountAuto': 'Herken uit het bestand',
  'import.file': 'Afschrift',
  'import.fileHint': 'MT940 (.sta/.940), CAMT.053 (.xml) of CSV',
  'import.uploadAction': 'Uploaden en controleren',
  'import.reasonFile': 'Kies eerst een bestand',
  'import.p.file': 'Bestand',
  'import.p.account': 'Rekening',
  'import.p.period': 'Periode',
  'import.p.count': 'Transacties',
  'import.p.new': '{n, plural, one {# nieuwe} other {# nieuwe}}',
  'import.p.total': '{n} in het bestand',
  'import.p.dupes': '{n} al bekend',
  'import.p.balances': 'Saldo begin → eind',
  'import.zeroNew': '0 nieuwe transacties',
  'import.zeroNewText': 'Dit bestand hebben we al eerder ingelezen. Er verandert niets.',
  'import.continuity.ok': 'Saldo sluit aan op de vorige import',
  'import.continuity.gap': 'Er ontbreekt een periode tussen de imports',
  'import.continuity.mismatch': 'Het beginsaldo sluit niet aan',
  'import.continuity.unknown': 'We konden de aansluiting niet controleren',
  'import.continuity.text': 'Importeer ook het afschrift van de ontbrekende periode, anders missen we misschien betalingen.',
  'import.confirm': '{n, plural, one {# transactie importeren} other {# transacties importeren}}',
  'import.confirmZero': 'Afronden',
  'import.done': '{n, plural, one {# transactie geïmporteerd} other {# transacties geïmporteerd}}',
  'import.doneZero': '0 nieuwe transacties',
  'import.doneText': 'We koppelen de betalingen aan je facturen en zetten vragen klaar als iets onduidelijk is.',
  'import.failed.title': 'We herkennen dit bestand niet',
  'import.mapping.title': 'Help ons de kolommen te lezen',
  'import.mapping.text': "We weten niet zeker welke kolom wat is. Kies het hieronder; we onthouden het, zodat je dit voor deze bank maar één keer doet.",
  'import.map.date': 'Datum',
  'import.map.amount': 'Bedrag',
  'import.map.description': 'Omschrijving',
  'import.map.counterpartyName': 'Naam tegenpartij',
  'import.map.counterpartyIban': 'IBAN tegenpartij',
  'import.map.debitCredit': 'Af/Bij',
  'import.map.balance': 'Saldo',
  'import.map.choose': 'Kies een kolom',
  'import.map.dateFormat': 'Datumnotatie',
  'import.map.decimal': 'Decimaalteken',
  'import.map.comma': 'Komma (1.234,56)',
  'import.map.dot': 'Punt (1,234.56)',
  'import.map.missing': 'Nog {n} verplichte kolommen kiezen',
  'import.map.submit': 'Kolommen toepassen',
  'import.period.edit': "aanpassen",
  'import.err.period_reversed': "De einddatum ligt vóór de begindatum.",
  'import.err.period_future': "De periode kan niet na vandaag eindigen.",
  'import.err.period_excludes_bookings': "De periode moet alle betalingen bevatten: van {first} t/m {last}.",
  'import.err.period_too_long': "Eén afschrift kan hoogstens 10 jaar beslaan.",
  'import.err.period_incomplete': "Vul zowel een begin- als een einddatum in.",
  'import.err.period_from_statement': "Dit afschrift noemt zelf zijn periode; die hoef je niet aan te passen.",
  'import.err.bank_account_required': "Kies bij welke bankrekening dit afschrift hoort.",
  'import.err.iban_mismatch': "Dit afschrift is van een andere bankrekening dan je koos.",
  'import.err.iban_other_entity': "Deze bankrekening hoort bij een ander bedrijf in je account. Kies dat bedrijf.",
  'import.err.bank_account_unknown': "Bankrekening •••• {last4} is nog niet bekend. Vraag de eigenaar om hem toe te voegen onder Instellingen → Bankrekeningen.",
  'import.err.file': "Kies een afschrift van hoogstens 10 MB.",
  'import.err.admission': "Maak eerst de vragen over je bedrijf af; daarna kun je afschriften importeren.",
  'import.err.other': "Dit afschrift kon niet worden geïmporteerd. Probeer het opnieuw of kies een MT940- of CAMT.053-bestand.",
  'import.warning.balance_does_not_add_up': "De saldi in het bestand tellen niet op. Controleer of het bestand compleet is.",
  'import.warning.foreign_currency_rows': "{n} betalingen staan in een andere valuta dan de rekening.",
  'import.warning.rows_skipped_not_completed': "{n} betalingen die nog niet zijn afgerond, zijn overgeslagen.",
  'import.warning.skipped_entry_status': "Een boeking met status {status} (nog niet definitief) is overgeslagen.",
  'import.warning.columns_guessed': "De kolommen zijn automatisch herkend.",
  'import.warning.bank_account_created': "Nieuwe bankrekening {iban} toegevoegd.",
  'import.warning.bank_account_assumed': "Het bestand noemt geen rekeningnummer; we zetten het op je enige zakelijke rekening.",
  'import.warning.bank_account_required': "Het bestand noemt geen rekeningnummer. Kies bij welke bankrekening het hoort.",
  'import.warning.starts_after_quarter_start': "De eerste betaling is van {first}. Heb je ook het afschrift vanaf {date}? Dan is het kwartaal compleet.",
  'import.warning.no_transactions': "Er staan geen betalingen in dit bestand.",
  'import.warning.template_not_found': "We herkenden de kolommen niet zeker; kies ze hieronder.",
  'import.warning.parse_error': "We konden dit bestand niet lezen. Probeer een MT940- of CAMT.053-bestand.",
  'import.recognised': "Herkend als: {name}",
  'import.recognised.remembered': "met je eerdere kolomkeuze",
  'import.recognised.manual': "kolommen zelf gekozen",
  'import.adjustColumns': "Kolommen aanpassen",
  'import.adjust.text': "Klopt een kolom niet? Kies hem hier; we onthouden het voor de volgende keer.",
  'import.map.uncertain': "Niet zeker: kies de kolom",
  'import.map.auto': "Automatisch herkennen",
  'import.mapErr.column_missing': "Kolom '{column}' staat niet in het bestand",
  'import.mapErr.not_dates': "Kolom '{column}' bevat geen datums (bijv. '{value}')",
  'import.mapErr.not_amounts': "Kolom '{column}' bevat geen bedragen (bijv. '{value}')",
  'import.mapErr.looks_like_dates': "Kolom '{column}' bevat datums, geen bedragen",
  'import.mapErr.unknown_indicator': "Kolom '{column}' bevat geen af/bij-aanduiding (gevonden: '{value}')",
  'import.mapErr.same_column': "Datum en bedrag kunnen niet dezelfde kolom zijn",
  'import.mapErr.mapping_failed': "Met deze kolommen lukt het niet. Kies ze opnieuw.",
  'import.hint.summary': "Tip: download CAMT.053 of MT940, dan hoef je nooit kolommen te kiezen",
  'import.howto.ing': "ING: Mijn ING (website) → Betalen → Af- en bijschrijvingen downloaden → MT940 of CAMT.053.",
  'import.howto.rabobank': "Rabobank: Rabo Internetbankieren → Rekeningen → Transacties downloaden → CAMT.053 of MT940.",
  'import.howto.abnamro': "ABN AMRO: Internet Bankieren → Zelf regelen → Transacties downloaden → CAMT.053 of MT940.",
  'import.howto.bunq': "bunq: app → je rekening → Exporteren → Afschrift → CAMT.053 of MT940.",
  'import.howto.knab': "Knab: website → je rekening → Exporteren → MT940.",
  'import.howto.revolut': "Revolut: Afschrift → CSV; die lezen we zonder kolommen te kiezen.",
  'import.howto.triodos': "Triodos: Internet Bankieren → Rekening → Downloaden → MT940.",
  'import.howto.volksbank': "ASN, SNS, RegioBank: Internetbankieren → Bij- en afschrijvingen → Downloaden → MT940.",

  /* entities (§7) */
  'entities.sub': 'Je bedrijven, hun gegevens en hoe je inlogt bij de Belastingdienst.',
  'entities.add': '+ Bedrijf toevoegen',
  'entities.kvk': 'KvK-nummer',
  'entities.kvkInvalid': 'Een KvK-nummer heeft 8 cijfers.',
  'entities.kvkCheck.pending': 'Wordt gecontroleerd',
  'entities.kvkCheck.ok': 'Gecontroleerd met het Handelsregister',
  'entities.kvkCheck.mismatch': 'Klopt niet met het Handelsregister',
  'entities.kvkCheck.mismatchTitle': 'De gegevens kloppen niet met het Handelsregister — controleer naam en KvK-nummer',
  'entities.kvkCheck.note': 'Toelichting van BTW Kwartier: {note}',
  'entities.btwId': 'Btw-id',
  'entities.btwIdHint': 'Het btw-identificatienummer (NL…B..) dat je op facturen zet.',
  'entities.btwIdInvalid': 'Dit btw-id klopt niet. Het ziet eruit als NL123456789B01.',
  'entities.btwIdObNumber': 'Dit lijkt je omzetbelastingnummer (met je BSN). Vul je btw-id in: het nummer dat op je facturen staat, sinds 2020 zonder BSN.',
  'entities.accounts': '{n, plural, one {# rekening} other {# rekeningen}}',
  'entities.openPeriod': 'Naar aangifte {quarter}',
  'entities.details': 'Bedrijfsgegevens',
  'entities.name': 'Naam',
  'entities.legalForm': 'Rechtsvorm',
  'entities.address': 'Adres',
  'entities.filingPeriod': 'Aangifteperiode',
  'entities.period.quarter': 'Per kwartaal',
  'entities.period.month': 'Per maand',
  'entities.period.year': 'Per jaar',
  'entities.since': 'Toegevoegd op',
  'entities.members': 'Wie heeft toegang',
  'intake.title': 'Toelatingsvragen',
  'intake.notDone': 'Nog niet ingevuld.',
  'intake.do': 'Vragen invullen',
  'intake.eligible': 'Je bedrijf past bij BTW Kwartier',
  'intake.eligibleText': 'Alle toelatingsvragen zijn in orde.',
  'intake.channelGuidance': 'Je kunt nog niet inloggen bij het portaal. Geen probleem: we laten zien hoe je dat regelt.',
  'intake.notEligible': 'Nog niet geschikt voor de eerste versie',
  'intake.notEligibleShort': 'Niet geschikt',
  'intake.q.quarterly': 'Doe je voor dit bedrijf elk kwartaal btw-aangifte?',
  'intake.q.kor': 'Doe je mee aan de kleineondernemersregeling (KOR)?',
  'intake.q.servicesOnly': 'Verkoop je vooral diensten — zonder in- of uitvoer van goederen en zonder verkoop op afstand aan consumenten in de EU?',
  'intake.q.excludedSchemes': 'Heb je te maken met onroerend goed, een fiscale eenheid of de margeregeling?',
  'intake.q.txPerQuarter': 'Hoeveel bankbetalingen heb je ongeveer per kwartaal?',
  'intake.q.canLogin': 'Kun je inloggen bij Mijn Belastingdienst Zakelijk?',
  'intake.h.quarterly': 'Dat staat in de brief van de Belastingdienst over je btw-nummer.',
  'intake.h.kor': 'Met de KOR hoef je geen btw-aangifte te doen.',
  'intake.h.servicesOnly': 'Denk aan advies, IT, design of marketing.',
  'intake.h.excludedSchemes': 'Bijvoorbeeld verhuur of verkoop van panden, of tweedehandsverkoop met margeregeling.',
  'intake.h.txPerQuarter': 'Tel bij- en afschrijvingen samen. Een schatting is genoeg.',
  'intake.h.canLogin': 'Een B.V. logt in met eHerkenning (niveau 3), een eenmanszaak met DigiD.',
  'intake.tx.lt50': 'Minder dan 50',
  'intake.tx.50to150': '50 tot 150',
  'intake.tx.150to300': '150 tot 300',
  'intake.tx.gt300': 'Meer dan 300',
  'intake.reason.not_quarterly': 'Geen eigen kwartaalaangifte (per maand, per jaar of in een fiscale eenheid)',
  'intake.reason.kor': 'Je doet mee aan de KOR',
  'intake.reason.goods_or_distance': 'Invoer, uitvoer of verzending van goederen over de grens',
  'intake.reason.distance_sales': 'Verkoop op afstand aan consumenten in andere EU-landen (OSS)',
  'intake.kor': 'KOR: geen btw-aangifte',
  'intake.korText': 'Je doet mee aan de kleineondernemersregeling. We houden je omzet gratis bij tegen de grens van € 20.000.',
  'intake.korView': 'Omzet bekijken',
  'intake.redo': 'Vragen opnieuw beantwoorden',
  'intake.reason.excluded_scheme': 'Vrijgestelde omzet of de margeregeling',
  'intake.reason.too_many_transactions': 'Meer dan 300 betalingen per kwartaal',
  'intake.reason.exempt_income': 'Vrijgestelde omzet (zorg, onderwijs, financiële diensten, verhuur of verkoop van vastgoed)',
  'intake.reason.margin_scheme': 'De margeregeling',
  'intake.reason.holding_only': 'Een holding zonder eigen omzet',
  'intake.reason.non_resident': 'Niet in Nederland gevestigd',
  'intake.when.not_quarterly': 'Maand- en jaaraangiftes komen in de tweede fase (2027).',
  'intake.when.kor': 'Met de KOR heb je ons niet nodig. Stop je ermee? Dan ben je welkom.',
  'intake.when.goods_or_distance': 'Goederen en OSS staan nog niet op de planning; een boekhouder kan je helpen.',
  'intake.when.excluded_scheme': 'Deze regelingen vragen maatwerk van een boekhouder.',
  'intake.when.too_many_transactions': 'Nu nog niet; later verhogen we de grens.',
  'channel.title': 'Inloggen bij de Belastingdienst',
  'channel.eherkenning': 'eHerkenning',
  'channel.digid': 'DigiD',
  'channel.status.unknown': 'nog niet bevestigd',
  'channel.status.ok': 'werkt',
  'channel.status.applying': 'aangevraagd',
  'channel.status.unavailable': 'nog niet geregeld',
  'channel.explain.eherkenning': 'Een B.V. dient de btw-aangifte in via Mijn Belastingdienst Zakelijk met eHerkenning, niveau EH3 of hoger.',
  'channel.explain.digid': 'Een eenmanszaak dient de btw-aangifte in via Mijn Belastingdienst Zakelijk met DigiD.',
  'channel.guide.eherkenning.title': 'eHerkenning aanvragen',
  'channel.guide.eherkenning.text': 'Vraag eHerkenning niveau 3 aan bij een erkende leverancier. Reken op 2 tot 5 werkdagen; regel het ruim vóór de deadline.',
  'channel.guide.eherkenning.link': 'Naar eherkenning.nl',
  'channel.guide.digid.title': 'DigiD aanvragen',
  'channel.guide.digid.text': 'Vraag DigiD aan op digid.nl. Je krijgt binnen 5 werkdagen een brief met een activeringscode.',
  'channel.guide.digid.link': 'Naar digid.nl',
  'channel.canLogin': 'Ik kan inloggen',
  'channel.applied': 'Ik heb het aangevraagd',
  'channel.cannotLogin': 'Inloggen lukt niet meer',
  'channel.saved': 'Opgeslagen',
  'bank.iban': 'IBAN',
  'bank.ibanInvalid': 'Dit IBAN klopt niet. Controleer de cijfers.',
  'bank.bank': 'Bank',
  'bank.bankAuto': 'Herken uit het IBAN',
  'bank.label': 'Naam van de rekening',
  'bank.private': 'Dit is een privérekening',
  'bank.privateHint': 'Alleen de eigenaar ziet de details van privébetalingen.',
  'bank.add': 'Rekening toevoegen',
  'bank.added': 'Rekening {iban} toegevoegd',
  'bank.removeAria': 'Rekening {iban} verwijderen',
  'bank.removeTitle': 'Rekening verwijderen?',
  'bank.removeText': 'Rekening {iban} en de geïmporteerde transacties verdwijnen uit lopende aangiftes die nog niet bevestigd zijn.',
  'bank.removeAction': 'Rekening verwijderen',
  'bank.removed': 'Rekening verwijderd',

  /* onboarding (§7.1) */
  'onb.eyebrow': 'Je bedrijf toevoegen',
  'onb.duration': 'Ongeveer 15 minuten. Je kunt tussendoor stoppen.',
  'onb.exit': 'Stoppen en naar overzicht',
  'onb.stepsAria': 'Stappen',
  'onb.skippable': 'kan later',
  'onb.step.account': 'Account en taal',
  'onb.step.company': 'Bedrijf',
  'onb.step.intake': 'Toelatingsvragen',
  'onb.step.channel': 'Inloggen bij de Belastingdienst',
  'onb.step.previous': 'Vorige aangifte',
  'onb.step.bank': 'Bankafschrift',
  'onb.step.forward': 'Doorstuuradres',
  'onb.step.plan': 'Abonnement',
  'onb.step.done': 'Klaar',
  'onb.later': 'Later doen',
  'onb.chooseOne': 'Kies eerst een antwoord',
  'onb.noEntity': 'Voeg eerst een bedrijf toe.',
  'onb.account.title': 'Welkom, {name}',
  'onb.account.text': 'Je account “{account}” staat klaar. In welke taal wil je werken?',
  'onb.account.language': 'Taal',
  'onb.company.title': 'Wat is je KvK-nummer?',
  'onb.company.text': 'We zoeken je bedrijf op en vullen de rest voor je in.',
  'onb.company.kvk': 'KvK-nummer',
  'onb.company.kvkHint': '8 cijfers',
  'onb.company.kvkInvalid': 'Een KvK-nummer heeft 8 cijfers.',
  'onb.company.looking': 'Opzoeken bij de KvK…',
  'onb.company.found': 'Gevonden. Klopt het?',
  'onb.company.notFound': 'Niet gevonden. Vul de gegevens zelf in.',
  'onb.company.lookupError': 'Opzoeken lukt nu niet. Vul de gegevens zelf in.',
  'onb.company.check': 'Controleer de gegevens',
  'onb.company.reason': 'Vul eerst het KvK-nummer en de naam in',
  'onb.intake.count': 'Vraag {n} van {total}',
  'onb.intake.okTitle': 'Goed nieuws!',
  'onb.intake.okText': 'Je bedrijf past bij BTW Kwartier.',
  'onb.intake.noTitle': 'Dit bedrijf kunnen we nog niet helpen',
  'onb.intake.noText': 'Eerlijk is eerlijk: dit valt buiten de eerste versie. Hieronder lees je waarom, wanneer dat kan veranderen en wie je nu kan helpen.',
  'onb.intake.why': 'Waarom niet',
  'onb.intake.who': 'Wie kan je nu helpen',
  'onb.intake.whoText': 'We werken samen met boekhouders die dit wél doen. We brengen je graag in contact.',
  'onb.intake.refer': 'Breng me in contact met een boekhouder',
  'onb.intake.referSubject': 'Doorverwijzing na toelatingsvragen',
  'onb.intake.referSent': 'Verstuurd. Je krijgt een bevestiging per e-mail.',
  'onb.intake.redo': 'Antwoorden aanpassen',
  'onb.channel.title.eherkenning': 'Kun je inloggen met eHerkenning?',
  'onb.channel.title.digid': 'Kun je inloggen met DigiD?',
  'onb.channel.opt.ok': 'Ja, dat werkt',
  'onb.channel.opt.applying': 'Ik heb het aangevraagd',
  'onb.channel.opt.unavailable': 'Nee, nog niet',
  'onb.channel.opt.unknown': 'Weet ik niet',
  'onb.previous.title': 'Hoe ging je aangifte over {quarter}?',
  'onb.previous.text': 'Zo sluiten we goed aan op je vorige aangifte. Je kunt dit ook later doen.',
  'onb.previous.direction': 'Moest je betalen of kreeg je geld terug?',
  'onb.previous.amount': 'Bedrag in hele euro’s',
  'onb.previous.amountHint': 'Staat in de ontvangstbevestiging of in het portaal.',
  'onb.previous.corrections': 'Er moest daarna nog iets gecorrigeerd worden',
  'onb.bank.title': 'Importeer een bankafschrift',
  'onb.bank.text': 'Met een afschrift van dit kwartaal kunnen we meteen beginnen. Per bank laten we zien hoe je het downloadt.',
  'onb.bank.done': 'Afschrift geïmporteerd',
  'onb.forward.title': 'Je eigen doorstuuradres',
  'onb.forward.text': 'Stuur facturen van {name} door naar dit adres. Binnen een minuut staan ze in BTW Kwartier.',
  'onb.forward.tip1': 'Zet een doorstuurregel in je mail voor facturen van vaste leveranciers.',
  'onb.forward.tip2': 'Bonnetjes? Maak een foto met de knop “+ Uploaden” op je telefoon.',
  'onb.plan.title': 'Kies je abonnement',
  'onb.plan.text': 'Per bedrijf per kwartaal. Opzeggen kan altijd.',
  'onb.plan.choose': 'Abonnement',
  'onb.plan.perEntity': 'per bedrijf per kwartaal, excl. btw',
  'onb.plan.cycle': 'Betaalperiode',
  'onb.plan.methods': 'Betalen met iDEAL of SEPA-incasso. Je krijgt automatisch een factuur met 21% btw.',
  'onb.plan.start': 'Start gratis kwartaal',
  'onb.done.title': 'Je bedrijf staat erin',
  'onb.done.text': 'We gaan aan de slag met je gegevens. Zodra er iets te doen is, zie je het in je overzicht.',
  'onb.done.another': '+ Volgend bedrijf toevoegen',
  'onb.done.overview': 'Naar overzicht',
  'plan.self_service': 'Zelf doen',
  'plan.self_service.desc': '€ 49 voor je eerste bedrijf, € 39 vanaf het tweede. 150 banktransacties per bedrijf per kwartaal inbegrepen, daarboven € 0,20 per transactie.',
  'plan.founder': 'Oprichtersprijs',
  'plan.founder.desc': 'Voor bèta-deelnemers: 12 maanden vaste prijs, alles van Zelf doen.',
  'plan.free_check': 'Gratis btw-check',
  'plan.free_check.desc': 'Eenmalig een lijst van wat er ontbreekt, zonder concept.',
  'cycle.quarterly': 'Per kwartaal',
  'cycle.annual': 'Per jaar (15% korting)',
  'price.entity_first': 'Eerste bedrijf',
  'price.entity_additional': 'Extra bedrijf',
  'price.entity_founder': 'Oprichtersprijs per bedrijf',
  'price.annual_discount': 'Jaarkorting 15%',
  'price.overage': 'Extra transacties',
  'price.advisor_review': 'Controle door adviseur',
  'price.beta_free': 'Bèta: eerste aangiftekwartaal gratis',
  'price.entity_annual_extra': 'Extra bedrijf (jaartarief)',

  /* audit (§7) */
  'audit.sub': 'Wie deed wat en wanneer. Records worden alleen toegevoegd, nooit gewijzigd.',
  'audit.export': 'Exporteren (CSV)',
  'audit.chainOk': 'Keten gecontroleerd: niets is achteraf gewijzigd',
  'audit.chainBroken': 'De controle van het logboek klopt niet',
  'audit.chainBrokenText': 'We hebben ons team gewaarschuwd. Je gegevens zijn veilig; we nemen contact met je op.',
  'audit.actor': 'Wie',
  'audit.actor.all': 'Iedereen',
  'audit.actor.user': 'Mensen',
  'audit.actor.ai': 'AI',
  'audit.actor.advisor': 'Adviseur',
  'audit.actor.system': 'Systeem',
  'audit.action': 'Actie',
  'audit.actionPlaceholder': 'bijv. question.answered',
  'audit.empty': 'Geen records gevonden',
  'audit.end': 'Dit is het begin van het logboek.',
  'audit.showChange': 'Toon wijziging',
  'audit.hideChange': 'Verberg wijziging',
  'audit.before': 'Voor',
  'audit.after': 'Na',

  /* settings (§7) */
  'settings.tabsAria': 'Instellingen',
  'settings.tab.profile': 'Profiel & beveiliging',
  'settings.tab.members': 'Leden',
  'settings.tab.banks': 'Bankrekeningen',
  'settings.tab.billing': 'Abonnement & facturen',
  'settings.tab.rules': 'Mijn regels',
  'settings.tab.notifications': 'Meldingen',
  'settings.tab.display': 'Taal & weergave',
  'settings.profile.title': 'Profiel',
  'settings.profile.emailHint': 'Je e-mailadres wijzigen? Neem contact op met support.',
  'totp.verifyFirst.title': 'Bevestig eerst je e-mailadres',
  'totp.verifyFirst.text': 'Tweestapsverificatie kun je aanzetten zodra {email} bevestigd is. Klik op de link in de bevestigingsmail.',
  'totp.verifyFirst.resend': 'Stuur de bevestigingsmail opnieuw',
  'totp.verifyFirst.sent': 'Bevestigingsmail verstuurd. Bekijk ook je spammap.',
  'totp.verifyFirst.already': 'Je e-mailadres is al bevestigd. Herlaad de pagina.',
  'error.email_unverified': 'Bevestig eerst je e-mailadres.',
  'totp.recovery.title': 'Herstelcodes',
  'totp.recovery.saveText': 'Bewaar deze codes op een veilige plek (wachtwoordmanager of geprint). Raak je je telefoon kwijt, dan log je met één van deze codes in. Elke code werkt één keer; we tonen ze maar één keer.',
  'totp.recovery.copy': 'Kopiëren',
  'totp.recovery.download': 'Downloaden (.txt)',
  'totp.recovery.saved': 'Ik heb ze bewaard',
  'totp.recovery.none': 'Geen herstelcodes meer',
  'totp.recovery.left': '{n, plural, one {# herstelcode over} other {# herstelcodes over}}',
  'totp.recovery.renew': 'Nieuwe herstelcodes maken',
  'totp.recovery.create': 'Herstelcodes maken',
  'totp.title': 'Tweestapsverificatie',
  'totp.text': 'Naast je wachtwoord vul je een code uit een app in (bijv. Google Authenticator, Microsoft Authenticator of 1Password). Verplicht om aangiftes te bevestigen.',
  'totp.isOn': 'Tweestapsverificatie staat aan',
  'totp.isOnText': 'Bij bevestigen en andere belangrijke acties vragen we om je code.',
  'totp.start': 'Instellen',
  'totp.step1': 'Open een authenticator-app op je telefoon (bijvoorbeeld Google Authenticator, Microsoft Authenticator of 1Password) en kies “account toevoegen”.',
  'totp.step2': 'Scan deze QR-code met de app.',
  'totp.step3': 'Vul de code van 6 cijfers in die de app nu laat zien.',
  'totp.secret': 'Geheime sleutel',
  'totp.copySecret': 'Kopieer geheime sleutel',
  'totp.openApp': 'Open in authenticator-app',
  'totp.qrLabel': 'QR-code om BTW Kwartier aan je authenticator-app toe te voegen',
  'totp.onPhone': 'Ben je op je telefoon? Open de app dan direct:',
  'totp.manual': 'Lukt scannen niet? Vul de sleutel zelf in',
  'totp.manualHint': 'Kies in de app “sleutel invoeren”, als account {email} en als type “op tijd gebaseerd”.',
  'totp.enable': 'Aanzetten',
  'totp.reason': 'Vul de 6 cijfers in',
  'closure.title': "Account verwijderen",
  'closure.text': "Je abonnement stopt direct en het account wordt alleen-lezen; vooruitbetaalde tijd vervalt. Je hebt daarna {days} dagen om alles te exporteren. {warn} dagen vóór het verwijderen krijgen alle leden een e-mail. Daarna verwijderen wij alle gegevens: documenten en originelen, bankafschriften en transacties, aangiftes, vragen, regels en AI-uitkomsten. Back-ups zijn binnen {backup} dagen schoon.",
  'closure.keep': "Wij bewaren alleen wat wij zelf {years} jaar moeten bewaren: onze facturen aan jou, je akkoord met de voorwaarden, de bevestigingen van je aangiftes en verwijzingen in het logboek (geen documenten of transacties). De fiscale bewaarplicht ligt bij jou: exporteer op tijd.",
  'closure.start': "Account verwijderen…",
  'closure.ownerOnly': "Alleen de eigenaar kan het account verwijderen",
  'closure.totpFirst': "Zet eerst tweestapsverificatie aan",
  'closure.dialogTitle': "Account en alle gegevens verwijderen?",
  'closure.dialogText': "Het account wordt nu alleen-lezen en je abonnement stopt. Over {days} dagen verwijderen wij alle gegevens. Tot die datum kun je alles exporteren en het verzoek intrekken. Je bevestigt zo met je tweestapscode.",
  'closure.typeName': "Typ de naam van het account ter bevestiging: {name}",
  'closure.nameWrong': "De naam klopt niet",
  'closure.confirm': "Account verwijderen",
  'closure.requested': "Verzoek ontvangen. We hebben je een e-mail gestuurd.",
  'closure.scheduled': "Dit account wordt op {date} verwijderd",
  'closure.scheduledUser': "Je hebt gevraagd het account te verwijderen. Het is alleen-lezen: exporteer wat je wilt bewaren. {warn} dagen vooraf sturen we nog een e-mail. Toch blijven? Trek het verzoek in.",
  'closure.scheduledEnded': "Je abonnement is beëindigd. Je hebt {days} dagen om je gegevens te exporteren; {warn} dagen vooraf sturen we een e-mail. Toch verder? Kies opnieuw een abonnement.",
  'closure.scheduledInactive': "Dit gratis account is {months} maanden niet gebruikt en staat daarom op de lijst om te verwijderen. Doordat je nu bent ingelogd, stoppen we dat automatisch binnen een kwartier.",
  'closure.export': "Naar de historie (exporteren)",
  'closure.withdraw': "Verzoek intrekken",
  'closure.withdrawn': "Verzoek ingetrokken. Kies een abonnement om weer verder te werken.",
  'closure.choosePlan': "Abonnement kiezen",
  'ops.closures': "Verwijderingen",
  'ops.closure.reason': "Reden",
  'ops.closure.status': "Status",
  'ops.closure.window': "Exportperiode",
  'ops.closure.warned': "Gewaarschuwd",
  'ops.closure.result': "Afgerond",
  'ops.closure.deletedAccount': "(verwijderd account)",
  'ops.closure.userRequest': "Verzoek van de klant",
  'ops.closure.subscriptionEnded': "Abonnement beëindigd",
  'ops.closure.inactive': "12 maanden inactief (gratis check)",
  'ops.closure.scheduled': "Gepland",
  'ops.closure.deleted': "Verwijderd",
  'ops.closure.withdrawn': "Ingetrokken",
  'ops.closure.blocked': "Wacht: {reason}",
  'ops.closure.summary': "{blobs} bestanden, {documents} documenten, {transactions} transacties",
  'totp.enabled': 'Tweestapsverificatie staat aan',
  'totp.wrong': 'Deze code klopt niet. Controleer de tijd op je telefoon en probeer de nieuwste code.',
  'members.invite': 'Iemand uitnodigen',
  'members.role': 'Rol',
  'members.roleDesc.owner': 'Mag alles, ook bevestigen, leden en abonnement beheren.',
  'members.roleDesc.member': 'Mag documenten uploaden en vragen beantwoorden. Ziet geen privédetails.',
  'members.allEntities': 'Alle bedrijven',
  'members.privateNote': 'Leden zien privébetalingen alleen als “Privé · bedrag”.',
  'members.send': 'Uitnodiging versturen',
  'members.invited': 'Uitnodiging verstuurd naar {email}',
  'members.you': 'jij',
  'members.twofaOn': '2FA aan',
  'members.twofaOff': '2FA uit',
  'members.pending': 'Uitgenodigd op {date}',
  'members.ownerOnly': 'Alleen de eigenaar kan leden uitnodigen.',
  'members.removeAria': '{name} verwijderen',
  'members.removeTitle': 'Lid verwijderen?',
  'members.removeText': '{name} heeft daarna geen toegang meer tot dit account. Wat diegene heeft gedaan, blijft in het logboek staan.',
  'members.removeAction': 'Lid verwijderen',
  'members.removed': 'Lid verwijderd',
  'billing.plan': 'Je abonnement',
  'billing.planName': 'Abonnement',
  'billing.cycle': 'Betaalperiode',
  'billing.entities': 'Bedrijven',
  'billing.nextCharge': 'Volgende afschrijving',
  'billing.locked': 'Prijs vast tot',
  'billing.line': 'Omschrijving',
  'billing.qty': 'Aantal',
  'billing.amount': 'Bedrag',
  'billing.subtotal': 'Subtotaal',
  'billing.vat': 'Btw 21%',
  'billing.total': 'Totaal',
  'billing.invoices': 'Facturen',
  'billing.noInvoices': 'Nog geen facturen.',
  'billing.pdfAria': 'Factuur {number} als pdf',
  'billing.cancel': 'Abonnement opzeggen',
  'billing.cancelTitle': 'Abonnement opzeggen?',
  'billing.cancelText': 'Aangiftes die al lopen kun je nog afronden. Daarna wordt alles alleen-lezen; je kunt je gegevens altijd exporteren. We vragen je om je code.',
  'billing.cancelAction': 'Abonnement opzeggen',
  'billing.cancelled': 'Je abonnement is opgezegd',
  'invoice.open': 'Open',
  'invoice.paid': 'Betaald',
  'invoice.failed': 'Mislukt',
  'invoice.void': 'Vervallen',
  'plans.title': 'Kies je abonnement',
  'plans.sub': 'Je betaalt per aangifte die je met BTW Kwartier voorbereidt: per bedrijf, per kwartaal met activiteit. Gearchiveerde bedrijven en bedrijven die niet in aanmerking komen, betaal je niet.',
  'plans.quarterly.title': 'Per kwartaal',
  'plans.quarterly.price': '€ 49 per kwartaal, € 39 vanaf het tweede bedrijf',
  'plans.annual.title': 'Per jaar',
  'plans.annual.price': '15% korting, vier kwartalen vooruit',
  'plans.founder.title': 'Oprichtersprijs (bèta)',
  'plans.founder.price': '€ 29 per bedrijf per kwartaal, 12 maanden vast',
  'plans.exVat': 'Alle prijzen excl. 21% btw.',
  'plans.betaFree': 'Bèta: het eerste kwartaal waarin je een aangifte bevestigt, is gratis, voor al je bedrijven. Kies je nu al een abonnement, dan verlies je dat gratis kwartaal niet. Nu geef je alleen een machtiging voor automatische incasso.',
  'plans.mandateNote': 'De eerste betaling doe je met iDEAL. Daarmee geef je ook een machtiging, zodat volgende facturen automatisch worden afgeschreven.',
  'plans.payer': 'Factuur op naam van',
  'plans.payerHint': 'Dit bedrijf betaalt en staat als afnemer op je facturen, met adres en btw-id.',
  'plans.payerNoAddress': 'Vul eerst het adres van {name} in: het moet op de factuur staan.',
  'plans.payerEdit': 'Adres invullen',
  'plans.estimate': 'Nu {n, plural, one {# bedrijf} other {# bedrijven}}: hooguit {amount} per kwartaal excl. btw',
  'plans.choose': 'Abonnement kiezen en betalen',
  'plans.save': 'Wijziging opslaan',
  'plans.change': 'Abonnement wijzigen',
  'plans.changed': 'Je abonnement is aangepast. Het geldt vanaf de volgende afrekening.',
  'plans.started': 'Gelukt: je abonnement is actief.',
  'plans.redirecting': 'Je gaat naar de betaalpagina…',
  'plans.noCompanies': 'Voeg eerst een bedrijf toe.',
  'plans.chosen': 'Gekozen',
  'paywall.no_plan.title': 'Kies een abonnement om deze aangifte voor te bereiden',
  'paywall.no_plan.text': 'Zonder abonnement kun je je gegevens uploaden en één keer de gratis btw-check doen. Het concept, de controle en het indienen horen bij een abonnement.',
  'paywall.payment_pending.title': 'Rond je eerste betaling af',
  'paywall.payment_pending.text': 'Je hebt een abonnement gekozen, maar de eerste betaling (je machtiging) is nog niet gelukt. Daarna kun je meteen verder.',
  'paywall.suspended.title': 'Je abonnement is gepauzeerd',
  'paywall.suspended.text': 'We konden je factuur na drie pogingen niet afschrijven. Betaal nu om weer aangiftes voor te bereiden en in te dienen. Je gegevens blijven bewaard.',
  'paywall.choose': 'Abonnement kiezen',
  'paywall.pay': 'Nu betalen',
  'paywall.finish': 'Betaling afronden',
  'paywall.askOwner': 'Vraag de eigenaar van het account om dit te regelen.',
  'paywall.freeCheck': 'Gratis btw-check doen',
  'paywall.freeCheckUsed': 'Je hebt de gratis btw-check al gebruikt.',
  'paywall.freeCheckTitle': 'Gratis btw-check: wat ontbreekt er nog',
  'paywall.freeCheckNone': 'Er ontbreekt niets in je gegevens van dit kwartaal.',
  'paywall.freeCheckNote': 'De check laat alleen zien wat ontbreekt, zonder bedragen of concept.',
  'planPrompt.no_plan': 'Je hebt nog geen abonnement. Kies er een om je aangifte te laten voorbereiden.',
  'planPrompt.payment_pending': 'Je eerste betaling is nog niet afgerond.',
  'planPrompt.suspended': 'Je abonnement is gepauzeerd tot de openstaande factuur betaald is.',
  'banner.pending.title': 'Eerste betaling nog niet afgerond',
  'banner.pending.text': 'Tot die gelukt is, kun je alleen gegevens uploaden en de gratis btw-check doen.',
  'banner.suspended.title': 'Je abonnement is gepauzeerd',
  'banner.suspended.text': 'Voorbereiden en indienen staan stil tot de openstaande factuur betaald is. Je gegevens blijven bewaard.',
  'banner.cancelled.title': 'Je abonnement is opgezegd',
  'banner.cancelled.text': 'Tot het einde van de betaalde periode werk je gewoon verder. Daarna wordt alles alleen-lezen en blijft exporteerbaar.',
  'billing.payer': 'Op naam van',
  'billing.payerChange': 'Ander bedrijf kiezen',
  'billing.payerSaved': 'De volgende facturen staan op naam van {name}.',
  'billing.mandate': 'Automatische incasso',
  'billing.mandate.none': 'Nog niet geregeld',
  'billing.mandate.pending': 'Wacht op de eerste betaling',
  'billing.mandate.valid': 'Machtiging actief',
  'billing.mandate.invalid': 'Machtiging ongeldig: betaal opnieuw via iDEAL',
  'billing.betaQuarter': 'Gratis kwartaal',
  'billing.betaQuarterPending': 'Het eerste kwartaal waarin je een aangifte bevestigt',
  'billing.paidThrough': 'Vooruitbetaald t/m',
  'billing.cancelEffective': 'Werkt nog tot',
  'billing.dunning.title': 'Betaling mislukt',
  'billing.dunning.text': 'We proberen het opnieuw op {date} (poging {attempt} van {max}). Je kunt ook nu meteen betalen.',
  'billing.dunning.textNoRetry': 'Betaal de openstaande factuur om verder te gaan.',
  'billing.dunning.due': 'Openstaand',
  'billing.payNow': 'Nu betalen',
  'billing.periods': 'Gefactureerde aangiftes',
  'billing.periodsHint': 'Je betaalt per aangifte: een kwartaal van een bedrijf telt zodra je de cijfers in de app bevestigt. Nihilaangiftes betaal je niet.',
  'billing.periodsEmpty': 'Nog geen aangiftes gefactureerd.',
  'billing.event.pending': 'Op de volgende factuur',
  'billing.event.invoiced': 'Gefactureerd',
  'billing.event.free_beta': 'Bèta: eerste aangiftekwartaal gratis',
  'billing.event.prepaid': 'Vooruitbetaald',
  'billing.event.void': 'Gecrediteerd',
  'billing.creditNote': 'Creditnota',
  'billing.creditFor': 'bij {number}',
  'billing.estimate': 'Indicatie per kwartaal (als alle bedrijven activiteit hebben)',
  'billing.paid': 'Betaling gelukt',
  'billing.returned': 'Terug van de betaalpagina. Het kan een paar seconden duren voordat je betaling verwerkt is.',
  'entities.archive': 'Archiveren',
  'entities.archiveTitle': '{name} archiveren?',
  'entities.archiveText': 'Het bedrijf verdwijnt uit je overzichten, krijgt geen herinneringen meer en wordt niet meer gefactureerd. Alle gegevens blijven bewaard (7 jaar) en je kunt het later terugzetten.',
  'entities.archivedTitle': 'Gearchiveerde bedrijven',
  'entities.unarchive': 'Terugzetten',
  'entities.archivedDone': '{name} is gearchiveerd',
  'entities.unarchivedDone': '{name} is teruggezet',
  'entities.archivePayer': 'Dit bedrijf betaalt je abonnement. Kies eerst een ander bedrijf als betaler onder Abonnement.',
  'entities.archivedOn': 'Gearchiveerd op {date}',
  'auth.invite.code': 'Uitnodigingscode',
  'auth.invite.hint': 'Tijdens de bèta maak je alleen met een uitnodiging een account.',
  'auth.invite.invite_required': 'Vul je uitnodigingscode in.',
  'auth.invite.invite_invalid': 'Deze uitnodigingscode klopt niet.',
  'auth.invite.invite_expired': 'Deze uitnodigingscode is verlopen.',
  'auth.invite.invite_used_up': 'Deze uitnodigingscode is al gebruikt.',
  'ops.tab.invites': 'Uitnodigingen',
  'ops.kvk': 'KvK-controle',
  'ops.kvk.intro': 'Er is geen koppeling met de KVK. Vergelijk de ingevulde gegevens met het Handelsregister en leg het resultaat vast.',
  'ops.kvk.empty': 'Geen bedrijven om te controleren.',
  'ops.kvk.col.kvk': 'KvK',
  'ops.kvk.col.company': 'Bedrijf',
  'ops.kvk.col.address': 'Adres',
  'ops.kvk.col.created': 'Toegevoegd',
  'ops.kvk.col.status': 'Status',
  'ops.kvk.col.action': 'Controle',
  'ops.kvk.pending': 'Te controleren',
  'ops.kvk.ok': 'Klopt',
  'ops.kvk.mismatch': 'Klopt niet',
  'ops.kvk.open': 'Open in KVK',
  'ops.kvk.note': 'Notitie (optioneel, zichtbaar voor de klant)',
  'ops.kvk.markOk': 'Klopt',
  'ops.kvk.markMismatch': 'Klopt niet',
  'ops.kvk.saved': 'Controle opgeslagen',
  'ops.kvk.archived': 'gearchiveerd',
  'ops.inv.title': 'Uitnodigingscodes',
  'ops.inv.create': 'Code maken',
  'ops.inv.maxUses': 'Aantal keer te gebruiken',
  'ops.inv.expiresOn': 'Geldig t/m',
  'ops.inv.note': 'Notitie (voor wie)',
  'ops.inv.code': 'Nieuwe code — alleen nu zichtbaar',
  'ops.inv.uses': '{uses} van {max} gebruikt',
  'ops.inv.revoke': 'Intrekken',
  'ops.inv.revoked': 'Ingetrokken',
  'ops.inv.expired': 'Verlopen',
  'ops.inv.usedUp': 'Opgebruikt',
  'ops.inv.active': 'Actief',
  'ops.inv.empty': 'Nog geen codes.',
  'ops.inv.until': 't/m {date}',
  'rules.sub': 'Gemaakt met “Vanaf nu altijd zo”. Intrekken geldt alleen voor kwartalen die je nog niet hebt bevestigd.',
  'rules.empty': 'Nog geen regels',
  'rules.emptyText': 'Vink bij een vraag “Vanaf nu altijd zo” aan, dan hoef je dezelfde vraag niet nog eens te beantwoorden.',
  'rules.sentence': 'Betalingen aan {what}: {result}',
  'rules.result.business': 'altijd zakelijk',
  'rules.result.private': 'altijd privé',
  'rules.result.entity': 'altijd bij {name}',
  'rules.applied': '{n}× toegepast',
  'rules.meta': 'door {by} op {date} · geldt vanaf {from}',
  'rules.revoke': 'Regel intrekken',
  'rules.revokeTitle': 'Regel intrekken?',
  'rules.revokeAction': 'Regel intrekken',
  'rules.impact': 'Deze regel geldt voor {n} transacties in {quarters}; die worden opnieuw beoordeeld.',
  'rules.locked': 'Al bevestigde kwartalen ({quarters}) blijven zoals ze zijn.',
  'rules.onlyUnauthorised': 'Alleen kwartalen die nog niet bevestigd zijn, veranderen mee.',
  'rules.revoked': 'Regel ingetrokken',
  'notifSettings.title': 'Hoe wil je meldingen krijgen?',
  'notifSettings.channel.in_app': 'In BTW Kwartier',
  'notifSettings.channel.email': 'E-mail',
  'notifSettings.channel.push': 'Pushmeldingen',
  'notifSettings.channelDesc.in_app': 'De bel rechtsboven',
  'notifSettings.channelDesc.email': 'Start van het kwartaal, ontbrekende documenten, deadline (14/7/3/1 dagen)',
  'notifSettings.channelDesc.push': 'Op je telefoon of computer',
  'notifSettings.quiet': 'Tussen {from} en {to} sturen we niets.',
  'notifSettings.noAmounts': 'Meldingen bevatten nooit bedragen.',
  'notifSettings.pushTitle': 'Pushmeldingen op dit apparaat',
  'notifSettings.pushText': 'Krijg een seintje als er vragen klaarstaan of de deadline nadert.',
  'notifSettings.pushEnable': 'Pushmeldingen aanzetten',
  'notifSettings.pushOn': 'Pushmeldingen staan aan op dit apparaat',
  'notifSettings.pushDenied': 'Je browser blokkeert meldingen',
  'notifSettings.pushDeniedText': 'Sta meldingen toe voor BTW Kwartier in de instellingen van je browser.',
  'notifSettings.pushUnsupported': 'Deze browser ondersteunt geen pushmeldingen.',
  'notifSettings.iosTitle': 'Eerst op je beginscherm zetten',
  'notifSettings.iosText': 'Op een iPhone werken meldingen pas als je BTW Kwartier op je beginscherm zet: tik op Deel en kies “Zet op beginscherm”.',
  'display.language': 'Taal',
  'display.languageHint': 'Alleen voor jou. Andere leden kiezen hun eigen taal.',
  'display.theme': 'Weergave',
  'display.theme.light': 'Licht',
  'display.theme.dark': 'Donker',
  'display.theme.system': 'Zoals je apparaat',
  'display.largeText': 'Grote tekst',
  'display.largeTextHint': 'Alle tekst 25% groter',

  /* auth (§7.2) */
  'auth.tagline': 'Je btw-aangifte in een kwartier.',
  'auth.point1': 'AI helpt je voorbereiden, jij controleert en dient in.',
  'auth.point2': 'Je beantwoordt alleen vragen over je eigen zaak, niet over belastingregels.',
  'auth.point3': 'Elk bedrag terug te voeren op je bankafschrift en factuur.',
  'auth.loginTitle': 'Inloggen',
  'auth.loginText': 'Welkom terug.',
  'auth.email': 'E-mailadres',
  'auth.password': 'Wachtwoord',
  'auth.passwordHint': 'Minstens 10 tekens. Een wachtwoordmanager mag.',
  'auth.passwordShort': 'Kies een wachtwoord van minstens 10 tekens.',
  'auth.login': 'Inloggen',
  'auth.magic': 'Stuur me een inloglink',
  'auth.magicHint': 'Je krijgt een link die 15 minuten geldig is.',
  'auth.magicSent': 'Kijk in je mail',
  'auth.magicSentText': 'Als {email} bij ons bekend is, staat er nu een inloglink in je inbox.',
  'auth.withPassword': 'Inloggen met wachtwoord',
  'auth.wrongCredentials': 'Dit e-mailadres en wachtwoord passen niet bij elkaar.',
  'auth.totpTitle': 'Nog één stap',
  'auth.totpText': 'Vul de code uit je authenticator-app in.',
  'auth.verify': 'Bevestigen',
  'auth.noAccount': 'Nog geen account?',
  'auth.registerLink': 'Maak er een aan',
  'auth.haveAccount': 'Heb je al een account?',
  'auth.loginLink': 'Inloggen',
  'auth.registerTitle': 'Maak je account',
  'auth.registerText': 'Daarna voeg je je eerste bedrijf toe.',
  'auth.name': 'Je naam',
  'auth.accountName': 'Naam van je account',
  'auth.accountNameHint': 'Bijv. de naam van je groep. Hier vallen al je bedrijven onder.',
  'auth.termsReason': 'Ga eerst akkoord met de voorwaarden',
  'auth.register': 'Account maken',
  'invite.title': 'Uitnodiging voor {account}',
  'invite.text': 'Je bent uitgenodigd met {email}.',
  'invite.accept': 'Uitnodiging accepteren',
  'invite.invalid': 'Deze uitnodiging werkt niet meer',
  'invite.invalidText': 'Misschien is hij verlopen of al gebruikt. Vraag om een nieuwe uitnodiging.',
  'authLink.checking': 'Je wordt ingelogd…',
  'authLink.invalid': 'Deze inloglink werkt niet meer',
  'authLink.invalidText': 'Een inloglink is 15 minuten geldig en werkt maar één keer. Vraag een nieuwe aan.',
  'authLink.toLogin': 'Naar inloggen',
  'verifyEmail.checking': 'Je e-mailadres wordt bevestigd…',
  'verifyEmail.done': 'Je e-mailadres is bevestigd',
  'verifyEmail.invalid': 'Deze bevestigingslink werkt niet meer',
  'verifyEmail.invalidText': 'De link is 24 uur geldig en werkt maar één keer.',
  'verifyEmail.continue': 'Verder',

  /* ops back office (PRD §7) */
  'ops.sub': 'Alleen voor medewerkers van BTW Kwartier.',
  'ops.privacy': 'Je ziet hier alleen metadata. Uitzonderingen: de wachtrij Doorverwijzingen toont de contactgegevens die een klant uitdrukkelijk heeft toegestaan te delen met een partner-accountant, en KvK-controle toont de ingevulde bedrijfsgegevens (naam, KvK-nummer, rechtsvorm, adres) om ze te vergelijken met het Handelsregister. Andere klantgegevens zie je alleen via een tijdelijke, gelogde toegang bij een bestelde controle.',
  'ops.accounts': 'Accounts',
  'ops.review': 'Controlewachtrij',
  'ops.tickets': 'Tickets',
  'ops.rules': 'Regelbibliotheek',
  'ops.templates': 'Bankformaten',
  'ops.notifications': 'Verzonden meldingen',
  'ops.quality': 'Kwaliteit',
  'ops.none': 'Nog geen accounts',
  'ops.since': 'sinds {date}',
  'ops.col.account': 'Account',
  'ops.col.entities': 'Bedrijven',
  'ops.col.plan': 'Abonnement',
  'ops.col.periods': 'Aangiftes',
  'ops.col.lastActivity': 'Laatst actief',
  'ops.col.bank': 'Bank',
  'ops.col.format': 'Formaat',
  'ops.col.version': 'Versie',
  'ops.col.headers': 'Kolommen',
  'ops.col.status': 'Status',
  'ops.col.sentAt': 'Verzonden',
  'ops.col.kind': 'Soort',
  'ops.col.channel': 'Kanaal',
  'ops.reviewEmpty': 'Geen bestelde controles',
  'ops.orderedOn': 'besteld {date}',
  'ops.dueBy': 'klaar vóór {date}',
  'ops.escalated': 'Opgeschaald',
  'ops.claim': 'Oppakken',
  'ops.complete': 'Afronden',
  'ops.completeTitle': 'Controle afronden',
  'ops.notes': 'Conclusie voor de klant',
  'ops.notesHint': 'Wordt in het logboek vastgelegd en aan de klant getoond.',
  'ops.ticketsEmpty': 'Geen open tickets',
  'ops.reply': 'Antwoorden',
  'ops.replyClose': 'Antwoorden en sluiten',
  'ops.replyLabel': 'Je antwoord',
  'ops.rule.pattern': 'Patroon',
  'ops.rule.field': 'Veld',
  'ops.rule.treatment': 'Verwerking',
  'ops.rule.note': 'Notitie',
  'ops.rule.add': 'Regel toevoegen',
  'ops.q.entities': 'Bedrijven dit kwartaal',
  'ops.q.cards': 'Vragen per bedrijf',
  'ops.q.override': 'AI-voorstel overschreven',
  'ops.q.findings': 'Controle vond verschil',
  'ops.q.aiCost': 'AI-kosten per bedrijf',
  'ops.q.answerTime': 'Mediane antwoordtijd',
  'ops.q.answerTarget': 'Doel: ≤ 15 seconden',
  'ops.q.seconds': '{n} s',
  'ticket.channel.in_app': 'In de app',
  'ticket.channel.email': 'E-mail',
  'ticket.channel.whatsapp': 'WhatsApp',
  'ticket.channel.wechat': 'WeChat',
  'ticket.status.open': 'Open',
  'ticket.status.pending': 'Wacht op klant',
  'ticket.status.closed': 'Gesloten',

  /* treatments (rules engine) */
  'treatment.sale_nl_21': 'Verkoop 21%',
  'treatment.sale_nl_9': 'Verkoop 9%',
  'treatment.sale_nl_other': 'Verkoop overig tarief',
  'treatment.sale_nl_0_or_not_taxed': 'Verkoop 0% of btw verlegd',
  'treatment.sale_eu_b2b_service': 'Dienst aan bedrijf in de EU',
  'treatment.sale_noneu_b2b_service': 'Dienst aan bedrijf buiten de EU',
  'treatment.private_use': 'Privégebruik',
  'treatment.purchase_nl': 'Inkoop met Nederlandse btw',
  'treatment.purchase_reverse_charge_nl': 'Inkoop met btw verlegd',
  'treatment.purchase_eu_service': 'Dienst uit de EU',
  'treatment.purchase_noneu_service': 'Dienst van buiten de EU',
  'treatment.no_vat': 'Zonder btw (loon, bank, verzekering)',
  'treatment.private': 'Privé',
  'treatment.internal_transfer': 'Overboeking tussen eigen rekeningen',
  'treatment.sale_export_goods': 'Uitvoer van goederen',
  'treatment.sale_eu_goods': 'Levering van goederen in de EU',
  'treatment.sale_eu_distance': 'Verkoop op afstand (OSS)',
  'treatment.purchase_eu_goods': 'Inkoop van goederen uit de EU',
  'treatment.purchase_import_goods': 'Invoer van goederen',
  'treatment.import_vat_paid': 'Invoer-btw betaald',
  'treatment.import_vat_deferred': 'Invoer-btw verlegd (artikel 23)',
  'treatment.mixed_use_pro_rata': 'Gemengd gebruik (pro rata)',
  'treatment.real_estate': 'Onroerend goed',
  'treatment.margin_scheme': 'Margeregeling',
  'treatment.purchase_non_deductible': 'Inkoop zonder btw-aftrek (horeca, geschenken)',
  'treatment.purchase_foreign_vat': 'Buitenlandse btw (niet in deze aangifte)',
  'treatment.correction': 'Correctie uit eerder kwartaal',

  /* 2026-10 redesign: navigation, company switcher, kit, landing page */
  'nav.thisQuarter': 'Dit kwartaal',
  'nav.files': 'Documenten',
  'nav.history': 'Historie',
  'nav.me': 'Account',
  'nav.search': 'Zoeken',
  'nav.main': 'Hoofdnavigatie',
  'side.label': 'Menu',
  'side.overview': 'Overzicht',
  'side.questions': 'Vragen',
  'side.openCount': '{n, plural, one {# open vraag} other {# open vragen}}',
  'side.documents': 'Documenten',
  'side.bank': 'Bankafschriften',
  'side.vat': 'Btw-aangifte',
  'side.history': 'Historie',
  'side.companies': 'Bedrijven',
  'side.settings': 'Instellingen',
  'home.sum.title': 'Btw-overzicht (concept)',
  'home.sum.section': 'Rubriek',
  'home.sum.amount': 'Bedrag',
  'home.sum.due': 'Verschuldigde btw',
  'home.sum.input': 'Voorbelasting',
  'home.sum.concept': 'Concept — jij controleert het voordat je indient',
  'company.add': 'Bedrijf toevoegen',
  'company.listLabel': 'Je bedrijven',
  'company.switchLabel': 'Bedrijf: {name}. Wissel van bedrijf',
  'company.switchTo': 'Ga naar {name}',
  'company.current': 'Huidig bedrijf',
  'company.status.collecting': 'Stap 1 · Stukken aanleveren',
  'company.status.questions_open': 'Stap 2 · {n, plural, one {Nog # vraag} other {Nog # vragen}}',
  'company.status.in_review': 'Stap 3 · Wordt nagekeken',
  'company.status.draft_ready': 'Stap 3 · Klaar om te controleren',
  'company.status.review_differences': 'Stap 3 · {n, plural, one {# verschil bekijken} other {# verschillen bekijken}}',
  'company.status.ready_to_file': 'Stap 3 · Klaar om in te dienen',
  'company.status.filed': 'Ingediend · bevestiging uploaden',
  'company.status.closed': '✓ Afgerond',
  'company.status.out_of_scope': 'Niet ondersteund · boekhouder nodig',
  'company.status.not_required': 'KOR · geen aangifte',
  'company.status.kor.ok': 'KOR · {n}% van de grens',
  'company.status.kor.over': 'KOR · over de grens',
  'company.status.none': 'Nog geen aangifte',
  'kit.step.now': 'nu',
  'kit.step.done': 'klaar',
  'kit.step.current': 'huidige stap',
  'kit.step.todo': 'nog te doen',
  // ── 2026-10 redesign: Controleren en indienen (features/submit) ──
  'submit.back': "Terug naar dit kwartaal",
  'submit.eyebrow': "Stap 3 · {name} · {quarter}",
  'submit.title': "Controleren en indienen",
  'submit.pills.label': "Stappen van het indienen",
  'submit.pills.reopen': "{name} opnieuw bekijken",
  'submit.sub.check': "Bedragen controleren",
  'submit.sub.portal': "Invullen in het portaal",
  'submit.sub.receipt': "Bevestiging uploaden",
  'submit.status.portal': "Stap 3 · Invullen in het portaal",
  'submit.amount.pay': "Btw te betalen dit kwartaal",
  'submit.amount.refund': "Btw terug te krijgen dit kwartaal",
  'submit.amount.provisional': "voorlopig",
  'submit.amount.none': "Nog niet berekend: eerst je bankafschriften en facturen.",
  'submit.formula.pay': "Verschuldigd {payable} − aftrekbaar {input} = {balance}",
  'submit.formula.refund': "Verschuldigd {payable} − aftrekbaar {input} = {balance} terug",
  'submit.check.label': "Stand van zaken",
  'submit.check.tone.ok': "In orde",
  'submit.check.tone.todo': "Aandacht nodig",
  'submit.check.tone.busy': "Bezig",
  'submit.check.bank': "De bankafschriften dekken het kwartaal nog niet helemaal",
  'submit.check.collecting': "Het kwartaal is nog niet compleet",
  'submit.check.upload': "Aanvullen",
  'submit.check.questionsDone': "Alle vragen zijn beantwoord",
  'submit.check.questionsOpen': "{n, plural, one {Nog # vraag open} other {Nog # vragen open}}",
  'submit.check.answer': "Beantwoorden",
  'submit.check.reviewPassed': "Onafhankelijke controle geslaagd: een tweede AI las alle stukken opnieuw en vond dezelfde gegevens",
  'submit.check.reviewRunning': "Onafhankelijke controle loopt: een tweede AI leest alle stukken opnieuw. Dit duurt meestal een paar minuten; je hoeft hier niet te wachten.",
  'submit.check.reviewQueued': "De onafhankelijke controle start vanzelf",
  'submit.check.reviewDifferences': "{n, plural, one {De tweede AI ziet # verschil — kies hieronder wat klopt} other {De tweede AI ziet # verschillen — kies hieronder wat klopt}}",
  'submit.check.reviewFailed': "De onafhankelijke controle is niet gelukt",
  'submit.check.reviewRetry': "Opnieuw proberen",
  'submit.check.noInvoice': "{n, plural, one {# betaling heeft nog geen factuur en telt voorlopig als niet aftrekbaar} other {# betalingen hebben nog geen factuur en tellen voorlopig als niet aftrekbaar}}",
  'submit.check.importVat': '{n, plural, one {# inkoop van goederen van buiten de EU heeft nog geen invoer-btw} other {# inkopen van goederen van buiten de EU hebben nog geen invoer-btw}}. Upload de papieren van de douane of de vervoerder.',
  'submit.check.uploadImport': 'Uploaden',
  'submit.check.icp': 'Dien ook de ICP-opgaaf in',
  'submit.check.icpMonthly': 'Je leverde dit kwartaal meer dan € 50.000 aan goederen aan bedrijven in andere EU-landen. Dan doe je de ICP-opgaaf per maand (dat geldt ook als dat in een van de vier kwartalen hiervoor zo was). Vraag een adviseur.',
  'submit.icp.vatId': 'Btw-nummer',
  'submit.icp.name': 'Klant',
  'submit.icp.kind': 'Soort',
  'submit.icp.amount': 'Bedrag',
  'submit.icp.kind.goods': 'Leveringen (goederen)',
  'submit.icp.kind.services': 'Diensten',
  'submit.icp.kind.correction': 'Correctie',
  'submit.check.uploadInvoice': "Factuur uploaden",
  'submit.check.confirmedBy': "Bevestigd door {name}. Dit zijn de bedragen die je in het portaal invult.",
  'submit.check.backToCurrent': "Verder met invullen",
  'submit.check.changed': "De bedragen zijn veranderd nadat je ze bevestigde (concept #{from} → #{to}). Controleer ze opnieuw en bevestig nog een keer.",
  'submit.diff.lead': "Kies per verschil wat klopt. Je hoeft niets uit te leggen.",
  'submit.boxes.title': "De bedragen voor je aangifte",
  'submit.boxes.lead': "In dezelfde volgorde als in Mijn Belastingdienst. Klik op een regel om de transacties en documenten erachter te zien.",
  'submit.boxes.col.box': "Rubriek",
  'submit.boxes.col.what': "Omschrijving",
  'submit.boxes.col.amount': "Bedrag",
  'submit.boxes.col.vat': "Btw",
  'submit.boxes.drillAria': "Rubriek {box}, {name}: bekijk de transacties en documenten",
  'submit.boxes.zeroRest': "{n, plural, one {De overige # rubriek is € 0, die laat je in het portaal leeg} other {De overige # rubrieken zijn € 0, die laat je in het portaal leeg}}",
  'submit.boxes.showAll': "Alle {n} rubrieken tonen",
  'submit.boxes.showLess': "Alleen rubrieken met een bedrag tonen",
  'submit.box.5a': "Verschuldigde btw, totaal",
  'submit.box.5b': "{n, plural, one {Aftrekbare voorbelasting (# post)} other {Aftrekbare voorbelasting (# posten)}}",
  'submit.box.5gPay': "Te betalen dit kwartaal",
  'submit.box.5gRefund': "Terug te krijgen dit kwartaal",
  'submit.confirm.label': "Bevestigen",
  'submit.confirm.statement': "Ik heb deze bedragen bekeken. De bankafschriften, facturen en antwoorden die ik voor {name} heb gegeven, zijn naar mijn beste weten volledig en juist. Ik dien de aangifte zelf in via Mijn Belastingdienst Zakelijk en ben zelf verantwoordelijk voor wat ik indien.",
  'submit.confirm.button': "Bevestigen en naar het portaal",
  'submit.confirm.hint': "Je vult hierbij één keer je tweestapscode in. Veranderen de bedragen daarna, dan bevestig je opnieuw.",
  'submit.confirm.reauthReason': "Je bevestigt de bedragen van deze aangifte. Vul de code uit je authenticator-app in.",
  'submit.confirm.done': "Bevestigd. Vul nu de bedragen in het portaal in.",
  'submit.confirm.changed': "De bedragen zijn net veranderd. Controleer ze opnieuw.",
  'submit.confirm.reason.tick': "Vink eerst de verklaring aan",
  'submit.confirm.reason.role': "Alleen de eigenaar of de aangifteverantwoordelijke kan bevestigen",
  'submit.confirm.reason.step1': "Eerst je bankafschriften en facturen voor het hele kwartaal",
  'submit.confirm.reason.step2': "{n, plural, one {Beantwoord eerst nog # vraag} other {Beantwoord eerst nog # vragen}}",
  'submit.confirm.reason.review': "Wacht tot de onafhankelijke controle klaar is",
  'submit.confirm.reason.differences': "{n, plural, one {Kies eerst bij # verschil wat klopt} other {Kies eerst bij # verschillen wat klopt}}",
  'submit.confirm.reason.yearEnd': "Beantwoord eerst de drie vragen voor het einde van het jaar",
  'submit.confirm.reason.totp': "Zet eerst tweestapsverificatie aan.",
  'submit.portal.title': "Vul de bedragen in Mijn Belastingdienst Zakelijk in",
  'submit.portal.copy': "Neem de bedragen hieronder rubriek voor rubriek over (de kopieerknop kopieert hele euro’s zonder punten) en vink elke rubriek aan.",
  'submit.portal.send': "Verstuur de aangifte in het portaal en kom terug voor de bevestiging.",
  'submit.portal.rowsLabel': "Rubrieken om in te vullen",
  'submit.portal.computed': "Berekent het portaal zelf — vergelijk het bedrag",
  'submit.portal.typed': "Ingevuld",
  'submit.portal.same': "Klopt",
  'submit.portal.tickAria': "Rubriek {box} is ingevuld of klopt",
  'submit.portal.empty': "{n, plural, one {De overige # rubriek laat je leeg (€ 0).} other {De overige # rubrieken laat je leeg (€ 0).}}",
  'submit.portal.backToCheck': "Bedragen nog eens bekijken",
  'submit.portal.filed': "Ik heb ingediend, naar de bevestiging",
  'submit.receipt.intro': "Upload nu de ontvangstbevestiging van de Belastingdienst; dan is deze aangifte klaar.",
  'submit.receipt.submit': "Bevestiging opslaan en afronden",
  'kit.amount.none': 'Nog niet berekend',
  /* home — Dit kwartaal (2026-10, prototype Home / MobileHome) */
  'home.quarterName': '{n}e kwartaal {year}',
  'home.eyebrow': '{quarter} · {from} – {to}',
  'home.title.mobile': 'Dit kwartaal',
  'home.pill.left': 'Deadline {date} · nog {n, plural, one {# dag} other {# dagen}}',
  'home.pill.today': 'Deadline is vandaag',
  'home.pill.overdue': 'Deadline {n, plural, one {# dag} other {# dagen}} verstreken',
  'home.pill.running': 'Kwartaal loopt nog · deadline {date}',
  'home.pill.filed': 'Ingediend · bevestiging nog uploaden',
  'home.pill.closed': '✓ Afgerond · bevestiging bewaard',
  'home.kor.pill.ok': 'KOR · geen aangifte',
  'home.kor.pill.notice': 'KOR · {n}% van de grens',
  'home.kor.pill.warning': 'KOR · {n}% van de grens',
  'home.kor.pill.exceeded': 'Over de KOR-grens',
  'home.kor.label': 'Omzet {year}',
  'home.kor.note': '{n}% van de grens van € 20.000',
  'home.kor.unconfirmed': 'Waarvan {amount} nog niet bevestigd als omzet.',
  'home.kor.text.ok': 'Je doet mee aan de KOR: je doet geen btw-aangifte. We houden je omzet bij uit je bankafschriften en verkoopfacturen. Gratis.',
  'home.kor.text.notice': 'Je zit op {n}% van de grens. Houd je omzet in de gaten.',
  'home.kor.text.warning': 'Je zit dicht bij de grens. Ga je erover, dan stopt de KOR meteen bij die verkoop.',
  'home.kor.text.exceeded': 'Je omzet ging op {date} over de grens van € 20.000. Vanaf die verkoop reken je btw en doe je weer aangifte.',
  'home.kor.questions': '{n, plural, one {# ontvangst wacht op je antwoord} other {# ontvangsten wachten op je antwoord}}',
  'home.kor.foreign': '{n, plural, one {# inkoop} other {# inkopen}} uit het buitenland: misschien moet je daarover toch btw aangeven.',
  'home.kor.answer': 'Vragen beantwoorden',
  'home.kor.details': 'Bekijk de omzet',
  'kor.title': 'KOR-omzet',
  'kor.lead': 'Met de kleineondernemersregeling (KOR) doe je geen btw-aangifte, zolang je omzet in een kalenderjaar niet boven € 20.000 komt. Wij tellen je omzet uit je bankafschriften en verkoopfacturen.',
  'kor.year': 'Omzet {year}',
  'kor.progress': '{amount} van {limit} ({n}%)',
  'kor.invoiced': 'Verkoopfacturen',
  'kor.receipts': 'Ontvangsten zonder factuur (bevestigd als omzet)',
  'kor.unconfirmed': 'Ontvangsten nog niet bevestigd (tellen voorlopig mee)',
  'kor.foreignServices': 'Diensten aan bedrijven in het buitenland (tellen niet mee)',
  'kor.foreignServicesHelp': 'Een factuur aan een buitenlandse klant met een btw-nummer, zonder goederen, belast het land van de klant. Lever je toch goederen? Dan telt het wel mee; upload dan een factuur waarop dat staat.',
  'kor.foreignPurchasesTitle': 'Inkopen uit het buitenland',
  'kor.foreignPurchasesText': '{n, plural, one {# inkoop} other {# inkopen}} uit het buitenland dit jaar, bijvoorbeeld online advertenties. Over diensten uit het buitenland en goederen uit andere EU-landen moet je soms toch btw aangeven, ook met de KOR. Vraag een adviseur of je een aangifte moet doen.',
  'kor.total': 'Totaal',
  'kor.answer': 'Beantwoord de vragen',
  'kor.exceededTitle': 'Je bent over de grens',
  'kor.exceededText': 'Op {date} ging je omzet over € 20.000. De KOR stopt direct vanaf die verkoop: over die verkoop en alles daarna reken je btw. Meld je meteen af voor de KOR bij de Belastingdienst. Zet daarna hier de KOR uit; dan bereiden we je kwartaalaangiftes voor.',
  'kor.turnOff': 'KOR uitzetten',
  'kor.vatInvoicesTitle': 'Facturen met btw',
  'kor.vatInvoicesText': 'In de KOR reken je geen btw. Op deze verkoopfacturen staat toch btw; die btw moet je afdragen. Stuur je klant een gecorrigeerde factuur zonder btw, of overleg met een adviseur.',
  'kor.invoiceLine': 'Factuur {number} van {date}: {vat} btw',
  'kor.noNumber': 'zonder nummer',
  'kor.previousTitle': 'Vorig jaar ({year})',
  'kor.previousOver': 'Je omzet in {year} was hoger dan € 20.000. Dan mag je dit jaar niet meedoen aan de KOR. Controleer dit met een adviseur.',
  'kor.notesTitle': 'Goed om te weten',
  'kor.note1': 'Ontvangsten die je nog niet hebt bevestigd tellen voorlopig mee, zodat een waarschuwing nooit te laat komt.',
  'kor.note2': 'Contante verkopen en betalingen op een andere rekening zien we niet. Upload daarvoor je verkoopfacturen.',
  'kor.note3': 'Koop je diensten in het buitenland (bijvoorbeeld online advertenties) of goederen in andere EU-landen, dan moet je daarover soms toch btw aangeven. Dat doen we niet in de KOR-bewaking; vraag een adviseur.',
  'kor.free': 'De KOR-bewaking is gratis; je hebt er geen abonnement voor nodig.',
  'kor.notKor': 'Dit bedrijf doet niet mee aan de KOR.',
  'home.amount.pay': 'Te betalen btw',
  'home.amount.payEstimate': 'Verwacht te betalen',
  'home.amount.receive': 'Terug te krijgen btw',
  'home.amount.receiveEstimate': 'Verwacht terug te krijgen',
  'home.amount.provisional': 'Het bedrag staat vast zodra je de vragen hebt beantwoord.',
  'home.amount.none': 'Upload je stukken, dan rekenen wij het bedrag uit.',
  'home.amount.incomplete': 'Het bedrag kan nog veranderen tot alle stukken binnen zijn.',
  'home.amount.final': 'De cijfers staan klaar. Controleer ze en vul ze daarna in bij Mijn Belastingdienst.',
  'home.amount.filed': 'Ingediend op {date}.',
  'home.amount.filedNoDate': 'Ingediend bij de Belastingdienst.',
  'home.amount.outOfScope': 'Deze aangifte valt buiten wat BTW Kwartier kan doen. Een boekhouder kan je helpen.',
  'home.steps.label': 'Voortgang dit kwartaal',
  'home.step1.title': 'Stukken aanleveren',
  'home.step1.done': 'Bankafschriften en facturen zijn binnen',
  'home.step1.todo': 'Upload de bankafschriften en facturen van dit kwartaal',
  'home.step1.running': 'Het kwartaal loopt nog. Upload alvast wat je hebt.',
  'home.step1.bankGaps': 'Van {n, plural, one {# bankrekening} other {# bankrekeningen}} ontbreekt nog een deel van het kwartaal',
  'home.step2.title': 'Vragen beantwoorden',
  'home.step2.done': 'Alle vragen zijn beantwoord',
  'home.step2.open': '{n, plural, one {Nog # vraag} other {Nog # vragen}}',
  'home.step2.todo': 'Alleen vragen over je bedrijf, één tegelijk',
  'home.step3.title': 'Controleren en indienen',
  'home.step3.todo': 'Cijfers nakijken → invullen in Mijn Belastingdienst → bevestiging uploaden',
  'home.step3.in_review': 'Een tweede AI controleert de cijfers. Dat duurt een paar minuten.',
  'home.step3.review_differences': 'De controle ziet {n, plural, one {# verschil} other {# verschillen}}. Kies wat klopt.',
  'home.step3.portal': 'Vul de cijfers vak voor vak in bij Mijn Belastingdienst',
  'home.step3.filed': 'Ingediend. Upload de ontvangstbevestiging om af te ronden.',
  'home.step3.closed': 'Ingediend op {date} · bevestiging bewaard',
  'home.step3.closedNoDate': 'Ingediend · bevestiging bewaard',
  'home.step3.out_of_scope': 'Niet ondersteund · een boekhouder kan helpen',
  'home.action.view': 'Bekijken',
  'home.action.viewDocuments': 'Documenten bekijken',
  'home.action.viewReceipt': 'Bevestiging bekijken',
  'home.cta.upload': 'Stukken uploaden',
  'home.cta.questions': 'Vragen beantwoorden',
  'home.cta.questionsTime': 'Ongeveer {n, plural, one {# minuut} other {# minuten}}',
  'home.cta.check': 'Controleren en indienen',
  'home.cta.differences': 'Verschillen bekijken',
  'home.cta.receipt': 'Bevestiging uploaden',
  'home.cta.refer': 'Boekhouder zoeken',
  'home.busy': 'Je hoeft nu niets te doen. Kijk over een paar minuten nog eens.',
  'home.missing.purchaseLead': '{n, plural, one {# betaling heeft} other {# betalingen hebben}} nog geen factuur.',
  'home.missing.purchaseText': 'Je kunt ook zonder indienen, maar dan trek je de btw over die betalingen niet af.',
  'home.missing.sales': '{n, plural, one {# ontvangst heeft} other {# ontvangsten hebben}} nog geen verkoopfactuur.',
  'home.missing.action': 'Facturen uploaden',
  'home.aiDegraded': 'De AI is even traag. Wat met vaste regels kan, gaat gewoon door.',
  'home.others.title': 'Je andere bedrijven',
  'home.others.note': 'Per bedrijf zie je alleen de volgende stap. Klik op een naam om naar dat bedrijf te gaan.',
  'home.others.compact': '{n, plural, one {Nog # bedrijf} other {Nog # bedrijven}}',
  'home.others.show': 'Bekijken',
  'home.others.hide': 'Verbergen',
  'home.row.upload': 'Uploaden',
  'home.row.questions': 'Vragen beantwoorden',
  'home.row.check': 'Controleren',
  'home.row.receipt': 'Bevestiging',
  'home.row.view': 'Bekijken',
  'home.row.refer': 'Hulp zoeken',
  'home.row.aria': '{action} voor {name}',
  'home.empty.title': 'Voeg je eerste bedrijf toe',
  'home.empty.text': 'Met je KvK-nummer vullen we de gegevens in. Daarna zie je hier wat er dit kwartaal moet gebeuren.',
  'home.empty.action': 'Bedrijf toevoegen',
  /* questions — stap 2 (2026-10, prototype Questions) */
  'questions.back': 'Terug naar dit kwartaal',
  'questions.context': '{company} · stap 2',
  'questions.position': 'Vraag {n} van {total}',
  'questions.out': 'uitgave',
  'questions.in': 'ontvangst',
  'questions.private': 'Privé · {amount}',
  'questions.viewInvoice': 'Factuur bekijken',
  'questions.hint.ai': 'AI-voorstel',
  'questions.hint.rule': 'Volgens je regel',
  'questions.hint.advisor': 'Voorstel adviseur',
  'questions.hint.reason': 'Waarom: {reason}',
  'questions.reason.foreign_vat_on_invoice': 'er staat buitenlandse btw op de factuur',
  'questions.reason.supplier_country': 'de leverancier zit in het buitenland',
  'questions.reason.general_rate': 'de meeste goederen vallen onder 21%',
  'questions.reason.horeca_name': 'de naam lijkt op een restaurant of café',
  'questions.reason.meal_words': 'de bon noemt eten of drinken',
  'questions.reason.delivered': 'het lijkt op een bezorgde bestelling',
  'questions.reason.room_or_stay': 'de bon noemt een kamer of overnachting',
  'questions.reason.import_vat_line': 'het document noemt invoer-btw',
  'questions.reason.art23_text': 'het document noemt artikel 23 of verlegde invoer-btw',
  'questions.reason.reverse_charge_text': 'de factuur noemt “btw verlegd”',
  'questions.reason.name_on_invoice': 'de bedrijfsnaam staat op de factuur',
  'questions.unsure': 'Ik weet het niet zeker',
  'questions.unsureHint': 'Dan kiezen we de veilige kant: geen btw-aftrek voor deze post.',
  'questions.rule.payments': 'Voortaan alle betalingen aan {party} zo verwerken',
  'questions.rule.invoices': 'Voortaan alle facturen van {party} zo verwerken',
  'questions.rule.hint': 'Je kunt deze regel intrekken onder Instellingen → Mijn regels.',
  'questions.note': 'Een AI-voorstel is alleen een hint; we kiezen nooit voor je. Fout geantwoord? Maak het meteen ongedaan.',
  'questions.saved': 'Opgeslagen',
  'questions.savedRule': 'Opgeslagen · regel gemaakt',
  'questions.undo': 'Ongedaan maken',
  'questions.undone': 'Antwoord ongedaan gemaakt',
  'questions.unsureDone': 'Veilig verwerkt: geen btw-aftrek voor deze post.',
  'questions.allDone': 'Alle vragen zijn beantwoord. Het bedrag is bijgewerkt.',
  'questions.none.title': 'Geen open vragen',
  'questions.none.text': 'Voor dit bedrijf hoef je nu niets te beantwoorden.',
  'questions.later': 'Later beantwoorden',
  'questions.otherOptions': 'Andere opties',
  'questions.readOnly': 'Alleen lezen: je kunt nu geen vragen beantwoorden.',
  'questions.opt.incoming_payment.sale_21': 'Een verkoop met 21% btw',
  'questions.opt.incoming_payment.sale_9': 'Een verkoop met 9% btw',
  'questions.opt.incoming_payment.sale_0': 'Een verkoop met 0% btw',
  'questions.opt.incoming_payment.sale_with_vat': 'Een verkoop met btw',
  'questions.opt.incoming_payment.sale_reverse_charged': 'Een verkoop met btw verlegd naar de klant',
  'questions.opt.incoming_payment.sale_exempt': 'Vrijgestelde omzet (bijv. zorg, onderwijs)',
  /* history — Historie (2026-10) */
  'history.title': 'Historie',
  'history.amount.pay': 'Te betalen {amount}',
  'history.amount.receive': 'Terug {amount}',
  'history.amount.none': 'Nog geen bedrag',
  'history.filedOn': 'ingediend {date}',
  'history.open.receipt': 'Bevestiging',
  'history.open.return': 'Aangifte',
  'history.open.continue': 'Verder',
  'history.open.aria': '{action}: {quarter}',
  'history.empty.title': 'Nog geen kwartalen',
  'history.empty.text': 'Na je eerste aangifte vind je hier elk kwartaal terug, met de bevestiging van de Belastingdienst.',
  'history.note': 'Een ander bedrijf bekijken? Wissel van bedrijf met de knop bovenaan.',
  'history.recomputing': 'Wordt herberekend…',
  'dismiss.action': "Al elders ingediend / niet van toepassing",
  'dismiss.done': "{quarter} staat niet meer op je lijst. Ongedaan maken kan via Historie.",
  'dismiss.notice': "Je hebt {quarter} gemarkeerd als al elders ingediend of niet van toepassing. Je krijgt er geen herinneringen meer voor.",
  'dismiss.undo': "Ongedaan maken",
  'dismiss.undoAria': "{quarter} weer op je lijst zetten",
  'dismiss.undone': "{quarter} staat weer op je lijst.",
  'dismiss.pill': "Niet van toepassing",
  /* Sprint 2B — recompute pending (P0-8), statement coverage (P0-9), one set of figures (P0-7) */
  'recompute.title': 'Bezig met herberekenen…',
  'recompute.text': 'Er is net iets veranderd (een antwoord, document of afschrift). We rekenen de aangifte opnieuw uit; dat duurt meestal een paar seconden.',
  'recompute.reason': 'Bezig met herberekenen… wacht even op de nieuwe cijfers',
  'recompute.amount': 'Bezig met herberekenen… het bedrag wordt zo bijgewerkt.',
  'coverage.gap': 'Afschrift van {from} t/m {to} ontbreekt voor {iban}',
  'coverage.noStatement': 'Nog geen afschrift van dit kwartaal voor {iban}',
  'coverage.noAccount': 'Nog geen bankafschrift voor dit kwartaal',
  'coverage.more': '(en nog {n})',
  'submit.reconcile.label': 'Zo komt het bedrag tot stand',
  'submit.reconcile.aria': 'Optelling: {sum}',
  'import.period.title': 'Welke periode dekt dit afschrift?',
  'import.period.text': 'Dit bestand noemt zelf geen periode. Kies van welke dag tot en met welke dag het álle betalingen van de rekening bevat — dan weten we dat er niets ontbreekt.',
  'import.period.from': 'Van',
  'import.period.to': 'Tot en met',
  'import.period.quarter': 'Hele kwartaal ({quarter})',
  'import.period.invalid': 'De periode moet alle betalingen in het bestand bevatten ({first} t/m {last}) en mag niet in de toekomst eindigen.',
  'import.period.statement': 'Periode volgens het afschrift',
  'import.period.balances': 'Periode volgens de saldodatums in het afschrift',
  'landing.home': 'BTW Kwartier — home',
  'landing.nav.aria': 'Navigatie',
  'landing.nav.how': 'Zo werkt het',
  'landing.nav.price': 'Prijs',
  'landing.nav.faq': 'Veelgestelde vragen',
  'landing.nav.login': 'Inloggen',
  'landing.cta.register': 'Registreren',
  'landing.cta.login': 'Inloggen',
  'landing.hero.eyebrow': 'Voor zzp’ers en mkb · btw-aangifte per kwartaal',
  'landing.hero.title': 'Je btw-aangifte, al in een kwartier klaar',
  'landing.hero.text': 'Zet je bankafschrift en facturen erin en beantwoord een paar eenvoudige vragen over je zaak. Wij rekenen elke rubriek van de aangifte uit; jij neemt de bedragen over in Mijn Belastingdienst Zakelijk en dient zelf in.',
  'landing.hero.point1': 'Geen verstand van belasting of boekhouden nodig',
  'landing.hero.point2': 'AI zet alles klaar, vaste rekenregels bepalen de bedragen',
  'landing.hero.point3': 'Je betaalt per kwartaal en stopt wanneer je wilt',
  'landing.hero.secondary': 'Bekijk hoe het werkt',
  'landing.hero.note': 'Na registratie kun je één keer gratis checken wat er voor dit kwartaal nog ontbreekt, zonder betaalgegevens.',
  'landing.sample.aria': 'Voorbeeld van een aangifte in BTW Kwartier',
  'landing.sample.deadline': 'Deadline {date}',
  'landing.sample.toPay': 'Te betalen btw',
  'landing.sample.stepsAria': 'Voortgang in het voorbeeld',
  'landing.sample.meta1': '17 stukken',
  'landing.sample.meta2': '3 vragen, klaar',
  'landing.sample.label': 'Voorbeeld',
  'landing.how.title': 'In drie stappen van bankafschrift naar ontvangstbevestiging',
  'landing.how.text': 'Elk kwartaal dezelfde drie stappen. Wij laten steeds zien wat de volgende stap is; onthouden hoeft niet.',
  'landing.how.s1.title': 'Stukken aanleveren',
  'landing.how.s1.text': 'Download het afschrift van dit kwartaal uit je internetbankieren en sleep het samen met je facturen naar binnen. Werkt met ING, Rabobank, ABN AMRO, bunq, Knab en Revolut.',
  'landing.how.s2.title': 'Vragen beantwoorden',
  'landing.how.s2.text': 'We vragen alleen naar je zaak, bijvoorbeeld: ‘Is deze betaling zakelijk of privé?’ Eén vraag tegelijk, makkelijk op je telefoon.',
  'landing.how.s3.title': 'Controleren en indienen',
  'landing.how.s3.text': 'Je ziet meteen wat je moet betalen of terugkrijgt. Klopt het, dan neem je in Mijn Belastingdienst de bedragen rubriek voor rubriek over en upload je de ontvangstbevestiging. Klaar.',
  'landing.compare.title': 'Geen boekhoudpakket en geen boekhouder nodig',
  'landing.compare.text': 'Wil je alleen je btw per kwartaal goed aangeven? Dan is dit de makkelijkste manier.',
  'landing.compare.col.way': 'Manier',
  'landing.compare.col.you': 'Wat jij doet',
  'landing.compare.col.cost': 'Kosten',
  'landing.compare.accountant.way': 'Boekhouder',
  'landing.compare.accountant.you': 'Stukken verzamelen en opsturen, wachten op de uitkomst',
  'landing.compare.accountant.cost': 'ca. € 75–200 per aangifte',
  'landing.compare.software.way': 'Boekhoudpakket',
  'landing.compare.software.you': 'Zelf leren boekhouden en elke boeking indelen',
  'landing.compare.software.cost': 'ca. € 15–49 per maand',
  'landing.compare.us.you': 'Stukken aanleveren, een paar vragen beantwoorden, bedragen overnemen',
  'landing.compare.us.cost': '{price} per bedrijf per kwartaal (excl. btw)',
  'landing.compare.source': 'Prijzen van boekhouders en boekhoudpakketten: openbare prijsindicaties van oktober 2026. Alleen bedoeld als vergelijking.',
  'landing.price.title': 'Eén prijs, geen pakketten om te vergelijken',
  'landing.price.text': 'Je betaalt alleen voor bedrijven waarvoor je via ons aangifte doet. Een bedrijf dat niet in aanmerking komt of dat je archiveert, kost niets.',
  'landing.price.f1': 'Bankafschriften importeren en facturen herkennen',
  'landing.price.f2': 'Elke rubriek uitgerekend, met de onderbouwing erbij',
  'landing.price.f3': 'Een tweede AI leest alle stukken opnieuw en controleert de gegevens',
  'landing.price.f4': 'Rubriek voor rubriek vergelijken met het portaal; al je stukken en aangiftes altijd te exporteren',
  'landing.price.f5': 'In het Nederlands, Engels en Chinees',
  'landing.price.per': 'Per bedrijf · per kwartaal',
  'landing.price.excl': 'excl. btw',
  'landing.price.second': 'Vanaf het tweede bedrijf {price}',
  'landing.price.tx': 'Inclusief {n} banktransacties per bedrijf per kwartaal; daarboven {price} per transactie',
  'landing.price.note': 'Per kwartaal, stop wanneer je wilt',
  'landing.scope.title': 'Wat we wel en niet doen',
  'landing.scope.do': 'Dit doen we',
  'landing.scope.do1': 'Betalingen en facturen aan elkaar koppelen en laten zien welke factuur nog ontbreekt',
  'landing.scope.do2': 'Elke rubriek volgens de regels uitrekenen; achter elk bedrag zie je de bonnen en facturen',
  'landing.scope.do3': 'Situaties die we niet ondersteunen (bijvoorbeeld vrijgestelde omzet of webwinkelverkoop aan consumenten in andere EU-landen) eerlijk benoemen, en je doorverwijzen naar een boekhouder',
  'landing.scope.dont': 'Dit doen we niet',
  'landing.scope.dont1': 'Niet namens jou indienen: dat doe je zelf in het officiële portaal',
  'landing.scope.dont2': 'Nooit vragen om je wachtwoord voor internetbankieren, DigiD of eHerkenning',
  'landing.scope.dont3': 'Geen jaarrekening, inkomstenbelasting of vennootschapsbelasting; daarvoor heb je nog een boekhouder nodig',
  'landing.faq.title': 'Veelgestelde vragen',
  'landing.faq.q1.q': 'Voor welke bedrijven is BTW Kwartier?',
  'landing.faq.q1.a': 'Voor eenmanszaken en bv’s in Nederland die per kwartaal btw-aangifte doen: dienstverleners, en ook bedrijven die goederen invoeren, uitvoeren of aan bedrijven in de EU leveren. Doe je mee aan de KOR, dan houden we gratis je omzet bij. Bij de start zie je aan de hand van een paar ja/nee-vragen of het bij jou past.',
  'landing.faq.q2.q': 'Hoef ik echt niets van belasting te weten?',
  'landing.faq.q2.a': 'Nee. We vragen alleen naar feiten over je zaak, niet naar belastingtermen. Twijfel je, kies dan ‘Ik weet het niet zeker’: we kiezen dan de voorzichtige verwerking en laten zien wat dat betekent.',
  'landing.faq.q3.q': 'Ik heb meerdere bedrijven. Hoe werkt dat?',
  'landing.faq.q3.a': 'Je beheert al je bedrijven vanuit één account en wisselt bovenaan met één klik.',
  'landing.faq.q4.q': 'Waar staan mijn gegevens, en hoe lang?',
  'landing.faq.q4.a': 'Onze servers staan in de EU (West-Europa). We werken alleen met dienstverleners met wie we een verwerkersovereenkomst hebben. Je kunt al je stukken en aangiftes altijd exporteren. De wettelijke bewaarplicht (meestal 7 jaar) ligt bij jou; exporteer je stukken voordat je stopt.',
  'landing.final.title': 'Doe het dit kwartaal eens zonder gedoe',
  'landing.final.text': 'De deadline is {date}. Na registratie zie je meteen wat er nog ontbreekt.',
  'landing.footer.rights': '© {year} {owner}',
  'landing.footer.aria': 'Juridisch en contact',
  'landing.footer.terms': 'Voorwaarden',
  'landing.footer.privacy': 'Privacyverklaring',
  'landing.footer.contact': 'Contact',
  'landing.footer.disclaimer': 'BTW Kwartier is geen onderdeel van de Belastingdienst. Je dient de aangifte zelf in via het officiële portaal.',
  /* prelaunch: launch waitlist, public footer, privacy statement, terms */
  'landing.beta.cta': 'Houd me op de hoogte',
  'landing.beta.groups': 'We laten je weten zodra BTW Kwartier live gaat.',
  'public.back': 'Naar de homepage',
  'public.footer.kvk': 'KvK {kvk}',
  'waitlist.title': 'Houd me op de hoogte',
  'waitlist.lead': 'We laten je weten zodra BTW Kwartier live gaat.',
  'waitlist.point1': 'Eén e-mail zodra je kunt beginnen',
  'waitlist.point2': 'Je aanmelding verplicht je tot niets',
  'waitlist.point3': 'Afmelden kan altijd, met één mailtje',
  'waitlist.company': 'Bedrijfsnaam',
  'waitlist.name': 'Je naam',
  'waitlist.email': 'E-mailadres',
  'waitlist.kvk': 'KvK-nummer',
  'waitlist.kvkHint': '8 cijfers',
  'waitlist.companies': 'Aantal bedrijven',
  'waitlist.companiesHint': 'Waarvoor je btw-aangifte doet',
  'waitlist.consent': 'Ik geef {company} toestemming om mij te mailen over de lancering van BTW Kwartier. Zie de',
  'waitlist.consentLink': 'privacyverklaring',
  'waitlist.submit': 'Houd me op de hoogte',
  'waitlist.note': 'Aanmelden is gratis en vrijblijvend.',
  'waitlist.err.company': 'Vul de naam van je bedrijf in.',
  'waitlist.err.name': 'Vul je naam in.',
  'waitlist.err.emailRequired': 'Vul je e-mailadres in.',
  'waitlist.err.email': 'Dit e-mailadres lijkt niet te kloppen. Controleer het even.',
  'waitlist.err.kvk': 'Een KvK-nummer heeft 8 cijfers. Weet je het niet? Laat het veld dan leeg.',
  'waitlist.err.companies': 'Kies een aantal van 1 tot 50.',
  'waitlist.err.consent': 'Vink dit aan, anders kunnen we je niet mailen over de lancering.',
  'waitlist.rate.title': 'Even geduld',
  'waitlist.rate.text': 'Vanaf jouw verbinding zijn al een paar aanmeldingen verstuurd. Probeer het over een uur opnieuw; wat je hebt ingevuld blijft staan.',
  'waitlist.failed.title': 'Versturen lukte niet',
  'waitlist.failed.text': 'Er ging iets mis met de verbinding of aan onze kant. Je gegevens staan nog in het formulier; probeer het zo opnieuw.',
  'waitlist.success.title': 'Dank je!',
  'waitlist.success.text': 'We laten je weten zodra BTW Kwartier live gaat.',
  'privacy.updated': 'Laatst bijgewerkt: {date}',
  'privacy.contactFallback': 'door te antwoorden op een e-mail van ons',
  'privacy.who.name': 'Bedrijf',
  'privacy.who.address': 'Adres',
  'privacy.who.kvk': 'KvK-nummer',
  'privacy.who.email': 'E-mail',
  'legal.version': 'versie {version}',
  'auth.consent.a': 'Ik ga akkoord met de ',
  'auth.consent.terms': 'voorwaarden',
  'auth.consent.b': ' en heb de ',
  'auth.consent.privacy': 'privacyverklaring',
  'auth.consent.c': ' gelezen.',
  'auth.consent.newTab': '(opent in een nieuw tabblad)',
  'auth.consent.outdated': 'De voorwaarden zijn net bijgewerkt. Lees ze opnieuw en bevestig.',
  'legal.gate.title': 'Onze voorwaarden zijn bijgewerkt',
  'legal.gate.text': 'Lees de nieuwe voorwaarden en ga akkoord om BTW Kwartier te blijven gebruiken. Je gegevens blijven gewoon bewaard en je kunt ze altijd exporteren.',
  'legal.gate.terms': 'Voorwaarden lezen',
  'legal.gate.privacy': 'Privacyverklaring lezen',
  'legal.gate.accept': 'Ik ga akkoord',
  'legal.gate.logout': 'Uitloggen',
  'referral.promise': 'Een partner-accountant neemt binnen {days} werkdagen contact met je op.',
  'referral.noFirm': 'We zoeken een passende accountant voor je en laten je weten wie het wordt. Pas dan delen we je gegevens met dat kantoor.',
  'referral.share.title': 'Dit delen we met het kantoor',
  'referral.share.company': 'Bedrijfsnaam: {name}',
  'referral.share.contact': 'Je naam en e-mailadres: {name}, {email}',
  'referral.phone': 'Telefoonnummer',
  'referral.phoneHint': 'Alleen als je liever gebeld wordt. We delen het dan ook.',
  'referral.phoneInvalid': 'Vul een telefoonnummer in, bijvoorbeeld 06 1234 5678.',
  'referral.shareQuestions': '{n, plural, one {Ook mijn # open vraag meesturen} other {Ook mijn # open vragen meesturen}}',
  'referral.shareQuestionsCurrent': 'Ook deze vraag meesturen',
  'referral.shareQuestionsHint': 'Per vraag: datum, tegenpartij, bedrag en soort vraag.',
  'referral.consent': 'Ik geef BTW Kwartier toestemming om deze gegevens te delen met een partner-accountant, zodat die contact met me kan opnemen.',
  'referral.consentError': 'Geef toestemming om door te gaan.',
  'referral.privacyLink': 'Zo gaan we met je gegevens om',
  'referral.wwft': 'Het kantoor doet zelf het wettelijke cliëntonderzoek (Wwft) en kan je daarvoor om een identiteitsbewijs vragen.',
  'referral.alreadyWith': 'Je bent voor dit kwartaal al doorverwezen naar {name}.',
  'referral.already': 'Je verzoek voor dit kwartaal is al verstuurd. We nemen contact met je op.',
  'referral.outdated': 'De tekst over wat we delen is net gewijzigd. Lees hem opnieuw en bevestig.',
  'referral.doneWithDays': 'Ze nemen binnen {days} werkdagen contact met je op. Je kunt ze ook zelf bereiken.',
  'ops.accountants': 'Accountants',
  'ops.referrals': 'Doorverwijzingen',
  'ops.acc.add': 'Kantoor toevoegen',
  'ops.acc.edit': 'Kantoor bewerken',
  'ops.acc.name': 'Naam kantoor',
  'ops.acc.contact': 'Contactpersoon',
  'ops.acc.email': 'E-mail voor doorverwijzingen',
  'ops.acc.phone': 'Telefoon',
  'ops.acc.languages': 'Talen',
  'ops.acc.specialities': 'Specialismen',
  'ops.acc.regions': 'Regio’s',
  'ops.acc.listHint': 'Gescheiden door komma’s',
  'ops.acc.share': 'Afgesproken aandeel (%)',
  'ops.acc.shareHint': '30–50 % van de honoraria in het eerste jaar',
  'ops.acc.active': 'Actief',
  'ops.acc.inactive': 'Niet actief',
  'ops.acc.open': '{n, plural, one {# open doorverwijzing} other {# open doorverwijzingen}}',
  'ops.acc.empty': 'Nog geen partnerkantoren',
  'ops.acc.emptyText': 'Zolang er geen actief kantoor is, belooft de app geen termijn en zegt ze dat we contact opnemen.',
  'ops.acc.noActive': 'Geen actief kantoor: klanten krijgen geen 2-werkdagenbelofte.',
  'ops.acc.adminOnly': 'Alleen een beheerder kan kantoren wijzigen.',
  'ops.acc.deactivate': 'Deactiveren',
  'ops.acc.activate': 'Activeren',
  'ops.ref.empty': 'Geen doorverwijzingen',
  'ops.ref.status.new': 'Nieuw',
  'ops.ref.status.contacted': 'Contact gelegd',
  'ops.ref.status.client': 'Klant',
  'ops.ref.status.not_client': 'Geen klant',
  'ops.ref.noFirm': 'Nog geen kantoor',
  'ops.ref.assign': 'Kantoor toewijzen',
  'ops.ref.assignHint': 'Het kantoor en de klant krijgen meteen een e-mail.',
  'ops.ref.claim': 'Oppakken',
  'ops.ref.owner': 'Eigenaar: {name}',
  'ops.ref.noOwner': 'Geen eigenaar',
  'ops.ref.sla': 'Contact uiterlijk {date}',
  'ops.ref.overdue': 'Te laat',
  'ops.ref.consent': 'Toestemming {date} (tekst {version})',
  'ops.ref.noConsent': 'Oude doorverwijzing zonder vastgelegde toestemming',
  'ops.ref.questions': '{n, plural, one {# vraag} other {# vragen}}',
  'ops.ref.contacted': 'Contact gelegd',
  'ops.ref.client': 'Klant geworden',
  'ops.ref.notClient': 'Geen klant',
  'ops.ref.open': 'Openen',
  'ops.ref.reason': 'Hulpvraag',
  'ops.ref.shared': 'Gedeeld met toestemming',
  'ops.ref.notes': 'Notities (intern)',
  'ops.ref.save': 'Opslaan',
  'ops.ref.fee': 'Honorarium eerste jaar (€)',
  'ops.ref.recordFee': 'Honorarium vastleggen',
  'ops.ref.commission': 'Commissie {amount} ({pct} % van {fee})',
  'ops.ref.contactedAt': 'Contact {date}',
  'ops.ref.closedAt': 'Afgesloten {date}',
  'subscription.complimentary': "Gratis toegang",
  'billing.event.free_comp': "Gratis (toegang van BTW Kwartier)",
  'billing.event.free_promo': "Gratis (kortingscode)",
  'billing.comp.title': "Gratis toegang",
  'billing.comp.until': "Je gebruikt BTW Kwartier gratis tot en met {date}.",
  'billing.comp.noEnd': "Je gebruikt BTW Kwartier gratis, zonder einddatum.",
  'billing.comp.after': "Je hoeft niets te kiezen of te betalen. Wil je daarna doorgaan, kies dan na die datum een abonnement.",
  'billing.comp.text': "Je hoeft niets te kiezen of te betalen. Aangiften die je bevestigt, kosten niets.",
  'billing.discount.title': "Kortingscode",
  'billing.discount.have': "Heb je een kortingscode?",
  'billing.discount.code': "Code",
  'billing.discount.apply': "Toepassen",
  'billing.discount.hint': "Eén code per account. De korting geldt voor de aangiften (en extra transacties) van de kwartalen die de code noemt, vanaf het eerste kwartaal dat we na het invullen factureren.",
  'billing.discount.applied': "Kortingscode toegepast",
  'billing.discount.pct': "{pct}% korting",
  'billing.discount.span': "van {from} tot en met {to}",
  'billing.discount.next': "{n, plural, one {voor het eerste kwartaal dat we factureren} other {voor de eerste # kwartalen die we factureren}}",
  'billing.discount.always': "op elk kwartaal",
  'billing.discount.err.discount_invalid': "Deze kortingscode bestaat niet of is niet meer geldig.",
  'billing.discount.err.discount_expired': "Deze kortingscode is verlopen.",
  'billing.discount.err.discount_used_up': "Deze kortingscode is al zo vaak gebruikt als mogelijk.",
  'billing.discount.err.discount_already': "Er is al een kortingscode toegepast op dit account.",
  'opsx.nav.overview': "Overzicht",
  'opsx.nav.dashboard': "Dashboard",
  'opsx.nav.customers': "Klanten",
  'opsx.nav.revenue': "Omzet",
  'opsx.nav.subscriptions': "Abonnementen & korting",
  'opsx.nav.payments': 'Betalingen controleren',
  'opsx.pay.title': 'Betalingen met onbekende uitkomst',
  'opsx.pay.intro': 'Bij deze afschrijvingen kwam er geen antwoord van de betaalprovider en kon ook later niet worden vastgesteld of het geld is afgeschreven. Ze worden nooit vanzelf opnieuw afgeschreven. Vraag het opnieuw na, of zoek de referentie of het factuurnummer op in het dashboard van de provider en leg vast wat je ziet.',
  'opsx.pay.empty': 'Niets te controleren.',
  'opsx.pay.reference': 'Referentie bij de provider',
  'opsx.pay.since': 'Sinds',
  'opsx.pay.attempts': '{n} pogingen',
  'opsx.pay.last': 'Laatste resultaat',
  'opsx.pay.note': 'Notitie (verplicht)',
  'opsx.pay.noteHint': 'Wat heb je gecontroleerd? Komt in het activiteitenlog.',
  'opsx.pay.paymentId': 'Betaling-id bij de provider',
  'opsx.pay.paymentIdHint': 'Alleen nodig voor "Wel betaald" (Mollie tr_…, Stripe pi_…).',
  'opsx.pay.recheck': 'Opnieuw navragen',
  'opsx.pay.markPaid': 'Wel betaald',
  'opsx.pay.markNotCharged': 'Niet afgeschreven',
  'opsx.pay.result.paid': 'Vastgelegd: betaald. De factuur is voldaan.',
  'opsx.pay.result.not_charged': 'Vastgelegd: niet afgeschreven. De factuur volgt de normale herinneringen.',
  'opsx.pay.result.pending': 'De provider verwerkt de betaling nog. Probeer het later opnieuw.',
  'opsx.pay.result.unknown': 'Nog steeds geen antwoord van de provider. Controleer het dashboard.',
  'opsx.pay.overageTitle': 'Korting op extra transacties nog te crediteren',
  'opsx.pay.overageIntro': 'Jaarabonnementen met een kortingscode: vóór 29-10-2026 kregen extra transacties de korting niet. Crediteer per bedrijf en kwartaal; de regel verdwijnt als die creditnota er is. Kan pas als de factuur betaald is.',
  'opsx.pay.overageEmpty': 'Niets te crediteren.',
  'opsx.pay.col.company': 'Bedrijf',
  'opsx.pay.col.quarter': 'Kwartaal',
  'opsx.pay.col.tx': 'Extra transacties',
  'opsx.pay.col.pct': 'Korting',
  'opsx.pay.col.invoice': 'Factuur',
  'opsx.pay.col.credit': 'Te crediteren (excl. btw)',
  'opsx.pay.creditRow': 'Crediteren',
  'opsx.pay.creditAfterPayment': 'Na betaling',
  'opsx.pay.creditTitle': 'Korting crediteren op {n}',
  'opsx.pay.creditText': 'Er komt een creditnota van {amount} (excl. btw) voor {company}, {quarter}. Het bedrag wordt teruggestort.',
  'opsx.pay.needsReview': 'Controleren',
  'opsx.pay.review': 'Beoordelen',
  'opsx.pay.reviewTitle': 'Bestaande creditnota op {n}',
  'opsx.pay.reviewText': 'Op deze factuur staat een creditnota met een bedrag dat nog bij geen enkele aangifte hoort (met de hand gemaakt, of deels gebruikt). Dekt die (een deel van) de korting van {amount} voor {company}, {quarter}? Koppel hem dan: tot wat er nog vrij is. Was hij voor iets anders, crediteer dan toch.',
  'opsx.pay.otherCredits': 'Creditnota’s op deze factuur zonder koppeling',
  'opsx.pay.link': 'Hoort hierbij (koppelen)',
  'opsx.pay.creditAnyway': 'Toch crediteren',
  'opsx.pay.linked': 'Gekoppeld aan creditnota {n}. Er is niets teruggestort.',
  'opsx.pay.linkedPart': 'Gekoppeld aan creditnota {n}: {amount}. Nog {rest} open op deze regel.',
  'opsx.pay.covered': 'al gedekt {amount} van {owed}',
  'opsx.pay.available': 'nog {amount} vrij',
  'opsx.nav.operations': "Uitvoering",
  'opsx.nav.content': "Regels & inhoud",
  'opsx.nav.system': "Systeem",
  'opsx.nav.staff': "Medewerkers & rollen",
  'opsx.nav.audit': "Activiteitenlog",
  'opsx.role.support': "Support",
  'opsx.role.advisor': "Adviseur",
  'opsx.role.admin': "Beheerder",
  'opsx.role.undefined': "—",
  'opsx.queues': "Te doen",
  'opsx.queue.kvk': "KvK-gegevens te controleren",
  'opsx.queue.kvkMismatch': "KvK klopt niet",
  'opsx.queue.tickets': "Open tickets",
  'opsx.queue.review': "Controles door adviseur",
  'opsx.queue.referrals': "Nieuwe doorverwijzingen",
  'opsx.reset2fa.title': 'Tweestapsverificatie resetten',
  'opsx.reset2fa.text': 'Alleen als iemand zowel de authenticator als de herstelcodes kwijt is, en pas nadat je de identiteit hebt gecontroleerd (bijvoorbeeld videobellen met ID). Alle sessies stoppen; de gebruiker krijgt een e-mail en zet het daarna opnieuw aan.',
  'opsx.reset2fa.reason': 'Reden en controle',
  'opsx.reset2fa.reasonHint': 'Komt in het activiteitenlog.',
  'opsx.reset2fa.button': 'Resetten',
  'opsx.reset2fa.confirmTitle': 'Tweestapsverificatie van {email} resetten?',
  'opsx.reset2fa.confirmText': 'De gebruiker wordt overal uitgelogd en kan inloggen met wachtwoord of e-maillink.',
  'opsx.reset2fa.done': 'Tweestapsverificatie gereset; de gebruiker heeft een e-mail gekregen.',
  'opsx.queue.failed': "Mislukte betalingen",
  'opsx.queue.paymentsUnknown': 'Betaling onbekend — controleren',
  'opsx.queue.closures': "Geplande verwijderingen",
  'opsx.kpi.accounts': "Accounts",
  'opsx.kpi.new30': "{n} nieuw in 30 dagen",
  'opsx.kpi.paying': "Betalende accounts",
  'opsx.kpi.free': "Gratis toegang",
  'opsx.kpi.trial': "Zonder abonnement",
  'opsx.kpi.entities': "Bedrijven",
  'opsx.kpi.filings': "Aangiften dit kwartaal",
  'opsx.kpi.revenueQuarter': "Ontvangen dit kwartaal",
  'opsx.kpi.revenue30': "{amount} in 30 dagen",
  'opsx.kpi.openInvoices': "Openstaand",
  'opsx.kpi.failed': "{n} mislukt",
  'opsx.kpi.activeUsers': "Actieve gebruikers (30 dagen)",
  'opsx.kpi.discounts': "Actieve kortingscodes",
  'opsx.kpi.redeemed': "{n} keer gebruikt",
  'opsx.search': "Zoek op naam, e-mail of kortingscode",
  'opsx.filter.status': "Status",
  'opsx.filter.all': "Alle",
  'opsx.filter.paying': "Betalend",
  'opsx.sort': "Sorteren",
  'opsx.sort.created': "Nieuwste eerst",
  'opsx.sort.activity': "Laatste activiteit",
  'opsx.sort.name': "Naam",
  'opsx.count': "{n} van {total}",
  'opsx.col.owner': "Eigenaar",
  'opsx.until': "tot en met {date}",
  'opsx.noEnd': "zonder einddatum",
  'opsx.back': "Alle accounts",
  'opsx.copyId': "Kopieer account-ID",
  'opsx.copy': "Kopieer code",
  'opsx.sub.title': "Abonnement",
  'opsx.sub.status': "Status",
  'opsx.sub.plan': "Abonnement",
  'opsx.sub.quarterly': "per kwartaal",
  'opsx.sub.annual': "per jaar",
  'opsx.sub.mandate': "Betaalmethode",
  'opsx.sub.started': "Gestart",
  'opsx.sub.discount': "Kortingscode",
  'opsx.sub.free': "Gratis toegang",
  'opsx.mandate.none': "Geen",
  'opsx.mandate.pending': "Wordt ingesteld",
  'opsx.mandate.valid': "Actief",
  'opsx.mandate.invalid': "Ingetrokken",
  'opsx.discountLine': "{code} · {pct}% · {span}",
  'opsx.quarters': "{n, plural, one {# kwartaal} other {# kwartalen}}",
  'opsx.forever': "Elk kwartaal",
  'opsx.unlimited': "onbeperkt",
  'opsx.free.grant': "Gratis toegang geven",
  'opsx.free.change': "Einddatum wijzigen",
  'opsx.free.end': "Gratis toegang beëindigen",
  'opsx.free.endTitle': "Gratis toegang nu beëindigen?",
  'opsx.free.endToPlan': "Dit account heeft een betaalmethode en een abonnement: aangiften worden vanaf nu weer gefactureerd.",
  'opsx.free.endToTrial': "Dit account heeft geen betaalmethode: het gaat terug naar de gratis check tot de eigenaar een abonnement kiest.",
  'opsx.free.ended': "Gratis toegang beëindigd",
  'opsx.free.title': "Gratis toegang",
  'opsx.free.text': "Geen abonnement of betaalmethode nodig; aangiften die in deze tijd worden bevestigd, kosten niets (ook extra transacties). Mislukte facturen blijven staan: crediteer ze zo nodig.",
  'opsx.free.noEnd': "Zonder einddatum",
  'opsx.free.until': "Laatste dag",
  'opsx.free.note': "Notitie (intern)",
  'opsx.free.notePh': "Bijvoorbeeld: partner, test, compensatie",
  'opsx.free.save': "Opslaan",
  'opsx.free.granted': "Gratis toegang opgeslagen",
  'opsx.free.list': "Accounts met gratis toegang",
  'opsx.free.listHint': "Geef of beëindig gratis toegang op de pagina van het account (Klanten → Accounts).",
  'opsx.free.empty': "Nog geen accounts met gratis toegang.",
  'opsx.members': "Gebruikers",
  'opsx.invited': "uitgenodigd",
  'opsx.2fa.on': "Tweestaps aan",
  'opsx.2fa.off': "Tweestaps uit",
  'opsx.entities': "Bedrijven",
  'opsx.archived': "Gearchiveerd",
  'opsx.kvk.pending': "KvK te controleren",
  'opsx.kvk.ok': "KvK klopt",
  'opsx.kvk.mismatch': "KvK klopt niet",
  'opsx.none': "Geen.",
  'opsx.invoices': "Facturen",
  'opsx.inv.number': "Nummer",
  'opsx.inv.date': "Datum",
  'opsx.inv.period': "Periode",
  'opsx.inv.total': "Totaal",
  'opsx.inv.status': "Status",
  'opsx.inv.st.open': "Open",
  'opsx.inv.st.paid': "Betaald",
  'opsx.inv.st.failed': "Mislukt",
  'opsx.inv.st.void': "Vervallen",
  'opsx.inv.creditFor': "creditnota bij {n}",
  'opsx.inv.credit': "Crediteren",
  'opsx.inv.creditTitle': "Factuur {n} crediteren",
  'opsx.inv.creditText': "Er komt een creditnota. Was de factuur ({amount}) betaald, dan storten we het bedrag terug.",
  'opsx.inv.reason': "Reden (staat op de creditnota)",
  'opsx.inv.partial': "Deelbedrag in euro, excl. btw",
  'opsx.inv.partialHint': "Bedrag excl. btw. Leeg laten voor de hele factuur.",
  'opsx.inv.credited': "Creditnota {n} gemaakt",
  'opsx.activity': "Recente activiteit",
  'opsx.activityHint': "Alleen wat er gebeurde en door wie, zonder inhoud.",
  'opsx.code.title': "Nieuwe kortingscode",
  'opsx.code.text': "Een percentage van de aangifteprijs (en extra transacties) voor een aantal kwartalen. De klant vult de code in bij Abonnement; één code per account.",
  'opsx.code.code': "Code",
  'opsx.code.codeHint': "Leeg laten voor een willekeurige code. Letters, cijfers en -.",
  'opsx.code.percent': "Korting (%)",
  'opsx.code.quarters': "Geldt voor",
  'opsx.code.max': "Maximaal aantal accounts",
  'opsx.code.expires': "Geldig tot en met",
  'opsx.code.note': "Notitie (intern)",
  'opsx.code.create': "Code maken",
  'opsx.code.created': "Kortingscode {code} gemaakt",
  'opsx.code.list': "Kortingscodes",
  'opsx.code.empty': "Nog geen kortingscodes.",
  'opsx.code.terms': "Korting",
  'opsx.code.used': "Gebruikt",
  'opsx.code.state': "Status",
  'opsx.staff.add': "Medewerker toevoegen of rol wijzigen",
  'opsx.staff.addHint': "De persoon moet eerst een eigen account op btwkwartier.nl hebben (registreren). In productie moet tweestapsverificatie aan staan om de backoffice te openen.",
  'opsx.staff.email': "E-mailadres",
  'opsx.staff.role': "Rol",
  'opsx.staff.roleOf': "Rol van {name}",
  'opsx.staff.save': "Opslaan",
  'opsx.staff.saved': "Opgeslagen",
  'opsx.staff.roles': "Support: klanten, KvK-controle, uitnodigingscodes, tickets. Adviseur: controles door adviseur. Beheerder: alles, ook facturen, kortingscodes, gratis toegang, medewerkers en het activiteitenlog.",
  'opsx.staff.name': "Medewerker",
  'opsx.staff.2fa': "Tweestaps",
  'opsx.staff.lastLogin': "Laatst ingelogd",
  'opsx.staff.you': "jij",
  'opsx.staff.remove': "Toegang intrekken",
  'opsx.staff.removeTitle': "Backoffice-toegang van {name} intrekken?",
  'opsx.staff.removeText': "Het account zelf blijft bestaan; alleen de toegang tot de backoffice verdwijnt. De laatste beheerder kan niet worden verwijderd.",
  'opsx.err.no_such_user': "Geen gebruiker met dit e-mailadres. Vraag de persoon eerst te registreren.",
  'opsx.err.last_admin': "De laatste beheerder kan niet worden verwijderd of gewijzigd.",
  'opsx.err.code_taken': "Deze code bestaat al.",
  'opsx.audit.search': "Zoek in het log",
  'opsx.audit.hint': "Wijzigingen door medewerkers in de backoffice. Kan niet worden aangepast of verwijderd.",
  'opsx.audit.empty': "Nog geen activiteit.",
  'opsx.audit.when': "Wanneer",
  'opsx.audit.who': "Wie",
  'opsx.audit.what': "Wat",
  'opsx.audit.account': "Account",
  'opsx.audit.details': "Details",
  'opsx.act.staff_role_set': "Rol van medewerker ingesteld",
  'opsx.act.staff_removed': "Medewerker verwijderd",
  'opsx.act.complimentary_granted': "Gratis toegang gegeven",
  'opsx.act.complimentary_ended': "Gratis toegang beëindigd",
  'opsx.act.discount_code_created': "Kortingscode gemaakt",
  'opsx.act.discount_code_revoked': "Kortingscode ingetrokken",
  'opsx.act.invite_code_created': "Uitnodigingscode gemaakt",
  'opsx.act.invite_code_revoked': "Uitnodigingscode ingetrokken",
  'opsx.act.invoice_credited': "Factuur gecrediteerd",
  'opsx.act.kvk_check_set': "KvK-controle vastgelegd",
  'price.discount': "Korting",
  // Sales invoicing and purchase invoices by e-mail (2026-11-03)
  'documents.tab.sales': 'Verkoopfacturen {n}',
  'documents.tab.purchase': 'Inkoopfacturen {n}',
  'documents.drop.purchaseTitle': 'Inkoopfacturen en bonnen toevoegen',
  'documents.drop.purchaseHint': 'Sleep ze hierheen: pdf, scan of foto (JPG, PNG, HEIC). Op je telefoon maak je direct een foto. Een bankafschrift herkennen we ook.',
  'documents.drop.bankTitle': 'Bankafschriften toevoegen',
  'documents.drop.bankHint': 'Sleep ze hierheen: CSV, MT940, CAMT.053 of pdf van je bank.',
  'documents.drop.salesTitle': 'Verkoopfacturen uploaden',
  'documents.drop.salesHint': "Pdf's van facturen die je in een ander pakket hebt gemaakt.",
  'fwd.title': 'Inkoopfacturen per e-mail',
  'fwd.text': "Stuur facturen door naar dit adres, of laat je eigen mailbox (bijvoorbeeld finance@jouwbedrijf.nl) ze automatisch doorsturen. Wij halen de pdf's en foto's uit de mail en lezen ze uit.",
  'fwd.off': 'Facturen per e-mail doorsturen komt binnenkort. Upload of fotografeer ze tot die tijd hierboven.',
  'fwd.copy': 'Kopiëren',
  'fwd.how': 'Zo stel je automatisch doorsturen in',
  'fwd.how.outlook': 'Instellingen → E-mail → Regels → Nieuwe regel → actie "Doorsturen naar" dit adres. Bij Microsoft 365 moet de beheerder extern doorsturen soms eerst toestaan.',
  'fwd.how.gmail': 'Instellingen → Doorsturen en POP/IMAP → Een doorstuuradres toevoegen. Google stuurt dan een bevestigingscode naar dit adres: je ziet die hieronder bij "Laatst ontvangen".',
  'fwd.how.tip': 'Tip: stuur alleen mails met een bijlage of met "factuur" in het onderwerp door.',
  'fwd.log.title': 'Laatst ontvangen',
  'fwd.log.empty': 'Nog niets ontvangen op dit adres.',
  'fwd.log.noSubject': '(geen onderwerp)',
  'fwd.log.accepted': '{n, plural, one {# bijlage verwerkt} other {# bijlagen verwerkt}}',
  'fwd.log.none': 'geen pdf of foto',
  'inv.new': 'Nieuwe factuur',
  'inv.settings': 'Factuurinstellingen',
  'inv.summary': '{n, plural, one {# factuur} other {# facturen}}',
  'inv.summaryOpen': '{n} openstaand: {amount}',
  'inv.empty.title': 'Nog geen verkoopfacturen',
  'inv.empty.text': 'Maak je facturen hier: wij nummeren ze, maken de pdf en sturen ze naar je klant. Ze tellen meteen mee in je btw-aangifte.',
  'inv.list.aria': 'Verkoopfacturen',
  'inv.col.number': 'Nummer',
  'inv.col.customer': 'Klant',
  'inv.col.date': 'Datum',
  'inv.col.due': 'Vervalt',
  'inv.col.amount': 'Bedrag',
  'inv.col.status': 'Status',
  'inv.state.draft': 'Concept',
  'inv.state.final': 'Definitief',
  'inv.state.sent': 'Verstuurd',
  'inv.state.paid': 'Betaald',
  'inv.state.overdue': 'Vervallen',
  'inv.noCustomer': 'Nog geen klant',
  'inv.uploaded.title': 'Verkoopfacturen uit een ander pakket',
  'inv.uploaded.text': "Maak je facturen (ook) elders? Upload de pdf's, dan tellen ze mee.",
  'inv.uploaded.button': 'Uploaden',
  'inv.editor.newTitle': 'Nieuwe factuur',
  'inv.editor.draftTitle': 'Conceptfactuur',
  'inv.editor.title': 'Factuur {number}',
  'inv.back': 'Verkoopfacturen',
  'inv.section.customer': 'Klant',
  'inv.customer.choose': 'Kies een klant',
  'inv.customer.new': 'Nieuwe klant',
  'inv.customer.edit': 'Wijzigen',
  'inv.section.details': 'Gegevens',
  'inv.issueDate': 'Factuurdatum',
  'inv.dueDate': 'Vervaldatum',
  'inv.dueHint': 'Standaard {n} dagen',
  'inv.supplyDate': 'Leverdatum',
  'inv.supplyDateHint': 'Alleen als die anders is dan de factuurdatum.',
  'inv.vatMode': 'Btw',
  'inv.modeSuggested': 'Voorstel op basis van de klant.',
  'inv.mode.standard': 'Nederlandse btw',
  'inv.mode.reverse_nl': 'Btw verlegd naar Nederlandse ondernemer',
  'inv.mode.eu_services': 'Dienst aan ondernemer in de EU (btw verlegd)',
  'inv.mode.eu_goods': 'Goederen naar ondernemer in de EU (0%)',
  'inv.mode.export_goods': 'Export van goederen buiten de EU (0%)',
  'inv.mode.noneu_services': 'Dienst aan ondernemer buiten de EU',
  'inv.language': 'Taal van de factuur',
  'inv.lang.nl': 'Nederlands',
  'inv.lang.en': 'Engels',
  'inv.kor': 'Je bedrijf zit in de KOR: er komt geen btw op de factuur, wel de vermelding van de vrijstelling.',
  'inv.section.lines': 'Regels',
  'inv.line.description': 'Omschrijving',
  'inv.line.placeholder': 'Wat heb je geleverd?',
  'inv.line.quantity': 'Aantal',
  'inv.line.price': 'Prijs excl. btw',
  'inv.line.vat': 'Btw',
  'inv.line.amount': 'Bedrag',
  'inv.line.actions': 'Acties',
  'inv.line.add': 'Regel toevoegen',
  'inv.line.remove': 'Regel {n} verwijderen',
  'inv.notes': 'Opmerking op de factuur',
  'inv.total.subtotal': 'Subtotaal excl. btw',
  'inv.total.vat': 'Btw {rate}% over {base}',
  'inv.total.total': 'Totaal',
  'inv.countsIn': 'Telt mee in de aangifte van {quarter}.',
  'inv.problems.title': 'Nog nodig om de factuur definitief te maken',
  'inv.problem.no_customer': 'Kies een klant.',
  'inv.problem.no_lines': 'Voeg minstens één regel toe.',
  'inv.problem.empty_line': 'Elke regel heeft een omschrijving en een aantal nodig.',
  'inv.problem.zero_total': 'Het totaal is € 0.',
  'inv.problem.customer_vat_needed': 'Bij deze btw-keuze is het btw-nummer van de klant verplicht.',
  'inv.problem.customer_vat_country': 'Het land of btw-nummer van de klant past niet bij deze btw-keuze.',
  'inv.problem.mode_country': 'Deze btw-keuze geldt alleen voor klanten buiten de EU.',
  'inv.problem.private_customer_mode': 'Een particulier betaalt Nederlandse btw.',
  'inv.problem.no_seller_address': 'Vul het adres van je bedrijf in.',
  'inv.problem.no_seller_vat': 'Vul het btw-nummer van je bedrijf in.',
  'inv.problem.no_iban': 'Vul je IBAN in bij de factuurinstellingen.',
  'inv.problem.due_before_issue': 'De vervaldatum ligt vóór de factuurdatum.',
  'inv.badNumber': 'Controleer de aantallen en prijzen: gebruik alleen cijfers.',
  'inv.save': 'Opslaan als concept',
  'inv.saved': 'Concept opgeslagen',
  'inv.preview': 'Voorbeeld (pdf)',
  'inv.view': 'Pdf bekijken',
  'inv.finalize': 'Definitief maken',
  'inv.finalized': 'Factuur {number} is definitief',
  'inv.finalizeConfirm.title': 'Factuur definitief maken?',
  'inv.finalizeConfirm.text': 'De factuur krijgt nummer {number} en kan daarna niet meer worden gewijzigd of verwijderd. Hij telt mee in de aangifte van {quarter}.',
  'inv.send': 'Versturen',
  'inv.sendAgain': 'Opnieuw versturen',
  'inv.download': 'Pdf downloaden',
  'inv.duplicate': 'Kopiëren als nieuwe factuur',
  'inv.inDocuments': 'Bekijken in Documenten',
  'inv.delete': 'Concept verwijderen',
  'inv.deleteConfirm': 'Dit concept verwijderen?',
  'inv.deleteText': 'Een concept heeft nog geen nummer; verwijderen kan zonder gevolgen.',
  'inv.deleted': 'Concept verwijderd',
  'inv.finalNote': 'Een definitieve factuur kun je niet meer wijzigen of verwijderen (wettelijke bewaarplicht). Klopt er iets niet? Maak een creditnota en zo nodig een nieuwe factuur.',
  'inv.info.final': 'Definitief sinds {date}, nog niet verstuurd.',
  'inv.info.sent': 'Verstuurd naar {to} op {date}.',
  'inv.info.paid': 'Betaald: de betaling staat op je bankafschrift.',
  'inv.info.overdue': 'Vervallen sinds {date}: nog geen betaling op je bankafschrift.',
  'inv.vatIdShort': 'Btw-id',
  'inv.cust.title.new': 'Nieuwe klant',
  'inv.cust.title.edit': 'Klant wijzigen',
  'inv.cust.kind': 'Soort klant',
  'inv.cust.kind.business': 'Bedrijf',
  'inv.cust.kind.private': 'Particulier',
  'inv.cust.name': 'Naam',
  'inv.cust.email': 'E-mailadres voor facturen',
  'inv.cust.address': 'Adres',
  'inv.cust.addressHint': 'Straat en huisnummer, postcode en plaats',
  'inv.cust.country': 'Land',
  'inv.cust.vatId': 'Btw-nummer',
  'inv.cust.vatIdHint': 'Nodig bij btw verlegd en bij klanten elders in de EU.',
  'inv.cust.kvk': 'KvK-nummer',
  'inv.cust.save': 'Klant opslaan',
  'inv.set.title': 'Factuurinstellingen',
  'inv.set.seller': 'Op je facturen',
  'inv.set.companyLink': 'Bedrijfsgegevens wijzigen',
  'inv.set.iban': 'IBAN voor betalingen',
  'inv.set.ibanHint': 'Staat op de factuur met het verzoek om te betalen.',
  'inv.set.ibanCurrent': 'Nu: {iban}. Vul een nieuw IBAN in om het te vervangen.',
  'inv.set.replyEmail': 'Antwoorden van klanten naar',
  'inv.set.replyHint': 'Facturen gaan uit vanaf {from} met je bedrijfsnaam; antwoordt de klant, dan komt dat hier binnen.',
  'inv.set.paymentDays': 'Betaaltermijn (dagen)',
  'inv.set.next': 'Volgend volgnummer',
  'inv.set.nextHint': 'Kom je van een ander pakket? Ga verder waar je was.',
  'inv.set.prefix': 'Voorvoegsel factuurnummer',
  'inv.set.prefixHint': '{YYYY} wordt het jaartal. Volgende factuur: {preview}',
  'inv.set.footer': 'Voettekst',
  'inv.set.save': 'Opslaan',
  'inv.set.saved': 'Factuurinstellingen opgeslagen',
  'inv.send.title': 'Factuur versturen',
  'inv.send.to': 'Aan',
  'inv.send.cc': 'Cc',
  'inv.send.ccHint': 'Meerdere adressen scheiden met een komma.',
  'inv.send.message': 'Bericht',
  'inv.send.messageHint': 'Leeg laten voor de standaardtekst; bedrag, vervaldatum en IBAN staan er altijd onder.',
  'inv.send.copy': 'Stuur mij een kopie ({email})',
  'inv.send.from': 'Gaat uit vanaf {from} als "{name} via BTW Kwartier", met de pdf als bijlage. Antwoorden komen bij {reply}.',
  'inv.send.finalWarn': 'Bij versturen wordt de factuur definitief (nummer {number}) en kun je hem niet meer wijzigen.',
  'inv.send.submit': 'Versturen',
  'inv.send.submitFinal': 'Definitief maken en versturen',
  'inv.send.done': 'Factuur {number} verstuurd naar {to}',
  'inv.send.invalid': 'Vul geldige e-mailadressen in.',
  'documents.tab.salesShort': 'Verkoop {n}',
  'documents.tab.purchaseShort': 'Inkoop {n}',
  'documents.tab.bankShort': 'Bank {n}',
  'inv.state.credited': 'Gecrediteerd',
  'inv.kind.credit': 'Creditnota',
  'inv.editor.creditTitle': 'Creditnota {number}',
  'inv.editor.creditDraftTitle': 'Concept-creditnota',
  'inv.creditFor': 'Creditnota voor factuur',
  'inv.creditHint': 'Pas de regels aan om een deel te crediteren; prijzen zijn negatief.',
  'inv.credit': 'Creditnota maken',
  'inv.credits.title': "Creditnota's",
  'inv.credits.left': 'Nog openstaand na creditering: {amount}',
  'inv.problem.credit_not_negative': 'Een creditnota heeft een negatief totaal: zet een min voor de prijzen.',
  'inv.problem.credit_exceeds': 'Je crediteert meer dan er van de factuur over is.',
  'inv.info.creditFinal': 'Definitief. Een creditnota vraagt geen betaling.',
  'inv.info.credited': 'Volledig gecrediteerd: er hoeft niets meer betaald te worden.',
  'inv.info.paidOnline': 'Betaald via de betaallink (Mollie).',
  'inv.info.paidManual': 'Als betaald gemarkeerd.',
  'inv.info.reminded': '{n, plural, one {Herinnering verstuurd} other {# herinneringen verstuurd}}, laatst op {date}.',
  'inv.info.payLink': 'Online betalen staat aan.',
  'inv.info.payLinkOpen': 'Betaallink openen',
  'inv.markPaid': 'Markeren als betaald',
  'inv.unmarkPaid': 'Toch niet betaald',
  'inv.repeat': 'Herhalen…',
  'inv.remind.button': 'Herinnering sturen',
  'inv.remind.title': 'Herinnering voor factuur {number}',
  'inv.remind.text': 'Dit is herinnering {n}. De klant krijgt de factuur nogmaals als pdf, met het bedrag, de vervaldatum en de betaalgegevens.',
  'inv.remind.submit': 'Herinnering versturen',
  'inv.remind.done': 'Herinnering voor {number} verstuurd naar {to}',
  'inv.set.remindTitle': 'Betalingsherinneringen',
  'inv.set.autoRemind': 'Automatisch herinneren',
  'inv.set.autoRemindHint': 'Voor verstuurde facturen die niet betaald zijn: {n} dagen na de vervaldatum, en nog een keer na {n} dagen. Een betaling op je bankafschrift of via de betaallink stopt de herinneringen.',
  'inv.set.remindDays': 'Dagen na de vervaldatum',
  'inv.set.mollieTitle': 'Online betalen (iDEAL)',
  'inv.set.mollieText': 'Koppel je eigen Mollie-account: elke factuur krijgt dan een betaallink in de mail en op de pdf. Het geld komt rechtstreeks op je eigen Mollie-rekening; Mollie rekent zijn eigen tarief.',
  'inv.set.mollieKey': 'Mollie API-key',
  'inv.set.mollieReplace': 'Andere Mollie API-key',
  'inv.set.mollieHint': 'Mollie-dashboard → Ontwikkelaars → API-keys: de live-key (live_…) of om te testen de test-key (test_…).',
  'inv.set.mollieOn': 'Gekoppeld ({mode}), key eindigt op {last4}',
  'inv.set.mollieOff': 'Ontkoppelen',
  'inv.set.mollieOffNote': 'Na opslaan krijgen nieuwe facturen geen betaallink meer. Bestaande links blijven werken.',
  'inv.rec.title': 'Factuur herhalen',
  'inv.rec.text': 'We maken deze factuur steeds opnieuw: zelfde klant, regels en btw, met de nieuwe datum.',
  'inv.rec.frequency': 'Elke',
  'inv.rec.freq.month': 'Maand',
  'inv.rec.freq.quarter': 'Kwartaal',
  'inv.rec.freq.year': 'Jaar',
  'inv.rec.first': 'Eerstvolgende factuurdatum',
  'inv.rec.end': 'Stoppen na',
  'inv.rec.endHint': 'Leeg laten om door te gaan tot je stopt.',
  'inv.rec.autoSend': 'Automatisch naar de klant sturen',
  'inv.rec.autoSendHint': 'Uit: de factuur wordt gemaakt en definitief, en wacht op jou om te versturen. Ontbreekt er iets (bijvoorbeeld je IBAN), dan blijft hij concept.',
  'inv.rec.placeholders': 'Tip: {maand}, {kwartaal} en {jaar} in een regel worden ingevuld, bijvoorbeeld "Abonnement {maand} {jaar}".',
  'inv.rec.save': 'Herhalen',
  'inv.rec.created': 'De factuur wordt herhaald',
  'inv.rec.listTitle': 'Terugkerende facturen',
  'inv.rec.next': 'Volgende: {date}',
  'inv.rec.paused': 'Gepauzeerd',
  'inv.rec.pause': 'Pauzeren',
  'inv.rec.resume': 'Hervatten',
  'inv.rec.last': 'laatste factuur',
  'inv.rec.stop': 'Stoppen',
  'inv.rec.stopTitle': 'Terugkerende factuur stoppen?',
  'inv.rec.stopText': 'Er worden geen nieuwe facturen meer gemaakt. Facturen die al gemaakt zijn blijven bestaan.',
  'inv.rec.every.month': 'Elke maand',
  'inv.rec.every.quarter': 'Elk kwartaal',
  'inv.rec.every.year': 'Elk jaar',
};

export type MessageKey = keyof typeof nl;
